// Core Application Logic
        
        // Application State
        let state = {
            unit: 'mm',           // 'mm' or 'in'
            dimType: 'external',   // 'external' or 'internal'
            boxType: 'open',       // 'closed' or 'open'
            width: 150,           // in internal mm
            height: 50,           // in internal mm
            depth: 120,           // in internal mm
            bottomLift: 0,        // raised bottom offset from the outside lower edge, in mm
            thickness: 3.0,       // in mm
            fingerSize: 30.0,     // target finger width in mm
            foldPercent: 0,       // assembly slider position: 0 = assembled (left), 100 = flat layout (right)
            addNotches: false,    // corner notches relief
            notchDiameter: 0.6,   // notch diameter in mm
            addKerf: false,       // whether to apply kerf compensation
            kerf: 0.10,           // cutting width compensation in mm
            dividers: {
                enabled: false,
                widthSections: 0,
                depthSections: 0,
                widthPositions: [],
                depthPositions: [],
                addSideSlots: false,
                addBottomSlots: false,
                removedSegments: { width: {}, depth: {} },
                lockedCells: { width: {}, depth: {} },
                lockedSections: {},
                axisCellSizeLocks: { width: null, depth: null }
            },
            removableLid: {
                enabled: false,
                cornerRadius: 5,
                addHandle: true,
                handleWidth: 26.5566,
                open: false,
                openProgress: 0
            },
            slideLid: {
                enabled: false,
                open: false,
                openProgress: 0
            },
            doorLid: {
                enabled: false,
                handleSize: null,
                open: false,
                openProgress: 0
            },
            twoDoorLid: {
                enabled: false,
                handleSize: null,
                open: false,
                openProgress: 0
            },
            viewTheme: 'night'    // 'day' or 'night'; night is the default
        };

        // UI Elements
        const els = {
            appRoot: document.getElementById('box-designer-app'),
            unitCtrl: document.getElementById('unit-control'),
            dimTypeCtrl: document.getElementById('dim-type-control'),
            boxTypeCtrl: document.getElementById('box-type-control'),
            
            widthInput: document.getElementById('width-input'),
            widthNum: document.getElementById('width-num'),
            
            heightInput: document.getElementById('height-input'),
            heightNum: document.getElementById('height-num'),
            
            depthInput: document.getElementById('depth-input'),
            depthNum: document.getElementById('depth-num'),
            thicknessSelect: document.getElementById('thickness-select'),
            thicknessNum: document.getElementById('thickness-num'),
            thicknessUnit: document.getElementById('thickness-unit'),
            fingerSizeInput: document.getElementById('finger-size-input'),
            fingerSizeNum: document.getElementById('finger-size-num'),
            
            foldInput: document.getElementById('fold-input'),
            foldVal: document.getElementById('fold-val'),
            notchesCheckbox: document.getElementById('notches-checkbox'),
            notchDiameterContainer: document.getElementById('notch-diameter-container'),
            notchDiameterNum: document.getElementById('notch-diameter-num'),
            notchDiameterUnit: document.getElementById('notch-diameter-unit'),
            kerfCheckbox: document.getElementById('kerf-checkbox'),
            kerfInputContainer: document.getElementById('kerf-input-container'),
            kerfNum: document.getElementById('kerf-num'),
            kerfUnit: document.getElementById('kerf-unit'),
            sumWarning: document.getElementById('sum-warning'),
            
            btnSvg: document.getElementById('btn-svg'),
            btnDxf: document.getElementById('btn-dxf'),
            btnAbout: document.getElementById('btn-about'),
            viewThemeSwitch: document.getElementById('view-theme-switch'),
            viewThemeButtons: document.querySelectorAll('#view-theme-switch [data-view-theme]'),
            dividersButton: document.getElementById('btn-dividers'),
            dividersPopover: document.getElementById('divider-popover'),
            removeAllDividers: document.getElementById('remove-all-dividers'),
            dividerWidthCount: document.getElementById('divider-width-count'),
            dividerDepthCount: document.getElementById('divider-depth-count'),
            dividerCellWidth: document.getElementById('divider-cell-width'),
            dividerCellDepth: document.getElementById('divider-cell-depth'),
            dividerCellWidthLock: document.getElementById('divider-cell-width-lock'),
            dividerCellDepthLock: document.getElementById('divider-cell-depth-lock'),
            dividerSideSlots: document.getElementById('divider-side-slots'),
            dividerBottomSlots: document.getElementById('divider-bottom-slots'),
            dividerPositionList: document.getElementById('divider-position-list'),
            removableLidButton: document.getElementById('btn-removable-lid'),
            removableLidPopover: document.getElementById('removable-lid-popover'),
            removeRemovableLid: document.getElementById('remove-removable-lid'),
            lidCornerRadius: document.getElementById('lid-corner-radius'),
            lidRadiusUnit: document.getElementById('lid-radius-unit'),
            lidAddHandle: document.getElementById('lid-add-handle'),
            lidModeControl: document.getElementById('lid-mode-control'),
            lidModeButtons: document.querySelectorAll('#lid-mode-control [data-lid-mode]'),
            slideLidButton: document.getElementById('btn-slide-lid'),
            slideLidPopover: document.getElementById('slide-lid-popover'),
            removeSlideLid: document.getElementById('remove-slide-lid'),
            slideLidModeButtons: document.querySelectorAll('#slide-lid-mode-control [data-slide-lid-mode]'),
            doorLidButton: document.getElementById('btn-door-lid'),
            doorLidPopover: document.getElementById('door-lid-popover'),
            removeDoorLid: document.getElementById('remove-door-lid'),
            doorLidModeButtons: document.querySelectorAll('#door-lid-mode-control [data-door-lid-mode]'),
            twoDoorLidButton: document.getElementById('btn-two-door-lid'),
            twoDoorLidPopover: document.getElementById('two-door-lid-popover'),
            removeTwoDoorLid: document.getElementById('remove-two-door-lid'),
            twoDoorLidModeButtons: document.querySelectorAll('#two-door-lid-mode-control [data-two-door-lid-mode]'),
            cellHoverEditor: document.getElementById('cell-hover-editor'),
            cellEditorTitle: document.getElementById('cell-editor-title'),
            cellWidthValue: document.getElementById('cell-width-value'),
            cellDepthValue: document.getElementById('cell-depth-value'),
            cellLockButton: document.getElementById('cell-lock-button'),
            segmentHoverEditor: document.getElementById('segment-hover-editor'),
            segmentEditorLabel: document.getElementById('segment-editor-label'),
            segmentRemoveButton: document.getElementById('segment-remove-button'),
            handleSizeEditor: document.getElementById('handle-size-editor'),
            handleWidthValue: document.getElementById('handle-width-value'),
            handleWidthRange: document.getElementById('handle-width-range'),
            handleWidthUnit: document.getElementById('handle-width-unit'),
            lidHandleSizeEditor: document.getElementById('lid-handle-size-editor'),
            lidHandleSizeTitle: document.getElementById('lid-handle-size-title'),
            lidHandleSizeValue: document.getElementById('lid-handle-size-value'),
            lidHandleSizeRange: document.getElementById('lid-handle-size-range'),
            lidHandleSizeUnit: document.getElementById('lid-handle-size-unit'),
            bottomLiftEditor: document.getElementById('bottom-lift-editor'),
            bottomLiftValue: document.getElementById('bottom-lift-value'),
            bottomLiftUnit: document.getElementById('bottom-lift-unit'),
            viewportContainer: document.querySelector('#box-designer-app .viewport-container'),
            
            sumVolume: document.getElementById('sum-volume'),
            sumOuter: document.getElementById('sum-outer'),
            sumInner: document.getElementById('sum-inner'),
            canvasHolder: document.getElementById('canvas-holder')
        };

        // Unit conversion scale (mm per unit)
        const MM_PER_INCH = 25.4;

        // Manual-entry limits. Sliders intentionally keep their existing compact ranges.
        const MAX_DIMENSION_MM = 1500;
        const MAX_THICKNESS_MM = 50;

        // Formats a number to at most `dec` decimal places, trimming any trailing zeros
        // (and the decimal point itself if nothing is left after it). Used anywhere a value
        // like a preset thickness (e.g. 3.175 mm) needs to display its true precision instead
        // of being force-rounded to a fixed decimal count that could silently misrepresent it
        // (e.g. 3.175 -> "3.2" would look like a different, less precise value was chosen).
        function fmtTrim(v, dec) {
            const fixed = v.toFixed(dec);
            if (!fixed.includes('.')) return fixed;
            return fixed.replace(/0+$/, '').replace(/\.$/, '');
        }

        // Three.js Globals
        let scene, camera, renderer, controls, ambientLight, dirLight1, dirLight2, pointLight;
        let panelGroup; // Group containing the 6 panel meshes
        const panelMeshes = [];
        const dividerMeshes = [];
        const removableLidMeshes = [];
        const slideLidMeshes = [];
        const doorLidMeshes = [];
        const twoDoorLidMeshes = [];
        const cellVisuals = [];
        let dividerRaycaster = null;
        let dividerPointer = null;
        let activeDividerDrag = null;
        let activeLidDrag = null;
        let activeSlideLidDrag = null;
        let activeDoorLidDrag = null;
        let activeTwoDoorLidDrag = null;
        let activeBottomDrag = null;
        let selectedLidHandle = false;
        let selectedAdjustableLidHandle = null;
        let selectedBottom = false;
        let hoveredCell = null;
        let hoveredDividerSegment = null;
        let hoverEditorHideTimer = null;
        let canvasPointerStart = null;
        const undoHistory = [];
        const MAX_UNDO_STATES = 100;
        let undoRestoring = false;
        let lidAnimationFrame = 0;
        let slideLidAnimationFrame = 0;
        let doorLidAnimationFrame = 0;
        let twoDoorLidAnimationFrame = 0;

        function ensureRemovableLidState() {
            if (!state.removableLid) {
                state.removableLid = { enabled: false, cornerRadius: 5, addHandle: true, handleWidth: 26.5566, open: false, openProgress: 0 };
            }
            if (!Number.isFinite(state.removableLid.cornerRadius)) state.removableLid.cornerRadius = 5;
            if (typeof state.removableLid.addHandle !== 'boolean') state.removableLid.addHandle = true;
            if (!Number.isFinite(state.removableLid.handleWidth)) {
                state.removableLid.handleWidth = 26.5566 * Math.max(0.01, state.thickness / 3);
            }
            if (!Number.isFinite(state.removableLid.openProgress)) {
                state.removableLid.openProgress = state.removableLid.open ? 1 : 0;
            }
            state.removableLid.openProgress = Math.max(0, state.removableLid.openProgress);
            return state.removableLid;
        }

        function ensureSlideLidState() {
            if (!state.slideLid) state.slideLid = { enabled: false, open: false, openProgress: 0 };
            if (typeof state.slideLid.enabled !== 'boolean') state.slideLid.enabled = false;
            if (typeof state.slideLid.open !== 'boolean') state.slideLid.open = false;
            if (!Number.isFinite(state.slideLid.openProgress)) state.slideLid.openProgress = state.slideLid.open ? 1 : 0;
            state.slideLid.openProgress = Math.max(0, Math.min(3, state.slideLid.openProgress));
            return state.slideLid;
        }

        function ensureDoorLidState() {
            if (!state.doorLid) state.doorLid = { enabled: false, handleSize: null, open: false, openProgress: 0 };
            if (typeof state.doorLid.enabled !== 'boolean') state.doorLid.enabled = false;
            if (state.doorLid.handleSize !== null && !Number.isFinite(state.doorLid.handleSize)) state.doorLid.handleSize = null;
            if (typeof state.doorLid.open !== 'boolean') state.doorLid.open = false;
            if (!Number.isFinite(state.doorLid.openProgress)) state.doorLid.openProgress = state.doorLid.open ? 1 : 0;
            state.doorLid.openProgress = Math.max(0, Math.min(1, state.doorLid.openProgress));
            return state.doorLid;
        }

        function ensureTwoDoorLidState() {
            if (!state.twoDoorLid) state.twoDoorLid = { enabled: false, handleSize: null, open: false, openProgress: 0 };
            if (typeof state.twoDoorLid.enabled !== 'boolean') state.twoDoorLid.enabled = false;
            if (state.twoDoorLid.handleSize !== null && !Number.isFinite(state.twoDoorLid.handleSize)) state.twoDoorLid.handleSize = null;
            if (typeof state.twoDoorLid.open !== 'boolean') state.twoDoorLid.open = false;
            if (!Number.isFinite(state.twoDoorLid.openProgress)) state.twoDoorLid.openProgress = state.twoDoorLid.open ? 1 : 0;
            state.twoDoorLid.openProgress = Math.max(0, Math.min(1, state.twoDoorLid.openProgress));
            return state.twoDoorLid;
        }

        function deactivateOtherLids(keep) {
            const entries = [
                ['removable', ensureRemovableLidState(), 'lidAnimationFrame'],
                ['slide', ensureSlideLidState(), 'slideLidAnimationFrame'],
                ['door', ensureDoorLidState(), 'doorLidAnimationFrame'],
                ['two-door', ensureTwoDoorLidState(), 'twoDoorLidAnimationFrame']
            ];
            entries.forEach(([name, lid, frameName]) => {
                if (name === keep) return;
                if (frameName === 'lidAnimationFrame' && lidAnimationFrame) cancelAnimationFrame(lidAnimationFrame);
                if (frameName === 'slideLidAnimationFrame' && slideLidAnimationFrame) cancelAnimationFrame(slideLidAnimationFrame);
                if (frameName === 'doorLidAnimationFrame' && doorLidAnimationFrame) cancelAnimationFrame(doorLidAnimationFrame);
                if (frameName === 'twoDoorLidAnimationFrame' && twoDoorLidAnimationFrame) cancelAnimationFrame(twoDoorLidAnimationFrame);
                lid.enabled = false;
                lid.open = false;
                lid.openProgress = 0;
            });
            if (keep !== 'removable') lidAnimationFrame = 0;
            if (keep !== 'slide') slideLidAnimationFrame = 0;
            if (keep !== 'door') doorLidAnimationFrame = 0;
            if (keep !== 'two-door') twoDoorLidAnimationFrame = 0;
        }

        function cloneApplicationState(source = state) {
            return JSON.parse(JSON.stringify(source));
        }

        function pushUndoSnapshot() {
            if (undoRestoring) return;
            const snapshot = cloneApplicationState();
            const serialized = JSON.stringify(snapshot);
            const previous = undoHistory[undoHistory.length - 1];
            if (previous && JSON.stringify(previous) === serialized) return;
            undoHistory.push(snapshot);
            if (undoHistory.length > MAX_UNDO_STATES) undoHistory.shift();
        }

        function syncInterfaceFromState() {
            const factor = state.unit === 'in' ? 1 / MM_PER_INCH : 1;
            const decimals = state.unit === 'in' ? 3 : 2;
            const setValue = (slider, input, value) => {
                const display = fmtTrim(value * factor, decimals);
                slider.value = display;
                input.value = display;
            };
            setValue(els.widthInput, els.widthNum, state.width);
            setValue(els.heightInput, els.heightNum, state.height);
            setValue(els.depthInput, els.depthNum, state.depth);
            setValue(els.fingerSizeInput, els.fingerSizeNum, state.fingerSize / 2);
            els.thicknessNum.value = fmtTrim(state.thickness * factor, state.unit === 'in' ? 3 : 2);
            els.foldInput.value = String(state.foldPercent);
            els.foldVal.textContent = `${state.foldPercent}%`;
            els.notchesCheckbox.checked = state.addNotches;
            els.kerfCheckbox.checked = state.addKerf;
            els.notchDiameterNum.value = fmtTrim((state.notchDiameter / 2) * factor, decimals);
            els.kerfNum.value = fmtTrim(state.kerf * factor, decimals);
            els.notchDiameterContainer.style.display = state.addNotches ? 'flex' : 'none';
            els.kerfInputContainer.style.display = state.addKerf ? 'flex' : 'none';
            document.querySelectorAll('.unit-label').forEach(label => { label.textContent = state.unit; });
            const syncSegmentedControl = (control, dataName, value) => {
                control.querySelectorAll('.segment-btn').forEach(button => {
                    const active = button.dataset[dataName] === value;
                    button.classList.toggle('active', active);
                    button.setAttribute('aria-pressed', active ? 'true' : 'false');
                });
            };
            syncSegmentedControl(els.unitCtrl, 'unit', state.unit);
            syncSegmentedControl(els.dimTypeCtrl, 'type', state.dimType);
            syncSegmentedControl(els.boxTypeCtrl, 'type', state.boxType);
            updateThicknessDropdownOptions();
            applyViewTheme(state.viewTheme || 'night');
            renderRemovableLidControls();
            renderSlideLidControls();
            renderDoorLidControls();
            renderTwoDoorLidControls();
            renderAdjustableLidHandleControls();
            renderBottomLiftControls();
        }

        function undoLastOperation() {
            if (!undoHistory.length) return false;
            const current = JSON.stringify(state);
            let snapshot = null;
            while (undoHistory.length) {
                const candidate = undoHistory.pop();
                if (JSON.stringify(candidate) !== current) {
                    snapshot = candidate;
                    break;
                }
            }
            if (!snapshot) return false;
            if (lidAnimationFrame) cancelAnimationFrame(lidAnimationFrame);
            lidAnimationFrame = 0;
            if (slideLidAnimationFrame) cancelAnimationFrame(slideLidAnimationFrame);
            slideLidAnimationFrame = 0;
            if (doorLidAnimationFrame) cancelAnimationFrame(doorLidAnimationFrame);
            doorLidAnimationFrame = 0;
            if (twoDoorLidAnimationFrame) cancelAnimationFrame(twoDoorLidAnimationFrame);
            twoDoorLidAnimationFrame = 0;
            undoRestoring = true;
            state = cloneApplicationState(snapshot);
            hoveredCell = null;
            hoveredDividerSegment = null;
            activeDividerDrag = null;
            activeLidDrag = null;
            activeDoorLidDrag = null;
            activeTwoDoorLidDrag = null;
            activeSlideLidDrag = null;
            activeBottomDrag = null;
            selectedLidHandle = false;
            selectedAdjustableLidHandle = null;
            selectedBottom = false;
            els.cellHoverEditor.hidden = true;
            els.segmentHoverEditor.hidden = true;
            els.handleSizeEditor.hidden = true;
            els.lidHandleSizeEditor.hidden = true;
            els.bottomLiftEditor.hidden = true;
            syncInterfaceFromState();
            updateAll();
            undoRestoring = false;
            return true;
        }

        // Camera Auto-fit Globals
        let targetDistance = 500;
        let targetControlsTarget = null;
        let isInteracting = false;
        let cameraNeedsFit = false;
        let boxDesignerStarted = false;
        let threeLoadAttempts = 0;

        // Initialize only after Shopify, Three.js and OrbitControls are ready.
        // This also works when Shopify delays or re-inserts the page template.
        function startBoxDesigner() {
            if (boxDesignerStarted) return;

            if (!window.THREE || typeof window.THREE.OrbitControls !== 'function') {
                threeLoadAttempts++;

                if (threeLoadAttempts < 200) {
                    window.setTimeout(startBoxDesigner, 50);
                    return;
                }

                console.error('Box Designer: Three.js or OrbitControls failed to load.');
                if (els.canvasHolder) {
                    els.canvasHolder.innerHTML = `
                        <div style="height:100%;display:flex;align-items:center;justify-content:center;padding:30px;text-align:center;color:#ff9b9b;font:600 14px Inter,Arial,sans-serif;">
                            The 3D preview could not be loaded. Please refresh the page or check whether external scripts are blocked.
                        </div>`;
                }
                return;
            }

            boxDesignerStarted = true;

            try {
                initThree();
                setupUI();
                updateAll();

                window.addEventListener('resize', onWindowResize);
                window.setTimeout(onWindowResize, 150);

                const mobileSummaryToggle = document.getElementById('mobile-summary-toggle');
                const mobileSummaryCard = document.getElementById('box-summary-card');
                if (mobileSummaryToggle && mobileSummaryCard) {
                    mobileSummaryToggle.addEventListener('click', () => {
                        const shouldOpen = !mobileSummaryCard.classList.contains('is-open');
                        mobileSummaryCard.classList.toggle('is-open', shouldOpen);
                        mobileSummaryToggle.setAttribute('aria-expanded', String(shouldOpen));
                    });

                    document.addEventListener('pointerdown', (event) => {
                        if (!mobileSummaryCard.classList.contains('is-open')) return;
                        if (mobileSummaryCard.contains(event.target) || mobileSummaryToggle.contains(event.target)) return;
                        mobileSummaryCard.classList.remove('is-open');
                        mobileSummaryToggle.setAttribute('aria-expanded', 'false');
                    });
                }

                if ('ResizeObserver' in window) {
                    let resizeFrame = 0;
                    const canvasResizeObserver = new ResizeObserver(() => {
                        cancelAnimationFrame(resizeFrame);
                        resizeFrame = requestAnimationFrame(onWindowResize);
                    });
                    canvasResizeObserver.observe(els.canvasHolder);
                }
            } catch (error) {
                boxDesignerStarted = false;
                console.error('Box Designer initialization failed:', error);

                if (els.canvasHolder) {
                    els.canvasHolder.innerHTML = `
                        <div style="height:100%;display:flex;align-items:center;justify-content:center;padding:30px;text-align:center;color:#ff9b9b;font:600 14px Inter,Arial,sans-serif;">
                            The 3D preview could not be initialized. Open the browser console for details.
                        </div>`;
                }
            }
        }

        // The optimized Shopify version loads this file with `defer`. During a deferred
        // script, document.readyState can already be `interactive`, even though the rest of
        // this JavaScript file is still being evaluated. Starting synchronously here would
        // run updateBox3D() before the materials declared later in this file are initialized.
        // Queueing the start guarantees that the entire file has finished evaluating first.
        function queueBoxDesignerStart() {
            if (typeof window.queueMicrotask === 'function') {
                window.queueMicrotask(startBoxDesigner);
            } else {
                window.setTimeout(startBoxDesigner, 0);
            }
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', queueBoxDesignerStart, { once: true });
        } else {
            queueBoxDesignerStart();
        }

        document.addEventListener('shopify:section:load', queueBoxDesignerStart);

        // ==========================================
        // 1. GEOMETRY ENGINE
        // ==========================================

        // ==========================================
        // 1. GEOMETRY ENGINE
        // ==========================================

        function fingerLayout(L, f, T) {
            let n = Math.floor(L / f);
            if (n % 2 === 0) n--;
            if (n < 1) return null;
            let m = Math.round(((L - n * f) / 2) * 1000) / 1000;
            // Hybrid min margin that is roughly a quarter of T and depends on finger size f
            const minCorner = Math.min(T / 4, f / 4);
            if (m > 0 && m < minCorner) {
                n -= 2;
                if (n < 1) return null;
                m = Math.round(((L - n * f) / 2) * 1000) / 1000;
            }
            return { n, m };
        }

        function getAbsoluteMinDimension(T) {
            const f_abs_min = 3.0; // absolute minimum finger width in mm
            for (let L = 10; L <= 500; L++) {
                const lay = fingerLayout(L, f_abs_min, T);
                if (lay && lay.n >= 3) {
                    return L;
                }
            }
            return 20; // fallback
        }

        function fingerRange(W, H, D, T) {
            const min = 3.0; // absolute minimum finger size in mm
            let max = Math.min(W, H, D) / 2;
            
            const isValid = f => {
                const layW = fingerLayout(W, f, T);
                const layH = fingerLayout(H, f, T);
                const layD = fingerLayout(D, f, T);
                return layW && layW.n >= 3 && layH && layH.n >= 3 && layD && layD.n >= 3;
            };
            
            if (!isValid(min)) {
                return { min, max: min };
            }
            
            let lo = min, hi = max;
            for (let i = 0; i < 50; i++) {
                const mid = (lo + hi) / 2;
                if (isValid(mid)) lo = mid; else hi = mid;
            }
            max = lo;
            
            return { min, max };
        }

        function clampFinger(W, H, D, T, f) {
            const { min, max } = fingerRange(W, H, D, T);
            return (f >= min && f <= max) ? f : (min + max) / 2;
        }

        function protrusionIntervals(L, f, T, type) {
            const lay = fingerLayout(L, f, T);
            if (!lay) return type === "B" ? [[0, L]] : [];
            const { n, m } = lay;
            if (n === 1) return type === "B" ? [[0, L]] : [];
            const iv = [];
            if (type === "A") {
                for (let i = 1; i < n; i += 2) iv.push([m + i * f, m + (i + 1) * f]);
            } else {
                iv.push([0, m + f]);
                for (let i = 2; i < n - 1; i += 2) iv.push([m + i * f, m + (i + 1) * f]);
                iv.push([m + (n - 1) * f, L]);
            }
            return iv;
        }

        function buildPanel(w, h, T, f, edges, forceNoNotches = false, returnCommands = false, edgeProfiles = null) {
            const E = [
                { S: [0, 0], d: [1, 0],  L: w, nrm: [0, -1] },  // низ
                { S: [w, 0], d: [0, 1],  L: h, nrm: [1, 0] },   // право
                { S: [w, h], d: [-1, 0], L: w, nrm: [0, 1] },   // верх
                { S: [0, h], d: [0, -1], L: h, nrm: [-1, 0] },  // ліво
            ];
            const ivs = E.map((e, i) => {
                if (edges[i] === "flat") return null;
                const profile = edgeProfiles && edgeProfiles[i];
                const profileLength = profile && Number.isFinite(profile.length) ? profile.length : e.L;
                const profileOffset = profile && Number.isFinite(profile.offset) ? profile.offset : 0;
                return protrusionIntervals(profileLength, f, T, edges[i])
                    .map(([start, end]) => [
                        Math.max(0, start - profileOffset),
                        Math.min(e.L, end - profileOffset)
                    ])
                    .filter(([start, end]) => end > start + 1e-7);
            });
            const touchesStart = iv => !!iv && iv.length > 0 && iv[0][0] < 1e-9;
            const touchesEnd = (iv, L) => !!iv && iv.length > 0 && iv[iv.length - 1][1] > L - 1e-9;
            const pts = [];
            const cmds = [];
            
            const push = (x, y) => {
                if (returnCommands) {
                    const lastCmd = cmds[cmds.length - 1];
                    // Same de-dup guard as the pts-mode branch below: skip a point that exactly
                    // repeats the previous one. Without this, corner cases where two edges'
                    // notch geometry coincide (e.g. adjoining 'A' side panels) emit zero-length
                    // L segments into the exported DXF/SVG path - harmless visually, but some
                    // CAM/offsetting software chokes on zero-length segments.
                    if (lastCmd && lastCmd.type !== 'A' && Math.abs(lastCmd.x - x) < 1e-9 && Math.abs(lastCmd.y - y) < 1e-9) return;
                    cmds.push({ type: cmds.length === 0 ? 'M' : 'L', x, y });
                } else {
                    const last = pts[pts.length - 1];
                    if (last && Math.abs(last[0] - x) < 1e-9 && Math.abs(last[1] - y) < 1e-9) return;
                    pts.push([x, y]);
                }
            };
            
            const prevFillsMyStart = E.map((e, i) => {
                const prev = (i + 3) % 4;
                return edges[i] !== "flat" && edges[prev] !== "flat" &&
                    touchesEnd(ivs[prev], E[prev].L) && touchesStart(ivs[i]);
            });
            E.forEach((e, i) => {
                const type = edges[i];
                const iv = ivs[i];
                if (type === "flat") { push(e.S[0], e.S[1]); return; }
                const nextType = edges[(i + 1) % 4];
                const nextIv = ivs[(i + 1) % 4];
                const fillReflex = nextType !== "flat" && touchesEnd(iv, e.L) && touchesStart(nextIv);
                const pushCorner = () => {
                    if (fillReflex) {
                        const nrmNext = E[(i + 1) % 4].nrm;
                        push(e.S[0] + e.d[0] * e.L + e.nrm[0] * T + nrmNext[0] * T,
                             e.S[1] + e.d[1] * e.L + e.nrm[1] * T + nrmNext[1] * T);
                    } else {
                        push(e.S[0] + e.d[0] * e.L, e.S[1] + e.d[1] * e.L);
                    }
                };
 
                const R = state.notchDiameter / 2; // custom diameter notches
                const hasNotches = !forceNoNotches && state.addNotches && type === "B";
 
                if (!prevFillsMyStart[i] && (iv.length === 0 || iv[0][0] > 1e-9)) push(e.S[0], e.S[1]);

                // "Reached the end of this edge" is a genuinely two-part condition: we must be on
                // the last interval of the array AND that interval's right end (b) must actually
                // reach the edge's full length e.L. An edge can end with a *gap* (interval doesn't
                // reach e.L) rather than a tab - in that case the closing edge-end point still needs
                // to be pushed as a plain point, not skipped via pushCorner(). Collapsing this to a
                // pure array-index check (as we mistakenly did before) drops that trailing point.
                const lastIvIdx = iv.length - 1;
                const lastIvReachesEdgeEnd = iv.length > 0 && iv[lastIvIdx][1] > e.L - 1e-9;

                iv.forEach(([a, b], idx) => {
                    const isLastIv = idx === lastIvIdx && lastIvReachesEdgeEnd;
                    const isLeftCorner = a < R;
                    const isRightCorner = b > e.L - R;

                    // 1. Left wall transition / Left notch (centered at T/2, protruding into slot via -d)
                    if (!isLeftCorner) {
                        push(e.S[0] + e.d[0] * a, e.S[1] + e.d[1] * a);
                        
                        if (hasNotches) {
                            if (returnCommands) {
                                const phi = Math.atan2(e.d[1], e.d[0]);
                                const cx = e.S[0] + e.d[0]*a + e.nrm[0]*(T/2);
                                const cy = e.S[1] + e.d[1]*a + e.nrm[1]*(T/2);
                                const sx = e.S[0] + e.d[0]*a + e.nrm[0]*(T/2 - R);
                                const sy = e.S[1] + e.d[1]*a + e.nrm[1]*(T/2 - R);
                                const ex = e.S[0] + e.d[0]*a + e.nrm[0]*(T/2 + R);
                                const ey = e.S[1] + e.d[1]*a + e.nrm[1]*(T/2 + R);
                                
                                push(sx, sy);
                                cmds.push({
                                    type: 'A',
                                    cx, cy, R,
                                    startAngle: phi + Math.PI / 2,
                                    endAngle: phi + Math.PI * 1.5,
                                    sweep: 0,
                                    bulge: 1.0,
                                    x: ex, y: ey
                                });
                            } else {
                                // Left notch: goes from T/2-R to T/2+R, bulging in -d direction
                                for (let k = 0; k <= 24; k++) {
                                    let theta = -Math.PI / 2 + k * Math.PI / 24;
                                    let px = -R * Math.cos(theta);
                                    let py = R * Math.sin(theta);
                                    push(e.S[0] + e.d[0] * (a + px) + e.nrm[0] * (T / 2 + py),
                                         e.S[1] + e.d[1] * (a + px) + e.nrm[1] * (T / 2 + py));
                                }
                            }
                        }
                    }
                    
                    // Top corners of the tab
                    push(e.S[0] + e.d[0] * a + e.nrm[0] * T, e.S[1] + e.d[1] * a + e.nrm[1] * T);
                    push(e.S[0] + e.d[0] * b + e.nrm[0] * T, e.S[1] + e.d[1] * b + e.nrm[1] * T);

                    // 2. Right wall transition / Right notch (centered at T/2, protruding into slot via +d)
                    // NOTE: previously this branch and the "no notches" branch below each independently
                    // decided whether to emit the plain edge-end point vs. the reflex-corner point,
                    // using different conditions (isRightCorner vs idx===lastIvIdx && float compare).
                    // That mismatch could double-emit or skip the closing vertex of a side. isLastIv is
                    // now the single, correctly-defined decision used consistently by both branches.
                    if (hasNotches && !isRightCorner) {
                        if (returnCommands) {
                            const phi = Math.atan2(e.d[1], e.d[0]);
                            const cx = e.S[0] + e.d[0]*b + e.nrm[0]*(T/2);
                            const cy = e.S[1] + e.d[1]*b + e.nrm[1]*(T/2);
                            const sx = e.S[0] + e.d[0]*b + e.nrm[0]*(T/2 + R);
                            const sy = e.S[1] + e.d[1]*b + e.nrm[1]*(T/2 + R);
                            const ex = e.S[0] + e.d[0]*b + e.nrm[0]*(T/2 - R);
                            const ey = e.S[1] + e.d[1]*b + e.nrm[1]*(T/2 - R);
                            
                            push(sx, sy);
                            cmds.push({
                                type: 'A',
                                cx, cy, R,
                                startAngle: phi - Math.PI / 2,
                                endAngle: phi + Math.PI / 2,
                                sweep: 0,
                                bulge: 1.0,
                                x: ex, y: ey
                            });
                            push(e.S[0] + e.d[0] * b, e.S[1] + e.d[1] * b);
                        } else {
                            // Right notch: goes from T/2+R to T/2-R, bulging in +d direction
                            for (let k = 0; k <= 24; k++) {
                                let theta = Math.PI / 2 - k * Math.PI / 24;
                                let px = R * Math.cos(theta);
                                let py = R * Math.sin(theta);
                                push(e.S[0] + e.d[0] * (b + px) + e.nrm[0] * (T / 2 + py),
                                     e.S[1] + e.d[1] * (b + px) + e.nrm[1] * (T / 2 + py));
                            }
                            push(e.S[0] + e.d[0] * b, e.S[1] + e.d[1] * b);
                        }
                        // If this was also the edge's final interval, still close the edge/corner properly.
                        if (isLastIv) pushCorner();
                    } else {
                        if (isLastIv) {
                            pushCorner();
                        } else {
                            push(e.S[0] + e.d[0] * b, e.S[1] + e.d[1] * b);
                        }
                    }
                });
                if (iv.length === 0 || !lastIvReachesEdgeEnd) pushCorner();
            });
            
            // Closing the contour is now unconditional and structural rather than a float-distance
            // guess: the loop above always ends having visited all 4 edges exactly once via
            // pushCorner()/flat-push, so cmds[0]/pts[0] IS the true start vertex. We simply append
            // (or drop) a single closing vertex based on that fact, not on re-measuring coordinates.
            if (returnCommands) {
                if (cmds.length > 1) {
                    const first = cmds[0];
                    const last = cmds[cmds.length - 1];
                    if (Math.hypot(last.x - first.x, last.y - first.y) > 1e-4) {
                        cmds.push({ type: 'L', x: first.x, y: first.y });
                    }
                }
                return simplifyCollinearCmds(cmds);
            } else {
                if (pts.length > 1) {
                    const first = pts[0];
                    const last = pts[pts.length - 1];
                    // Only the push() de-dup guard (line ~1063) may have already produced an
                    // exact duplicate; drop it in that one specific case so simplifyCollinear
                    // sees a clean, non-duplicated ring.
                    if (Math.abs(first[0] - last[0]) < 1e-9 && Math.abs(first[1] - last[1]) < 1e-9) pts.pop();
                }
                return simplifyCollinear(pts);
            }
        }

        // Same purpose as simplifyCollinear(), but operating on the {type,x,y,...} command list
        // used by DXF/SVG export instead of raw [x,y] point pairs. A straight ('L') vertex whose
        // neighbors are both plain (non-'A') points and which lies exactly on the line between
        // them contributes nothing to the shape and is dropped. Points that are themselves an
        // 'A' (arc), or are immediately adjacent to one, are never touched - removing them would
        // corrupt the arc's start/end/bulge geometry rather than just simplifying a straight run.
        function simplifyCollinearCmds(cmds) {
            let working = [...cmds];
            let wasClosed = false;
            
            // Remove all trailing duplicate closing points if present
            while (working.length > 1) {
                const first = working[0];
                const last = working[working.length - 1];
                // A closing arc may legitimately end at the first point. Keep it: removing
                // that command replaces the rounded corner with a straight closing chord.
                if (last.type !== 'A' && Math.hypot(last.x - first.x, last.y - first.y) < 1e-4) {
                    working.pop();
                    wasClosed = true;
                } else {
                    break;
                }
            }
            
            const N = working.length;
            if (N < 3) return cmds;
            
            const out = [];
            for (let i = 0; i < N; i++) {
                const prev = working[(i - 1 + N) % N];
                const curr = working[i];
                const next = working[(i + 1) % N];
                
                // Do not simplify arc commands or their neighbors
                if (curr.type === 'A' || prev.type === 'A' || next.type === 'A') {
                    out.push(curr);
                    continue;
                }
                
                // Calculate cross product
                const cross = (curr.x - prev.x) * (next.y - curr.y) - (curr.y - prev.y) * (next.x - curr.x);
                if (Math.abs(cross) > 1e-9) {
                    out.push(curr);
                }
            }
            
            // If the output collapsed, return the original
            if (out.length < 3) return cmds;
            
            // Force the first command to be 'M' (Move)
            out[0] = { ...out[0], type: 'M' };
            
            // Re-close the path if it was closed
            if (wasClosed) {
                const first = out[0];
                out.push({ type: 'L', x: first.x, y: first.y });
            }
            
            return out;
        }

        function simplifyCollinear(pts) {
            const out = [];
            const N = pts.length;
            for (let i = 0; i < N; i++) {
                const p = pts[(i - 1 + N) % N], c = pts[i], q = pts[(i + 1) % N];
                const cross = (c[0] - p[0]) * (q[1] - c[1]) - (c[1] - p[1]) * (q[0] - c[0]);
                if (Math.abs(cross) > 1e-9) out.push(c);
            }
            return out;
        }

        function generatePanelPolygon(w, h, t, edgeTypes, targetFingerWidth, forceNoNotches = false) {
            let pts = buildPanel(w, h, t, targetFingerWidth, edgeTypes, forceNoNotches);
            return pts.map(p => ({ x: p[0], y: p[1] }));
        }

        function getLidInternalHeightInset(t, isOpen = state.boxType === 'open') {
            if (!isOpen) return 0;
            if (state.slideLid && state.slideLid.enabled) return 2 * t;
            if ((state.doorLid && state.doorLid.enabled) ||
                (state.twoDoorLid && state.twoDoorLid.enabled) ||
                (state.removableLid && state.removableLid.enabled)) return t;
            return 0;
        }

        function getResolvedBoxDimensions() {
            const t = state.thickness;
            const isOpen = state.boxType === 'open';
            const hWall = isOpen ? t : 2 * t;
            const lidHeightInset = getLidInternalHeightInset(t, isOpen);
            const bottomLift = Math.max(0, Number.isFinite(state.bottomLift) ? state.bottomLift : 0);
            let W_ext, H_ext, D_ext, W_int, H_int, D_int, H_usable;

            if (state.dimType === 'external') {
                W_ext = state.width;
                H_ext = state.height;
                D_ext = state.depth;
                W_int = Math.max(0, W_ext - 2 * t);
                H_int = Math.max(0, H_ext - hWall);
                H_usable = Math.max(0, H_int - lidHeightInset - bottomLift);
                D_int = Math.max(0, D_ext - 2 * t);
            } else {
                W_int = state.width;
                H_usable = state.height;
                H_int = H_usable + lidHeightInset + bottomLift;
                D_int = state.depth;
                W_ext = W_int + 2 * t;
                H_ext = H_int + hWall;
                D_ext = D_int + 2 * t;
            }

            return { t, isOpen, W_ext, H_ext, D_ext, W_int, H_int, H_usable, D_int, lidHeightInset, bottomLift };
        }

        function getMaxBottomLift(dims = getResolvedBoxDimensions()) {
            if (state.dimType === 'external') {
                return Math.max(0, dims.H_int - dims.lidHeightInset - dims.t);
            }
            const hWall = dims.isOpen ? dims.t : 2 * dims.t;
            return Math.max(0, MAX_DIMENSION_MM - state.height - dims.lidHeightInset - hWall);
        }

        function getDividerPanelHeight(dims = getResolvedBoxDimensions()) {
            return Math.max(dims.t, dims.H_int - dims.lidHeightInset - dims.bottomLift);
        }

        function getMinimumDividerCellSize(t = state.thickness) {
            return state.dividers && state.dividers.addBottomSlots ? 2 * t : t;
        }

        function getRemovableLidOpenLift(dims = getResolvedBoxDimensions()) {
            return 2 * Math.max(40, dims.H_ext * 0.75, 12 * dims.t);
        }

        function ensureRemovableLidHandleFits() {
            const lid = ensureRemovableLidState();
            if (!lid.enabled || !lid.addHandle) return;
            const dims = getResolvedBoxDimensions();
            const handle = getLidHandleGeometry(dims.t);
            lid.handleWidth = handle.width;
        }

        function getMaxDividerCount(length, t) {
            if (!(length > 0) || !(t > 0)) return 0;
            const minCell = getMinimumDividerCellSize(t);
            return Math.max(0, Math.floor((length - minCell) / (t + minCell) + 1e-9));
        }

        function getDoorWidthDividerClearanceRanges(length, t) {
            const doorLid = ensureDoorLidState();
            const twoDoorLid = ensureTwoDoorLidState();
            if (state.boxType !== 'open' || (!doorLid.enabled && !twoDoorLid.enabled)) return [];
            const g = getDoorLidGeometry(length + 2 * t, Math.max(12 * t, 2 * t), t);
            const rotatingReach = g.bodyRight - g.pivotX;
            const halfWidth = rotatingReach + 0.6 * t;
            const hinges = twoDoorLid.enabled
                ? [g.hingeOuterRadius, length - g.hingeOuterRadius]
                : [length - g.hingeOuterRadius];
            return hinges.map(center => ({
                start: Math.max(0, center - halfWidth),
                end: Math.min(length, center + halfWidth)
            }));
        }

        function getDoorWidthDividerClearanceStart(length, t) {
            const ranges = getDoorWidthDividerClearanceRanges(length, t);
            return ranges.length ? ranges[ranges.length - 1].start : length;
        }

        function getMaxDividerCountForAxis(axis, length, t) {
            const physicalMaximum = getMaxDividerCount(length, t);
            for (let count = physicalMaximum; count > 0; count--) {
                const positions = evenDividerPositions(count, length, t);
                if (isDividerLayoutSafeForAxis(axis, positions, length, t)) return count;
            }
            return 0;
        }

        function isDividerLayoutSafeForAxis(axis, list, length, t) {
            if (axis !== 'width' || !list.length) return true;
            const ranges = getDoorWidthDividerClearanceRanges(length, t);
            return normalizeDividerPositions(list).every(position => {
                const center = position * length;
                return ranges.every(range => center + t / 2 <= range.start + 1e-7 || center - t / 2 >= range.end - 1e-7);
            });
        }

        function ensureCurrentDividerLayoutFits(axis) {
            const dims = getResolvedBoxDimensions();
            const t = dims.t;
            const minCell = getMinimumDividerCellSize(t);
            const positions = normalizeDividerPositions(
                axis === 'width' ? state.dividers.widthPositions : state.dividers.depthPositions
            );
            if (!positions.length) return;
            const currentLength = axis === 'width' ? dims.W_int : dims.D_int;
            let requiredLength = currentLength;
            requiredLength = Math.max(requiredLength, (minCell + t / 2) / Math.max(positions[0], 1e-9));
            for (let i = 1; i < positions.length; i++) {
                requiredLength = Math.max(requiredLength, (minCell + t) / Math.max(positions[i] - positions[i - 1], 1e-9));
            }
            requiredLength = Math.max(
                requiredLength,
                (minCell + t / 2) / Math.max(1 - positions[positions.length - 1], 1e-9)
            );
            if (requiredLength > currentLength + 1e-7) setInternalAxisLength(axis, requiredLength, t);
        }

        function evenDividerPositions(count, length, t) {
            const total = Math.max(0, Math.min(getMaxDividerCount(length, t), Math.round(count) || 0));
            if (!total) return [];
            const cell = (length - total * t) / (total + 1);
            return Array.from({ length: total }, (_, i) => (cell + t / 2 + i * (cell + t)) / length);
        }

        function normalizeDividerPositions(list) {
            return [...list]
                .map(v => Math.max(0, Math.min(1, Number(v) || 0.5)))
                .sort((a, b) => a - b);
        }

        function isDividerLayoutValid(list, length, t) {
            if (!list.length) return true;
            const minCell = getMinimumDividerCellSize(t);
            const centers = normalizeDividerPositions(list).map(pos => pos * length);
            if (centers[0] - t / 2 < minCell - 1e-7) return false;
            for (let i = 1; i < centers.length; i++) {
                if (centers[i] - centers[i - 1] - t < minCell - 1e-7) return false;
            }
            return length - centers[centers.length - 1] - t / 2 >= minCell - 1e-7;
        }

        function clampDraggedDividerPosition(list, index, next, length, t, axis = null) {
            const minCell = getMinimumDividerCellSize(t);
            const minCenter = index > 0 ? list[index - 1] * length + t + minCell : minCell + t / 2;
            let maxCenter = index < list.length - 1 ? list[index + 1] * length - t - minCell : length - minCell - t / 2;
            let center = Math.max(minCenter, Math.min(maxCenter, next * length));
            if (axis === 'width') {
                getDoorWidthDividerClearanceRanges(length, t).forEach(range => {
                    const before = range.start - t / 2;
                    const after = range.end + t / 2;
                    if (center > before && center < after) {
                        center = Math.abs(center - before) <= Math.abs(after - center) ? before : after;
                        center = Math.max(minCenter, Math.min(maxCenter, center));
                    }
                });
            }
            return center / length;
        }

        function ensureLockedCellStore() {
            if (!state.dividers.lockedCells) state.dividers.lockedCells = { width: {}, depth: {} };
            if (!state.dividers.lockedCells.width) state.dividers.lockedCells.width = {};
            if (!state.dividers.lockedCells.depth) state.dividers.lockedCells.depth = {};
            return state.dividers.lockedCells;
        }

        function getAxisLocks(axis) {
            return ensureLockedCellStore()[axis];
        }

        function ensureLockedSectionStore() {
            if (!state.dividers.lockedSections) state.dividers.lockedSections = {};
            return state.dividers.lockedSections;
        }

        function lockedSectionKey(widthCellIndex, depthCellIndex) {
            return `${widthCellIndex}:${depthCellIndex}`;
        }

        function ensureAxisCellSizeLocks() {
            if (!state.dividers.axisCellSizeLocks) {
                state.dividers.axisCellSizeLocks = { width: null, depth: null };
            }
            return state.dividers.axisCellSizeLocks;
        }

        function getAxisCellSizeLock(axis) {
            const value = Number(ensureAxisCellSizeLocks()[axis]);
            return Number.isFinite(value) && value > 0 ? value : null;
        }

        function rebuildSpecificAxisLocks() {
            const sections = ensureLockedSectionStore();
            state.dividers.lockedCells = { width: {}, depth: {} };
            Object.values(sections).forEach(section => {
                if (!section) return;
                const widthIndex = parseInt(section.widthCellIndex, 10);
                const depthIndex = parseInt(section.depthCellIndex, 10);
                if (Number.isInteger(widthIndex)) state.dividers.lockedCells.width[widthIndex] = Number(section.width);
                if (Number.isInteger(depthIndex)) state.dividers.lockedCells.depth[depthIndex] = Number(section.depth);
            });
        }

        function pruneLockedSections(widthCellCount, depthCellCount) {
            const sections = ensureLockedSectionStore();
            Object.entries(sections).forEach(([key, section]) => {
                if (!section || section.widthCellIndex < 0 || section.widthCellIndex >= widthCellCount ||
                    section.depthCellIndex < 0 || section.depthCellIndex >= depthCellCount) {
                    delete sections[key];
                }
            });
            rebuildSpecificAxisLocks();
        }

        function getMinimumDividerCountForLockedSections(axis) {
            const property = axis === 'width' ? 'widthCellIndex' : 'depthCellIndex';
            return Object.values(ensureLockedSectionStore()).reduce((minimum, section) => (
                section ? Math.max(minimum, Math.max(0, parseInt(section[property], 10) || 0)) : minimum
            ), 0);
        }

        function setInternalAxisLength(axis, internalLength, t = state.thickness) {
            const property = axis === 'width' ? 'width' : 'depth';
            state[property] = state.dimType === 'external' ? internalLength + 2 * t : internalLength;
        }

        function applyLockedAxisLayout(axis, positions, length, t) {
            const locks = getAxisLocks(axis);
            const globalCellSize = getAxisCellSizeLock(axis);
            const minCell = getMinimumDividerCellSize(t);
            const cellCount = positions.length + 1;
            Object.keys(locks).forEach(key => {
                const index = parseInt(key, 10);
                if (!Number.isInteger(index) || index < 0 || index >= cellCount) delete locks[key];
                else locks[key] = Math.max(minCell, Number(locks[key]) || minCell);
            });

            const lockedIndexes = Object.keys(locks).map(Number).sort((a, b) => a - b);
            if (!lockedIndexes.length && globalCellSize === null) return { positions, length };

            const dividerSpace = positions.length * t;
            const lockedSet = new Set(lockedIndexes);
            const unlockedIndexes = Array.from({ length: cellCount }, (_, index) => index)
                .filter(index => !lockedSet.has(index));
            const lockedTotal = lockedIndexes.reduce((sum, index) => sum + locks[index], 0);
            const unlockedMinimum = globalCellSize === null ? minCell : Math.max(minCell, globalCellSize);
            const requiredLength = lockedTotal + unlockedIndexes.length * unlockedMinimum + dividerSpace;
            let targetLength = globalCellSize === null && unlockedIndexes.length
                ? Math.max(length, requiredLength)
                : requiredLength;
            targetLength = Math.max(minCell, targetLength);
            if (Math.abs(targetLength - length) > 1e-7) {
                setInternalAxisLength(axis, targetLength, t);
                length = targetLength;
            }

            const currentSizes = getDividerCellSizes(positions, length, t);
            const totalClear = length - dividerSpace;
            const remainingForUnlocked = Math.max(0, totalClear - lockedTotal);
            const baseUnlocked = unlockedIndexes.length * unlockedMinimum;
            const extra = Math.max(0, remainingForUnlocked - baseUnlocked);
            const weights = unlockedIndexes.map(index => Math.max(0.001, (currentSizes[index] || minCell) - minCell));
            const weightTotal = weights.reduce((sum, value) => sum + value, 0) || 1;
            const nextSizes = Array.from({ length: cellCount }, (_, index) => (
                lockedSet.has(index) ? locks[index] : unlockedMinimum
            ));
            if (globalCellSize === null) {
                unlockedIndexes.forEach((index, weightIndex) => {
                    nextSizes[index] += extra * weights[weightIndex] / weightTotal;
                });
            }
            return { positions: positionsFromCellSizes(nextSizes, length, t), length };
        }

        function ensureAxisLengthForLocks(axis, dividerCount, length, t) {
            const locks = getAxisLocks(axis);
            const globalCellSize = getAxisCellSizeLock(axis);
            const minCell = getMinimumDividerCellSize(t);
            const cellCount = dividerCount + 1;
            const validLockedIndexes = Object.keys(locks)
                .map(Number)
                .filter(index => Number.isInteger(index) && index >= 0 && index < cellCount);
            if (!validLockedIndexes.length && globalCellSize === null) return length;
            const lockedTotal = validLockedIndexes.reduce((sum, index) => (
                sum + Math.max(minCell, Number(locks[index]) || minCell)
            ), 0);
            const unlockedCount = cellCount - validLockedIndexes.length;
            const unlockedSize = globalCellSize === null ? minCell : Math.max(minCell, globalCellSize);
            const requiredLength = lockedTotal + unlockedCount * unlockedSize + dividerCount * t;
            if (globalCellSize !== null || length < requiredLength) {
                setInternalAxisLength(axis, requiredLength, t);
                return requiredLength;
            }
            return length;
        }

        function syncDividerPositionsFromCounts(resetEvenly = false) {
            const d = state.dividers;
            const previousWidthCount = d.widthPositions.length;
            const previousDepthCount = d.depthPositions.length;
            let { W_int, D_int, t } = getResolvedBoxDimensions();
            const requestedWidthCount = Math.max(
                getMinimumDividerCountForLockedSections('width'),
                Math.max(0, parseInt(d.widthSections, 10) || 0)
            );
            const requestedDepthCount = Math.max(
                getMinimumDividerCountForLockedSections('depth'),
                Math.max(0, parseInt(d.depthSections, 10) || 0)
            );
            pruneLockedSections(requestedWidthCount + 1, requestedDepthCount + 1);
            W_int = ensureAxisLengthForLocks('width', requestedWidthCount, W_int, t);
            D_int = ensureAxisLengthForLocks('depth', requestedDepthCount, getResolvedBoxDimensions().D_int, t);
            const widthCount = Math.max(0, Math.min(getMaxDividerCountForAxis('width', W_int, t), requestedWidthCount));
            const depthCount = Math.max(0, Math.min(getMaxDividerCount(D_int, t), requestedDepthCount));
            d.widthSections = widthCount;
            d.depthSections = depthCount;

            const syncList = (axis, list, target, length) => {
                const normalized = normalizeDividerPositions(list);
                if (resetEvenly || normalized.length !== target || !isDividerLayoutValid(normalized, length, t)
                    || !isDividerLayoutSafeForAxis(axis, normalized, length, t)) {
                    return evenDividerPositions(target, length, t);
                }
                return normalized;
            };

            d.widthPositions = syncList('width', d.widthPositions, widthCount, W_int);
            d.depthPositions = syncList('depth', d.depthPositions, depthCount, D_int);

            const widthLayout = applyLockedAxisLayout('width', d.widthPositions, W_int, t);
            d.widthPositions = widthLayout.positions;
            W_int = widthLayout.length;
            D_int = getResolvedBoxDimensions().D_int;
            const depthLayout = applyLockedAxisLayout('depth', d.depthPositions, D_int, t);
            d.depthPositions = depthLayout.positions;
            if (previousWidthCount !== d.widthPositions.length || previousDepthCount !== d.depthPositions.length) {
                resetRemovedDividerSegments();
            }
            d.enabled = d.widthPositions.length > 0 || d.depthPositions.length > 0;
        }

        function resetRemovedDividerSegments() {
            state.dividers.removedSegments = { width: {}, depth: {} };
        }

        function isDividerSegmentRemoved(axis, dividerIndex, segmentIndex) {
            const store = state.dividers.removedSegments && state.dividers.removedSegments[axis];
            return !!(store && store[`${dividerIndex}:${segmentIndex}`]);
        }

        function removeDividerDefinition(axis, dividerIndex) {
            const d = state.dividers;
            if (!d.removedSegments) resetRemovedDividerSegments();
            const perpendicularAxis = axis === 'width' ? 'depth' : 'width';
            const axisPositions = axis === 'width' ? d.widthPositions : d.depthPositions;
            const perpendicularPositions = perpendicularAxis === 'width' ? d.widthPositions : d.depthPositions;
            if (dividerIndex < 0 || dividerIndex >= axisPositions.length) return false;

            const oldStores = d.removedSegments;
            const nextStores = { width: {}, depth: {} };
            Object.entries(oldStores[axis] || {}).forEach(([key, removed]) => {
                if (!removed) return;
                const [storedDivider, storedSegment] = key.split(':').map(Number);
                if (storedDivider === dividerIndex) return;
                const nextDivider = storedDivider > dividerIndex ? storedDivider - 1 : storedDivider;
                nextStores[axis][`${nextDivider}:${storedSegment}`] = true;
            });

            const oldCellCount = axisPositions.length + 1;
            for (let perpendicularDivider = 0; perpendicularDivider < perpendicularPositions.length; perpendicularDivider++) {
                const wasRemoved = segmentIndex => !!oldStores[perpendicularAxis][`${perpendicularDivider}:${segmentIndex}`];
                for (let nextSegment = 0; nextSegment < oldCellCount - 1; nextSegment++) {
                    let removed;
                    if (nextSegment < dividerIndex) {
                        removed = wasRemoved(nextSegment);
                    } else if (nextSegment === dividerIndex) {
                        removed = wasRemoved(dividerIndex) && wasRemoved(dividerIndex + 1);
                    } else {
                        removed = wasRemoved(nextSegment + 1);
                    }
                    if (removed) nextStores[perpendicularAxis][`${perpendicularDivider}:${nextSegment}`] = true;
                }
            }

            axisPositions.splice(dividerIndex, 1);
            if (axis === 'width') {
                d.widthSections = d.widthPositions.length;
            } else {
                d.depthSections = d.depthPositions.length;
            }
            d.removedSegments = nextStores;
            shiftAxisLocks(axis, dividerIndex + 2, -1);
            d.enabled = d.widthPositions.length > 0 || d.depthPositions.length > 0;
            return true;
        }

        function removeDividerSegmentRange(axis, dividerIndex, segmentStart, segmentEnd = segmentStart) {
            pushUndoSnapshot();
            if (!state.dividers.removedSegments) resetRemovedDividerSegments();
            const firstSegment = Math.max(0, Math.min(segmentStart, segmentEnd));
            const lastSegment = Math.max(firstSegment, Math.max(segmentStart, segmentEnd));
            for (let segmentIndex = firstSegment; segmentIndex <= lastSegment; segmentIndex++) {
                state.dividers.removedSegments[axis][`${dividerIndex}:${segmentIndex}`] = true;
            }
            const perpendicularCount = axis === 'width'
                ? state.dividers.depthPositions.length + 1
                : state.dividers.widthPositions.length + 1;
            const allRemoved = Array.from({ length: perpendicularCount }, (_, index) => (
                isDividerSegmentRemoved(axis, dividerIndex, index)
            )).every(Boolean);
            if (allRemoved) {
                removeDividerDefinition(axis, dividerIndex);
            }
            updateAll();
        }

        function removeDividerSegment(axis, dividerIndex, segmentIndex) {
            removeDividerSegmentRange(axis, dividerIndex, segmentIndex, segmentIndex);
        }

        function isDividerIntersectionNeeded(axis, dividerIndex, crossIndex) {
            const perpendicularAxis = axis === 'width' ? 'depth' : 'width';
            return !(
                isDividerSegmentRemoved(perpendicularAxis, crossIndex, dividerIndex) &&
                isDividerSegmentRemoved(perpendicularAxis, crossIndex, dividerIndex + 1)
            );
        }

        function getDividerRuns(axis, dividerIndex, length, t, crossPositions) {
            const centers = normalizeDividerPositions(crossPositions).map(pos => pos * length);
            const cellCount = centers.length + 1;
            const removed = Array.from({ length: cellCount }, (_, segmentIndex) => isDividerSegmentRemoved(axis, dividerIndex, segmentIndex));
            if (!removed.some(Boolean)) {
                return [{
                    start: 0,
                    end: length,
                    segmentStart: 0,
                    segmentEnd: cellCount - 1,
                    crossPositions: normalizeDividerPositions(crossPositions)
                        .filter((pos, crossIndex) => isDividerIntersectionNeeded(axis, dividerIndex, crossIndex))
                }];
            }

            const runs = [];
            let runStart = -1;
            for (let cellIndex = 0; cellIndex <= cellCount; cellIndex++) {
                const present = cellIndex < cellCount && !removed[cellIndex];
                if (present && runStart < 0) runStart = cellIndex;
                if ((!present || cellIndex === cellCount) && runStart >= 0) {
                    const runEnd = cellIndex - 1;
                    const startCross = runStart - 1;
                    const endCross = runEnd;
                    const startKeepsJoint = startCross >= 0 && isDividerIntersectionNeeded(axis, dividerIndex, startCross);
                    const endKeepsJoint = endCross < centers.length && isDividerIntersectionNeeded(axis, dividerIndex, endCross);
                    const start = runStart === 0
                        ? 0
                        : centers[startCross] + (startKeepsJoint ? -t / 2 : t / 2);
                    const end = runEnd === cellCount - 1
                        ? length
                        : centers[endCross] + (endKeepsJoint ? t / 2 : -t / 2);
                    const runLength = Math.max(0, end - start);
                    if (runLength >= t) {
                        const firstCrossIndex = Math.max(0, runStart - 1);
                        const lastCrossIndex = Math.min(centers.length - 1, runEnd);
                        const internalCrosses = centers
                            .map((center, crossIndex) => ({ center, crossIndex }))
                            .filter(({ crossIndex }) => (
                                crossIndex >= firstCrossIndex &&
                                crossIndex <= lastCrossIndex &&
                                isDividerIntersectionNeeded(axis, dividerIndex, crossIndex)
                            ))
                            .map(({ center }) => (center - start) / runLength);
                        runs.push({ start, end, segmentStart: runStart, segmentEnd: runEnd, crossPositions: internalCrosses });
                    }
                    runStart = -1;
                }
            }
            return runs;
        }

        function rectangleCmds(x, y, w, h) {
            return [
                { type: 'M', x, y },
                { type: 'L', x: x + w, y },
                { type: 'L', x: x + w, y: y + h },
                { type: 'L', x, y: y + h },
                { type: 'L', x, y }
            ];
        }

        function getRaisedBottomWallSlots(w, h, t, lift = state.bottomLift, edge = 'bottom') {
            if (!Number.isFinite(lift) || lift <= 1e-7) return [];
            const inset = Math.max(0, Math.min(h - t, lift));
            const y = edge === 'top' ? h - inset - t : inset;
            return protrusionIntervals(w, state.fingerSize, t, 'A').map(([start, end], index) => ({
                name: `raised-bottom-slot-${index + 1}`,
                cmds: rectangleCmds(start, y, end - start, t)
            }));
        }

        function roundedRectangleCmds(x, y, w, h, radius) {
            const r = Math.max(0, Math.min(Number(radius) || 0, w / 2, h / 2));
            if (r <= 1e-7) return rectangleCmds(x, y, w, h);
            const bulge = Math.tan(Math.PI / 8);
            const arc = (cx, cy, endX, endY, startAngle, endAngle) => ({
                type: 'A', cx, cy, R: r, startAngle, endAngle, sweep: 0, bulge, x: endX, y: endY
            });
            return [
                { type: 'M', x: x + r, y },
                { type: 'L', x: x + w - r, y },
                arc(x + w - r, y + r, x + w, y + r, -Math.PI / 2, 0),
                { type: 'L', x: x + w, y: y + h - r },
                arc(x + w - r, y + h - r, x + w - r, y + h, 0, Math.PI / 2),
                { type: 'L', x: x + r, y: y + h },
                arc(x + r, y + h - r, x, y + h - r, Math.PI / 2, Math.PI),
                { type: 'L', x, y: y + r },
                arc(x + r, y + r, x + r, y, Math.PI, Math.PI * 1.5),
                { type: 'L', x: x + r, y }
            ];
        }

        function crossSlotCmds(centerX, centerY, horizontalSpan, verticalSpan, thickness) {
            const halfT = thickness / 2;
            const halfW = horizontalSpan / 2;
            const halfH = verticalSpan / 2;
            return [
                { type: 'M', x: centerX - halfT, y: centerY - halfH },
                { type: 'L', x: centerX + halfT, y: centerY - halfH },
                { type: 'L', x: centerX + halfT, y: centerY - halfT },
                { type: 'L', x: centerX + halfW, y: centerY - halfT },
                { type: 'L', x: centerX + halfW, y: centerY + halfT },
                { type: 'L', x: centerX + halfT, y: centerY + halfT },
                { type: 'L', x: centerX + halfT, y: centerY + halfH },
                { type: 'L', x: centerX - halfT, y: centerY + halfH },
                { type: 'L', x: centerX - halfT, y: centerY + halfT },
                { type: 'L', x: centerX - halfW, y: centerY + halfT },
                { type: 'L', x: centerX - halfW, y: centerY - halfT },
                { type: 'L', x: centerX - halfT, y: centerY - halfT },
                { type: 'L', x: centerX - halfT, y: centerY - halfH }
            ];
        }

        function symmetricCrossSlotCmds(centerX, centerY, span, thickness) {
            // Keep all four arms identical even if a future caller supplies a size
            // smaller than the material thickness.
            const symmetricSpan = Math.max(thickness, Number(span) || 0);
            return crossSlotCmds(centerX, centerY, symmetricSpan, symmetricSpan, thickness);
        }

        function getLidHandleGeometry(t) {
            const scale = Math.max(0.01, t / 3);
            const dims = getResolvedBoxDimensions();
            const preferredHoleWidth = 20 * scale;
            const minimumWidth = preferredHoleWidth + 2 * t;
            const maximumWidth = Math.max(minimumWidth, Math.min(dims.W_ext, dims.D_ext) / 2);
            const requestedWidth = Number(state.removableLid && state.removableLid.handleWidth);
            const width = Math.max(minimumWidth, Math.min(
                maximumWidth,
                Number.isFinite(requestedWidth) ? requestedWidth : 26.5566 * scale
            ));
            const topHoleWidth = Math.max(Math.min(t, width / 3), Math.min(preferredHoleWidth, width - 2 * t));
            const radius = width / 2;
            const handleCenterTop = 2 * t + Math.sqrt(Math.max(0, radius * radius - (t / 2) * (t / 2)));
            return {
                scale,
                width,
                minimumWidth,
                maximumWidth,
                radius,
                outerMargin: (width - topHoleWidth) / 2,
                shoulder: 4 * scale,
                innerStep: 4.5 * scale,
                // Both perpendicular handle pieces meet at the exact same half-height.
                // This stays symmetric when the user changes the handle width.
                notchHeight: handleCenterTop / 2,
                topHoleWidth,
                lowerHoleSize: 12 * scale
            };
        }

        function getRemovableLidConstraints(t) {
            const scale = Math.max(0.01, t / 3);
            const minimumHandleWidth = 20 * scale + 2 * t;
            const minimumInternalHandleSpan = 2 * minimumHandleWidth - 2 * t;
            return {
                // The two handle pieces cross at 90 degrees, so the same safe span is
                // required across both lid axes. This keeps the curved pieces, shoulders
                // and center slots inside the lid when either width or depth is reduced.
                minInternalWidth: Math.max(getAbsoluteMinDimension(t), minimumInternalHandleSpan),
                minInternalHeight: getAbsoluteMinDimension(t),
                minInternalDepth: Math.max(getAbsoluteMinDimension(t), minimumInternalHandleSpan)
            };
        }

        function lidHandlePanelCmds(piece, t) {
            const g = getLidHandleGeometry(t);
            const r = g.radius;
            const base = 2 * t;
            const width = 2 * r;
            const cmds = [{ type: 'M', x: 0, y: base }];
            const arcTo = (x, y) => cmds.push({
                type: 'A', cx: r, cy: base, R: r,
                startAngle: 0, endAngle: 0, sweep: 1, bulge: -1, x, y
            });

            if (piece === 'cross-slot') {
                const slotX1 = r - t / 2;
                const slotX2 = r + t / 2;
                const slotTop = base + Math.sqrt(Math.max(0, r * r - (t / 2) * (t / 2)));
                arcTo(slotX1, slotTop);
                cmds.push({ type: 'L', x: slotX1, y: g.notchHeight });
                cmds.push({ type: 'L', x: slotX2, y: g.notchHeight });
                cmds.push({ type: 'L', x: slotX2, y: slotTop });
                arcTo(width, base);
                let x = width - g.outerMargin;
                cmds.push({ type: 'L', x, y: base });
                appendPressFitSemicircle(cmds, x, base, x, t, 1, 0);
                x -= g.shoulder;
                cmds.push({ type: 'L', x, y: t });
                appendPressFitSemicircle(cmds, x, t, x, 0, 1, 0);
                cmds.push({ type: 'L', x: g.outerMargin + g.shoulder, y: 0 });
                x = g.outerMargin + g.shoulder;
                appendPressFitSemicircle(cmds, x, 0, x, t, -1, 0);
                x = g.outerMargin;
                cmds.push({ type: 'L', x, y: t });
                appendPressFitSemicircle(cmds, x, t, x, base, -1, 0);
                cmds.push({ type: 'L', x: 0, y: base });
                return simplifyCollinearCmds(cmds);
            }

            arcTo(width, base);
            let x = width - g.outerMargin;
            cmds.push({ type: 'L', x, y: base });
            appendPressFitSemicircle(cmds, x, base, x, t, 1, 0);
            x -= g.shoulder;
            cmds.push({ type: 'L', x, y: t });
            appendPressFitSemicircle(cmds, x, t, x, 0, 1, 0);
            x -= g.innerStep;
            cmds.push({ type: 'L', x, y: 0 });
            appendPressFitSemicircle(cmds, x, 0, x, g.notchHeight, -1, 0);
            x -= t;
            cmds.push({ type: 'L', x, y: g.notchHeight });
            appendPressFitSemicircle(cmds, x, g.notchHeight, x, 0, 1, 0);
            x -= g.innerStep;
            cmds.push({ type: 'L', x, y: 0 });
            appendPressFitSemicircle(cmds, x, 0, x, t, -1, 0);
            x -= g.shoulder;
            cmds.push({ type: 'L', x, y: t });
            appendPressFitSemicircle(cmds, x, t, x, base, -1, 0);
            cmds.push({ type: 'L', x: 0, y: base });
            return simplifyCollinearCmds(cmds);
        }

        function appendPressFitSemicircle(cmds, x1, y1, x2, y2, outwardX, outwardY) {
            const radius = state.addNotches ? Math.max(0, Number(state.notchDiameter) / 2 || 0) : 0;
            const length = Math.hypot(x2 - x1, y2 - y1);
            if (!(radius > 1e-7) || length < radius * 2 + 1e-7) {
                cmds.push({ type: 'L', x: x2, y: y2 });
                return;
            }

            const ux = (x2 - x1) / length;
            const uy = (y2 - y1) / length;
            const cx = (x1 + x2) / 2;
            const cy = (y1 + y2) / 2;
            const sx = cx - ux * radius;
            const sy = cy - uy * radius;
            const ex = cx + ux * radius;
            const ey = cy + uy * radius;
            const cross = ux * outwardY - uy * outwardX;
            const bulge = cross < 0 ? 1 : -1;

            cmds.push({ type: 'L', x: sx, y: sy });
            cmds.push({
                type: 'A',
                cx,
                cy,
                R: radius,
                startAngle: Math.atan2(sy - cy, sx - cx),
                endAngle: Math.atan2(ey - cy, ex - cx),
                sweep: bulge > 0 ? 0 : 1,
                bulge,
                x: ex,
                y: ey
            });
            cmds.push({ type: 'L', x: x2, y: y2 });
        }

        function appendProfiledEdge(cmds, startX, startY, dirX, dirY, length, normalX, normalY, t, type, trimStart = 0, trimEnd = 0, profileLength = length, profileOffset = 0) {
            const intervals = protrusionIntervals(profileLength, state.fingerSize, t, type)
                .map(([start, end]) => [start + profileOffset, end + profileOffset]);
            const point = (distance, offset = 0) => ({
                x: startX + dirX * distance + normalX * offset,
                y: startY + dirY * distance + normalY * offset
            });
            const pushLine = pt => {
                const last = cmds[cmds.length - 1];
                if (last && Math.hypot(last.x - pt.x, last.y - pt.y) < 1e-7) return;
                cmds.push({ type: cmds.length ? 'L' : 'M', x: pt.x, y: pt.y });
            };
            const pushFittedLine = (from, to, outwardX, outwardY) => {
                if (!cmds.length) pushLine(from);
                appendPressFitSemicircle(cmds, from.x, from.y, to.x, to.y, outwardX, outwardY);
            };
            const edgeStart = Math.max(0, Math.min(length, trimStart));
            const edgeEnd = Math.max(edgeStart, Math.min(length, length - trimEnd));
            const clipped = intervals
                .map(([start, end]) => [Math.max(edgeStart, start), Math.min(edgeEnd, end)])
                .filter(([start, end]) => end > start + 1e-7);
            const startsInside = clipped.some(([start, end]) => start <= edgeStart + 1e-7 && end > edgeStart + 1e-7);
            pushLine(point(edgeStart, startsInside ? t : 0));
            let cursor = edgeStart;
            clipped.forEach(([start, end]) => {
                const continuesFromCursor = start <= cursor + 1e-7;
                if (!continuesFromCursor) {
                    pushLine(point(start));
                    pushFittedLine(point(start), point(start, t), -dirX, -dirY);
                }
                pushLine(point(end, t));
                if (end < edgeEnd - 1e-7) {
                    pushFittedLine(point(end, t), point(end), dirX, dirY);
                }
                cursor = end;
            });
            if (cursor < edgeEnd - 1e-7 || !clipped.length) pushLine(point(edgeEnd));
        }

        function appendArcPolyline(cmds, cx, cy, radius, startAngle, endAngle, clockwise, segments = 12) {
            let sweep = endAngle - startAngle;
            if (clockwise) {
                while (sweep >= 0) sweep -= Math.PI * 2;
            } else {
                while (sweep <= 0) sweep += Math.PI * 2;
            }
            for (let index = 1; index <= segments; index++) {
                const angle = startAngle + sweep * index / segments;
                cmds.push({
                    type: 'L',
                    x: cx + Math.cos(angle) * radius,
                    y: cy + Math.sin(angle) * radius
                });
            }
        }

        function getPreferredSlideRailWidth(t) {
            return Math.max(2 * t, t + 5);
        }

        function getSlideRailWidth(D_ext, t) {
            return Math.min(getPreferredSlideRailWidth(t), Math.max(t, D_ext / 2 - t));
        }

        function getSlideLidConstraints(t) {
            const displayFactor = state.unit === 'in' ? 1 / MM_PER_INCH : 1;
            const fingerStepDisplay = state.unit === 'in' ? 0.01 : 1;
            const rawFingerMinDisplay = (Math.max(3, t) / 2) * displayFactor;
            const fingerMinDisplay = Math.ceil((rawFingerMinDisplay - 1e-9) / fingerStepDisplay) * fingerStepDisplay;
            const fingerMin = fingerMinDisplay * 2 / displayFactor;
            const minCornerMargin = Math.min(t / 4, fingerMin / 4);
            const minInternalSpan = Math.max(getAbsoluteMinDimension(t), 3 * fingerMin + 2 * minCornerMargin);
            const preferredRailWidth = getPreferredSlideRailWidth(t);

            return {
                fingerMin,
                minInternalWidth: minInternalSpan,
                minInternalHeight: minInternalSpan,
                minInternalDepth: Math.max(minInternalSpan, 2 * preferredRailWidth)
            };
        }

        function slideRailFrameCmds(W_ext, D_ext, t, upper) {
            const baseWidth = Math.max(t, W_ext - (upper ? 0 : t));
            const wallWidth = Math.max(t, W_ext - 2 * t);
            const wallDepth = Math.max(t, D_ext - 2 * t);
            const rail = getSlideRailWidth(D_ext, t);
            const radius = Math.max(0, Math.min(5, rail - t, D_ext / 4));
            const profileType = upper ? 'A' : 'B';
            const cornerTrim = upper ? 0 : t;
            const cmds = [{ type: 'M', x: baseWidth, y: rail }];

            cmds.push({ type: 'L', x: baseWidth, y: upper ? 0 : t });
            appendProfiledEdge(cmds, baseWidth, 0, -1, 0, baseWidth, 0, 1, t, profileType, 0, cornerTrim, wallWidth, upper ? t : 0);
            appendProfiledEdge(cmds, 0, 0, 0, 1, D_ext, 1, 0, t, profileType, cornerTrim, cornerTrim, wallDepth, t);
            appendProfiledEdge(cmds, 0, D_ext, 1, 0, baseWidth, 0, -1, t, profileType, cornerTrim, 0, wallWidth, t);
            cmds.push({ type: 'L', x: baseWidth, y: D_ext - rail });
            cmds.push({ type: 'L', x: rail + radius, y: D_ext - rail });
            if (radius > 1e-7) {
                cmds.push({
                    type: 'A', cx: rail + radius, cy: D_ext - rail - radius, R: radius,
                    startAngle: Math.PI / 2, endAngle: Math.PI, sweep: 0,
                    bulge: Math.tan(Math.PI / 8), x: rail, y: D_ext - rail - radius
                });
            }
            cmds.push({ type: 'L', x: rail, y: rail + radius });
            if (radius > 1e-7) {
                cmds.push({
                    type: 'A', cx: rail + radius, cy: rail + radius, R: radius,
                    startAngle: Math.PI, endAngle: Math.PI * 1.5, sweep: 0,
                    bulge: Math.tan(Math.PI / 8), x: rail + radius, y: rail
                });
            }
            cmds.push({ type: 'L', x: baseWidth, y: rail });
            return simplifyCollinearCmds(cmds);
        }

        function getSlideLidMotionGeometry(W_int, D_ext, t) {
            const railWidth = getSlideRailWidth(D_ext, t);
            return {
                railWidth,
                travel: Math.max(0, W_int + 2 * t)
            };
        }

        function getSlideLidPanelGeometry(W_ext, D_ext, t) {
            const bodyWidth = Math.max(t, W_ext - t);
            const bodyDepth = Math.max(t, D_ext - 2 * t);
            const cornerRadius = Math.max(0, Math.min(5, bodyWidth / 4, bodyDepth / 4));
            const availableHandleLength = Math.max(0, bodyDepth - 2 * cornerRadius);
            const handleLength = Math.max(0, Math.min(D_ext / 3, availableHandleLength));
            const requestedOutset = Math.max(0, 2 * t);
            const handleRadius = Math.max(0, Math.min(requestedOutset, handleLength / 2));
            return {
                bodyWidth,
                bodyDepth,
                cornerRadius,
                handleLength,
                handleRadius,
                totalWidth: bodyWidth + handleRadius
            };
        }

        function slideLidPanelCmds(W_ext, D_ext, t) {
            const geometry = getSlideLidPanelGeometry(W_ext, D_ext, t);
            const bodyWidth = geometry.bodyWidth;
            const height = geometry.bodyDepth;
            const grip = geometry.handleRadius;
            const radius = geometry.cornerRadius;
            const middleY = height / 2;
            const handleStart = middleY - geometry.handleLength / 2;
            const handleEnd = middleY + geometry.handleLength / 2;
            const tabStart = handleStart + grip;
            const tabEnd = handleEnd - grip;
            const quarterBulge = Math.tan(Math.PI / 8);
            const cmds = [{ type: 'M', x: 0, y: radius }];
            if (radius > 1e-7) cmds.push({ type: 'A', cx: radius, cy: radius, R: radius, startAngle: Math.PI, endAngle: Math.PI * 1.5, sweep: 0, bulge: quarterBulge, x: radius, y: 0 });
            cmds.push({ type: 'L', x: bodyWidth - radius, y: 0 });
            if (radius > 1e-7) cmds.push({ type: 'A', cx: bodyWidth - radius, cy: radius, R: radius, startAngle: -Math.PI / 2, endAngle: 0, sweep: 0, bulge: quarterBulge, x: bodyWidth, y: radius });
            cmds.push({ type: 'L', x: bodyWidth, y: handleStart });
            if (grip > 1e-7) cmds.push({ type: 'A', cx: bodyWidth, cy: tabStart, R: grip, startAngle: -Math.PI / 2, endAngle: 0, sweep: 0, bulge: quarterBulge, x: bodyWidth + grip, y: tabStart });
            cmds.push({ type: 'L', x: bodyWidth + grip, y: tabEnd });
            if (grip > 1e-7) cmds.push({ type: 'A', cx: bodyWidth, cy: tabEnd, R: grip, startAngle: 0, endAngle: Math.PI / 2, sweep: 0, bulge: quarterBulge, x: bodyWidth, y: handleEnd });
            cmds.push({ type: 'L', x: bodyWidth, y: height - radius });
            if (radius > 1e-7) cmds.push({ type: 'A', cx: bodyWidth - radius, cy: height - radius, R: radius, startAngle: 0, endAngle: Math.PI / 2, sweep: 0, bulge: quarterBulge, x: bodyWidth - radius, y: height });
            cmds.push({ type: 'L', x: radius, y: height });
            if (radius > 1e-7) cmds.push({ type: 'A', cx: radius, cy: height - radius, R: radius, startAngle: Math.PI / 2, endAngle: Math.PI, sweep: 0, bulge: quarterBulge, x: 0, y: height - radius });
            cmds.push({ type: 'L', x: 0, y: radius });
            return cmds;
        }

        function getSlideLidWallSlots(w, h, t, edge = 'top') {
            const y = edge === 'top' ? Math.max(0, h - 2 * t) : t;
            return protrusionIntervals(w, state.fingerSize, t, 'A')
                .filter(([start, end]) => end - start >= t)
                .map(([start, end], index) => ({
                    name: `Slide-lid-${edge}-wall-slot-${index + 1}`,
                    cmds: rectangleCmds(start, y, end - start, t)
                }));
        }

        function circleCmds(cx, cy, radius) {
            const r = Math.max(0, Number(radius) || 0);
            const bulge = Math.tan(Math.PI / 8);
            return [
                { type: 'M', x: cx + r, y: cy },
                { type: 'A', cx, cy, R: r, startAngle: 0, endAngle: Math.PI / 2, sweep: 0, bulge, x: cx, y: cy + r },
                { type: 'A', cx, cy, R: r, startAngle: Math.PI / 2, endAngle: Math.PI, sweep: 0, bulge, x: cx - r, y: cy },
                { type: 'A', cx, cy, R: r, startAngle: Math.PI, endAngle: Math.PI * 1.5, sweep: 0, bulge, x: cx, y: cy - r },
                { type: 'A', cx, cy, R: r, startAngle: Math.PI * 1.5, endAngle: Math.PI * 2, sweep: 0, bulge, x: cx + r, y: cy }
            ];
        }

        function getDoorLidGeometry(W_ext, D_ext, t) {
            const lid = ensureDoorLidState();
            const bodyDepth = Math.max(t, D_ext - 2 * t);
            const bodyLeft = t;
            const hingeOuterRadius = Math.PI * t / 2;
            const pivotX = Math.max(t, W_ext - t - hingeOuterRadius);
            const rotationClearance = 0.05 * t;
            const rotatingRadius = Math.max(t / 2, hingeOuterRadius - rotationClearance);
            const rightReach = Math.sqrt(Math.max(0, rotatingRadius * rotatingRadius - (t / 2) * (t / 2)));
            const bodyRight = pivotX + rightReach;
            const minimumHandleSize = Math.min(bodyDepth, 4 * t);
            const maximumHandleSize = Math.max(minimumHandleSize, bodyDepth - 2 * t);
            const requestedHandleSize = Number.isFinite(lid.handleSize) ? lid.handleSize : Math.max(4 * t, D_ext / 3);
            const handleLength = Math.max(minimumHandleSize, Math.min(maximumHandleSize, requestedHandleSize));
            const handleOutset = Math.min(2 * t, handleLength / 2);
            const handleStart = (bodyDepth - handleLength) / 2;
            const handleEnd = handleStart + handleLength;
            const hingeHoleRadius = Math.min(hingeOuterRadius - t / 2, 11 * t / 15);
            const earHalfChord = Math.sqrt(Math.max(0, hingeOuterRadius * hingeOuterRadius - (t / 2) * (t / 2)));
            return {
                bodyDepth,
                bodyLeft,
                hingeOuterRadius,
                hingeHoleRadius,
                earHalfChord,
                pivotX,
                bodyRight,
                handleLength,
                minimumHandleSize,
                maximumHandleSize,
                handleOutset,
                handleStart,
                handleEnd,
                minX: bodyLeft - handleOutset,
                maxX: bodyRight,
                totalWidth: bodyRight - bodyLeft + handleOutset,
                openAngle: Math.PI * 0.72
            };
        }

        function getDoorLidConstraints(t, dims = getResolvedBoxDimensions()) {
            const lid = ensureDoorLidState();
            const hingeOuterRadius = Math.PI * t / 2;
            const handleSize = Number.isFinite(lid.handleSize) ? lid.handleSize : Math.max(4 * t, dims.D_ext / 3);
            return {
                minInternalWidth: Math.max(getAbsoluteMinDimension(t), 2 * hingeOuterRadius + 2 * t),
                minInternalHeight: Math.max(getAbsoluteMinDimension(t), hingeOuterRadius + 1.5 * t),
                minInternalDepth: Math.max(getAbsoluteMinDimension(t), 10 * t, handleSize + 2 * t)
            };
        }

        function doorLidPanelCmds(W_ext, D_ext, t) {
            const g = getDoorLidGeometry(W_ext, D_ext, t);
            const halfTab = t / 2;
            const quarterBulge = Math.tan(Math.PI / 8);
            const lowerHandleCenter = g.handleStart + g.handleOutset;
            const upperHandleCenter = g.handleEnd - g.handleOutset;
            const cmds = [
                { type: 'M', x: g.bodyLeft, y: 0 },
                { type: 'L', x: g.pivotX - halfTab, y: 0 },
                { type: 'L', x: g.pivotX - halfTab, y: -t },
                { type: 'L', x: g.pivotX + halfTab, y: -t },
                { type: 'L', x: g.pivotX + halfTab, y: 0 },
                { type: 'L', x: g.bodyRight, y: 0 },
                { type: 'L', x: g.bodyRight, y: g.bodyDepth },
                { type: 'L', x: g.pivotX + halfTab, y: g.bodyDepth },
                { type: 'L', x: g.pivotX + halfTab, y: g.bodyDepth + t },
                { type: 'L', x: g.pivotX - halfTab, y: g.bodyDepth + t },
                { type: 'L', x: g.pivotX - halfTab, y: g.bodyDepth },
                { type: 'L', x: g.bodyLeft, y: g.bodyDepth },
                { type: 'L', x: g.bodyLeft, y: g.handleEnd }
            ];
            if (g.handleOutset > 1e-7) {
                cmds.push({
                    type: 'A', cx: g.bodyLeft, cy: upperHandleCenter, R: g.handleOutset,
                    startAngle: Math.PI / 2, endAngle: Math.PI, sweep: 0,
                    bulge: quarterBulge, x: g.bodyLeft - g.handleOutset, y: upperHandleCenter
                });
                cmds.push({ type: 'L', x: g.bodyLeft - g.handleOutset, y: lowerHandleCenter });
                cmds.push({
                    type: 'A', cx: g.bodyLeft, cy: lowerHandleCenter, R: g.handleOutset,
                    startAngle: Math.PI, endAngle: Math.PI * 1.5, sweep: 0,
                    bulge: quarterBulge, x: g.bodyLeft, y: g.handleStart
                });
            }
            cmds.push({ type: 'L', x: g.bodyLeft, y: 0 });
            return simplifyCollinearCmds(cmds);
        }

        function getTwoDoorLidGeometry(W_ext, D_ext, t) {
            const lid = ensureTwoDoorLidState();
            const W_int = Math.max(t, W_ext - 2 * t);
            const bodyDepth = Math.max(t, D_ext - 2 * t);
            const hingeOuterRadius = Math.PI * t / 2;
            const rotationClearance = 0.05 * t;
            const rotatingRadius = Math.max(t / 2, hingeOuterRadius - rotationClearance);
            const outerReach = Math.sqrt(Math.max(0, rotatingRadius * rotatingRadius - (t / 2) * (t / 2)));
            const earHalfChord = Math.sqrt(Math.max(0, hingeOuterRadius * hingeOuterRadius - (t / 2) * (t / 2)));
            const safeHandleSpan = Math.max(t, W_int - 2 * (hingeOuterRadius + earHalfChord + t / 2));
            const minimumHandleSize = Math.min(4 * t, safeHandleSpan);
            const maximumHandleSize = Math.max(minimumHandleSize, safeHandleSpan);
            const requestedHandleSize = Number.isFinite(lid.handleSize) ? lid.handleSize : Math.max(4 * t, D_ext / 3);
            const handleGap = Math.max(minimumHandleSize, Math.min(maximumHandleSize, requestedHandleSize));
            const centerX = W_ext / 2;
            const leftPivotX = t + hingeOuterRadius;
            const rightPivotX = W_ext - t - hingeOuterRadius;
            const handleRadius = Math.min(2 * t, handleGap / 2);
            return {
                W_int,
                bodyDepth,
                hingeOuterRadius,
                hingeHoleRadius: Math.min(hingeOuterRadius - t / 2, 11 * t / 15),
                earHalfChord,
                outerReach,
                handleGap,
                minimumHandleSize,
                maximumHandleSize,
                handleRadius,
                centerX,
                leftPivotX,
                rightPivotX,
                leftBodyInnerX: centerX - handleGap / 2,
                rightBodyInnerX: centerX + handleGap / 2,
                leftBodyOuterX: leftPivotX - outerReach,
                rightBodyOuterX: rightPivotX + outerReach,
                openAngle: Math.PI * 0.72
            };
        }

        function getTwoDoorLidConstraints(t, dims = getResolvedBoxDimensions()) {
            const lid = ensureTwoDoorLidState();
            const hingeOuterRadius = Math.PI * t / 2;
            const earHalfChord = Math.sqrt(Math.max(0, hingeOuterRadius * hingeOuterRadius - (t / 2) * (t / 2)));
            const handleNotchLength = Number.isFinite(lid.handleSize) ? lid.handleSize : Math.max(4 * t, dims.D_ext / 3);
            const featureClearance = t / 2;
            const minimumWidthForSeparateFeatures = handleNotchLength
                + 2 * (hingeOuterRadius + earHalfChord + featureClearance);
            return {
                // The handle notch is based on box depth, while both hinge ears occupy
                // the same front/back wall edge. Keep a real flat bridge between every
                // feature so shrinking width can never make the notch cross the hinges.
                minInternalWidth: Math.max(
                    getAbsoluteMinDimension(t),
                    2 * hingeOuterRadius + 8 * t,
                    minimumWidthForSeparateFeatures
                ),
                minInternalHeight: Math.max(getAbsoluteMinDimension(t), hingeOuterRadius + 1.5 * t),
                minInternalDepth: Math.max(getAbsoluteMinDimension(t), 10 * t)
            };
        }

        function twoDoorLidPanelCmds(W_ext, D_ext, t, side) {
            const g = getTwoDoorLidGeometry(W_ext, D_ext, t);
            const halfTab = t / 2;
            const bulge = Math.tan(Math.PI / 8);
            const r = g.handleRadius;
            if (side === 'left') {
                const pivot = g.leftPivotX;
                const inner = g.leftBodyInnerX;
                const outer = g.leftBodyOuterX;
                return simplifyCollinearCmds([
                    { type: 'M', x: outer, y: 0 },
                    { type: 'L', x: pivot - halfTab, y: 0 },
                    { type: 'L', x: pivot - halfTab, y: -t },
                    { type: 'L', x: pivot + halfTab, y: -t },
                    { type: 'L', x: pivot + halfTab, y: 0 },
                    { type: 'L', x: inner, y: 0 },
                    { type: 'A', cx: inner + r, cy: 0, R: r, startAngle: Math.PI, endAngle: Math.PI * 1.5, sweep: 0, bulge, x: inner + r, y: -r },
                    { type: 'L', x: g.centerX, y: -r },
                    { type: 'L', x: g.centerX, y: g.bodyDepth + r },
                    { type: 'L', x: inner + r, y: g.bodyDepth + r },
                    { type: 'A', cx: inner + r, cy: g.bodyDepth, R: r, startAngle: Math.PI / 2, endAngle: Math.PI, sweep: 0, bulge, x: inner, y: g.bodyDepth },
                    { type: 'L', x: pivot + halfTab, y: g.bodyDepth },
                    { type: 'L', x: pivot + halfTab, y: g.bodyDepth + t },
                    { type: 'L', x: pivot - halfTab, y: g.bodyDepth + t },
                    { type: 'L', x: pivot - halfTab, y: g.bodyDepth },
                    { type: 'L', x: outer, y: g.bodyDepth },
                    { type: 'L', x: outer, y: 0 }
                ]);
            }
            const pivot = g.rightPivotX;
            const inner = g.rightBodyInnerX;
            const outer = g.rightBodyOuterX;
            return simplifyCollinearCmds([
                { type: 'M', x: inner, y: 0 },
                { type: 'L', x: pivot - halfTab, y: 0 },
                { type: 'L', x: pivot - halfTab, y: -t },
                { type: 'L', x: pivot + halfTab, y: -t },
                { type: 'L', x: pivot + halfTab, y: 0 },
                { type: 'L', x: outer, y: 0 },
                { type: 'L', x: outer, y: g.bodyDepth },
                { type: 'L', x: pivot + halfTab, y: g.bodyDepth },
                { type: 'L', x: pivot + halfTab, y: g.bodyDepth + t },
                { type: 'L', x: pivot - halfTab, y: g.bodyDepth + t },
                { type: 'L', x: pivot - halfTab, y: g.bodyDepth },
                { type: 'L', x: inner, y: g.bodyDepth },
                { type: 'A', cx: inner - r, cy: g.bodyDepth, R: r, startAngle: 0, endAngle: Math.PI / 2, sweep: 0, bulge, x: inner - r, y: g.bodyDepth + r },
                { type: 'L', x: g.centerX, y: g.bodyDepth + r },
                { type: 'L', x: g.centerX, y: -r },
                { type: 'L', x: inner - r, y: -r },
                { type: 'A', cx: inner - r, cy: 0, R: r, startAngle: -Math.PI / 2, endAngle: 0, sweep: 0, bulge, x: inner, y: 0 }
            ]);
        }

        function addDoorHingeEar(cmds, w, h, t, edge) {
            if (edge !== 'top' && edge !== 'bottom') return cmds;
            const g = getDoorLidGeometry(w + 2 * t, h + 2 * t, t);
            const pivotX = w - g.hingeOuterRadius;
            const baselineY = edge === 'top' ? h : 0;
            const centerY = baselineY + (edge === 'top' ? -t / 2 : t / 2);
            const leftX = pivotX - g.earHalfChord;
            const rightX = pivotX + g.earHalfChord;
            const arcBulge = Math.tan((Math.PI - 2 * Math.asin((t / 2) / g.hingeOuterRadius)) / 4);
            const out = [cmds[0]];
            let inserted = false;

            for (let index = 1; index < cmds.length; index++) {
                const previous = cmds[index - 1];
                const current = cmds[index];
                const isTargetEdge = !inserted && current.type === 'L' && previous.type !== 'A'
                    && Math.abs(previous.y - baselineY) < 1e-7
                    && Math.abs(current.y - baselineY) < 1e-7
                    && Math.min(previous.x, current.x) <= leftX + 1e-7
                    && Math.max(previous.x, current.x) >= rightX - 1e-7;
                if (!isTargetEdge) {
                    out.push(current);
                    continue;
                }

                const forward = current.x > previous.x;
                const startX = forward ? leftX : rightX;
                const endX = forward ? rightX : leftX;
                const startAngle = Math.atan2(baselineY - centerY, startX - pivotX);
                const endAngle = Math.atan2(baselineY - centerY, endX - pivotX);
                const naturalDirection = (edge === 'bottom' && forward) || (edge === 'top' && !forward);
                out.push({ type: 'L', x: startX, y: baselineY });
                out.push({
                    type: 'A', cx: pivotX, cy: centerY, R: g.hingeOuterRadius,
                    startAngle, endAngle, sweep: naturalDirection ? 0 : 1,
                    bulge: naturalDirection ? arcBulge : -arcBulge,
                    x: endX, y: baselineY
                });
                out.push(current);
                inserted = true;
            }
            return simplifyCollinearCmds(out);
        }

        function addTwoDoorHingeEars(cmds, w, h, t, edge) {
            if (edge !== 'top' && edge !== 'bottom') return cmds;
            const g = getTwoDoorLidGeometry(w + 2 * t, h + 2 * t, t);
            const baselineY = edge === 'top' ? h : 0;
            const centerY = baselineY + (edge === 'top' ? -t / 2 : t / 2);
            const centers = [g.hingeOuterRadius, w - g.hingeOuterRadius];
            const arcBulge = Math.tan((Math.PI - 2 * Math.asin((t / 2) / g.hingeOuterRadius)) / 4);
            const out = [cmds[0]];
            let inserted = false;
            for (let index = 1; index < cmds.length; index++) {
                const previous = cmds[index - 1];
                const current = cmds[index];
                const minX = Math.min(...centers.map(center => center - g.earHalfChord));
                const maxX = Math.max(...centers.map(center => center + g.earHalfChord));
                const isTargetEdge = !inserted && current.type === 'L' && previous.type !== 'A'
                    && Math.abs(previous.y - baselineY) < 1e-7
                    && Math.abs(current.y - baselineY) < 1e-7
                    && Math.min(previous.x, current.x) <= minX + 1e-7
                    && Math.max(previous.x, current.x) >= maxX - 1e-7;
                if (!isTargetEdge) {
                    out.push(current);
                    continue;
                }
                const forward = current.x > previous.x;
                const ordered = forward ? centers : [...centers].reverse();
                ordered.forEach(pivotX => {
                    const startX = pivotX + (forward ? -g.earHalfChord : g.earHalfChord);
                    const endX = pivotX + (forward ? g.earHalfChord : -g.earHalfChord);
                    const startAngle = Math.atan2(baselineY - centerY, startX - pivotX);
                    const endAngle = Math.atan2(baselineY - centerY, endX - pivotX);
                    const naturalDirection = (edge === 'bottom' && forward) || (edge === 'top' && !forward);
                    out.push({ type: 'L', x: startX, y: baselineY });
                    out.push({
                        type: 'A', cx: pivotX, cy: centerY, R: g.hingeOuterRadius,
                        startAngle, endAngle, sweep: naturalDirection ? 0 : 1,
                        bulge: naturalDirection ? arcBulge : -arcBulge,
                        x: endX, y: baselineY
                    });
                });
                out.push(current);
                inserted = true;
            }
            return simplifyCollinearCmds(out);
        }

        function addDoorHandleNotch(cmds, w, h, t, edge, handleLength) {
            if (edge !== 'top' && edge !== 'bottom') return cmds;
            const baselineY = edge === 'top' ? h : 0;
            const insetY = baselineY + (edge === 'top' ? -t : t);
            const length = Math.max(t, Math.min(w, handleLength));
            const leftX = (w - length) / 2;
            const rightX = leftX + length;
            const out = [cmds[0]];
            let inserted = false;

            for (let index = 1; index < cmds.length; index++) {
                const previous = cmds[index - 1];
                const current = cmds[index];
                const isTargetEdge = !inserted && current.type === 'L'
                    && Math.abs(previous.y - baselineY) < 1e-7
                    && Math.abs(current.y - baselineY) < 1e-7
                    && Math.min(previous.x, current.x) <= leftX + 1e-7
                    && Math.max(previous.x, current.x) >= rightX - 1e-7;
                if (!isTargetEdge) {
                    out.push(current);
                    continue;
                }
                const forward = current.x > previous.x;
                const firstX = forward ? leftX : rightX;
                const secondX = forward ? rightX : leftX;
                out.push({ type: 'L', x: firstX, y: baselineY });
                out.push({ type: 'L', x: firstX, y: insetY });
                out.push({ type: 'L', x: secondX, y: insetY });
                out.push({ type: 'L', x: secondX, y: baselineY });
                out.push(current);
                inserted = true;
            }
            return simplifyCollinearCmds(out);
        }

        function getDoorHingeHoleCmds(w, h, t, edge) {
            const g = getDoorLidGeometry(w + 2 * t, h + 2 * t, t);
            const centerY = edge === 'bottom' ? t / 2 : h - t / 2;
            return circleCmds(w - g.hingeOuterRadius, centerY, g.hingeHoleRadius);
        }

        function getTwoDoorHingeHoleCmds(w, h, t, edge) {
            const g = getTwoDoorLidGeometry(w + 2 * t, h + 2 * t, t);
            const centerY = edge === 'bottom' ? t / 2 : h - t / 2;
            return [
                circleCmds(g.hingeOuterRadius, centerY, g.hingeHoleRadius),
                circleCmds(w - g.hingeOuterRadius, centerY, g.hingeHoleRadius)
            ];
        }

        function dividerPanelCmds(w, h, t, options = {}) {
            const tab = Math.min(t, h / 5);
            const sideTabStart = options.sideTabs && options.sideTabsStart !== false ? t : 0;
            const sideTabEnd = options.sideTabs && options.sideTabsEnd !== false ? t : 0;
            const hasBottomTabs = !!options.bottomTabs;
            const crossPositions = normalizeDividerPositions(options.crossPositions || []);
            const topClearanceCuts = (options.topClearanceCuts || []).map(cut => ({
                x1: Math.max(0, Math.min(w, Number(cut.x1) || 0)),
                x2: Math.max(0, Math.min(w, Number(cut.x2) || 0)),
                depth: Math.max(0, Math.min(h, Number(cut.depth) || 0)),
                radius: Math.max(0, Number(cut.radius) || 0),
                roundSide: cut.roundSide === 'right' ? 'right' : 'left'
            })).filter(cut => cut.x2 - cut.x1 > 1e-7 && cut.depth > 1e-7);
            const crossFromTop = !!options.crossFromTop;
            const pressFitCrossSlots = !!options.pressFitCrossSlots && state.addNotches;
            const crossW = Math.max(t, 0.01);
            // A divider half-lap must always stop exactly at the height midpoint.
            // Using the material thickness as a minimum could cut through more than
            // half of a short divider after the bottom had been raised.
            const crossDepth = h / 2;

            if (!sideTabStart && !sideTabEnd && !hasBottomTabs && !crossPositions.length && !topClearanceCuts.length) {
                return rectangleCmds(0, 0, w, h);
            }

            const cmds = [{ type: 'M', x: 0, y: 0 }];

            const addBottomFeatures = (edgeY) => {
                let xCursor = 0;
                const bottomCross = crossFromTop ? [] : crossPositions.map(pos => ({
                    x1: pos * w - crossW / 2,
                    x2: pos * w + crossW / 2,
                    depth: crossDepth
                }));
                const features = [
                    ...(hasBottomTabs ? getBottomJointFeatures(w, t, crossPositions).map(feature => ({ type: 'tab', x1: feature.start, x2: feature.end })) : []),
                    ...bottomCross.map(slot => ({ type: 'slot', ...slot }))
                ].sort((a, b) => a.x1 - b.x1);

                features.forEach(feature => {
                    const x1 = Math.max(xCursor, Math.max(0, feature.x1));
                    const x2 = Math.min(w, feature.x2);
                    if (x2 <= x1) return;
                    cmds.push({ type: 'L', x: x1, y: edgeY });
                    if (feature.type === 'tab') {
                        appendPressFitSemicircle(cmds, x1, edgeY, x1, edgeY - tab, -1, 0);
                        cmds.push({ type: 'L', x: x2, y: edgeY - tab });
                        appendPressFitSemicircle(cmds, x2, edgeY - tab, x2, edgeY, 1, 0);
                    } else {
                        cmds.push({ type: 'L', x: x1, y: edgeY + feature.depth });
                        cmds.push({ type: 'L', x: x2, y: edgeY + feature.depth });
                        cmds.push({ type: 'L', x: x2, y: edgeY });
                    }
                    xCursor = x2;
                });
            };

            if (hasBottomTabs || (!crossFromTop && crossPositions.length)) {
                addBottomFeatures(0);
            }
            cmds.push({ type: 'L', x: w, y: 0 });
            if (sideTabEnd) {
                const y1 = h / 2;
                const y2 = h;
                cmds.push({ type: 'L', x: w, y: y1 });
                cmds.push({ type: 'L', x: w + sideTabEnd, y: y1 });
                cmds.push({ type: 'L', x: w + sideTabEnd, y: y2 });
                cmds.push({ type: 'L', x: w, y: y2 });
            }
            cmds.push({ type: 'L', x: w, y: h });

            if ((crossFromTop && crossPositions.length) || topClearanceCuts.length) {
                const rawTopSlots = [
                    ...(crossFromTop ? crossPositions.map(pos => ({
                        type: 'cross',
                        x1: Math.max(0, pos * w - crossW / 2),
                        x2: Math.min(w, pos * w + crossW / 2),
                        depth: crossDepth
                    })) : []),
                    ...topClearanceCuts.map(cut => ({ type: 'clearance', ...cut }))
                ].sort((a, b) => a.x1 - b.x1);
                const mergedTopSlots = [];
                rawTopSlots.forEach(slot => {
                    const previous = mergedTopSlots[mergedTopSlots.length - 1];
                    if (previous && slot.x1 <= previous.x2 + 1e-7) {
                        previous.x2 = Math.max(previous.x2, slot.x2);
                        previous.depth = Math.max(previous.depth, slot.depth);
                        previous.radius = Math.max(previous.radius || 0, slot.radius || 0);
                        previous.type = previous.type === slot.type ? previous.type : 'clearance';
                        if (previous.roundSide !== slot.roundSide) previous.roundSide = 'both';
                    } else {
                        mergedTopSlots.push({ ...slot });
                    }
                });
                const topSlots = mergedTopSlots.sort((a, b) => b.x1 - a.x1);
                let xCursor = w;
                topSlots.forEach(slot => {
                    const x2 = Math.min(xCursor, slot.x2);
                    const x1 = Math.max(0, slot.x1);
                    if (x2 <= x1) return;
                    cmds.push({ type: 'L', x: x2, y: h });
                    const roundLeft = slot.type === 'clearance' && slot.roundSide !== 'right';
                    const roundRight = slot.type === 'clearance' && slot.roundSide !== 'left';
                    const cornerRadius = slot.type === 'clearance'
                        ? Math.min(
                            slot.radius || slot.depth,
                            slot.depth,
                            (x2 - x1) / (roundLeft && roundRight ? 2 : 1)
                        )
                        : 0;
                    if (slot.type === 'cross' && pressFitCrossSlots && x2 < w - 1e-7) {
                        appendPressFitSemicircle(cmds, x2, h, x2, h - slot.depth, -1, 0);
                    } else if (roundRight && cornerRadius > 1e-7) {
                        const centerY = h - slot.depth + cornerRadius;
                        cmds.push({ type: 'L', x: x2, y: centerY });
                        cmds.push({
                            type: 'A',
                            cx: x2 - cornerRadius,
                            cy: centerY,
                            R: cornerRadius,
                            startAngle: 0,
                            endAngle: -Math.PI / 2,
                            sweep: 1,
                            bulge: -Math.tan(Math.PI / 8),
                            x: x2 - cornerRadius,
                            y: h - slot.depth
                        });
                    } else {
                        cmds.push({ type: 'L', x: x2, y: h - slot.depth });
                    }
                    const lowerLeftX = x1 + (roundLeft ? cornerRadius : 0);
                    cmds.push({ type: 'L', x: lowerLeftX, y: h - slot.depth });
                    if (roundLeft && cornerRadius > 1e-7) {
                        const centerY = h - slot.depth + cornerRadius;
                        cmds.push({
                            type: 'A',
                            cx: lowerLeftX,
                            cy: centerY,
                            R: cornerRadius,
                            startAngle: -Math.PI / 2,
                            endAngle: -Math.PI,
                            sweep: 1,
                            bulge: -Math.tan(Math.PI / 8),
                            x: x1,
                            y: centerY
                        });
                        if (centerY < h - 1e-7) cmds.push({ type: 'L', x: x1, y: h });
                    }
                    if (slot.type === 'cross' && pressFitCrossSlots && x1 > 1e-7) {
                        appendPressFitSemicircle(cmds, x1, h - slot.depth, x1, h, 1, 0);
                    } else if (!roundLeft || cornerRadius <= 1e-7) {
                        cmds.push({ type: 'L', x: x1, y: h });
                    }
                    xCursor = x1;
                });
            }
            cmds.push({ type: 'L', x: 0, y: h });
            if (sideTabStart) {
                const y1 = h;
                const y2 = h / 2;
                cmds.push({ type: 'L', x: 0, y: y1 });
                cmds.push({ type: 'L', x: -sideTabStart, y: y1 });
                cmds.push({ type: 'L', x: -sideTabStart, y: y2 });
                cmds.push({ type: 'L', x: 0, y: y2 });
            }
            cmds.push({ type: 'L', x: 0, y: 0 });
            return simplifyCollinearCmds(cmds);
        }

        function getDoorDividerTopClearanceCuts(run, W_int, W_ext, D_ext, t) {
            const doorLid = ensureDoorLidState();
            const twoDoorLid = ensureTwoDoorLidState();
            if (state.boxType !== 'open' || (!doorLid.enabled && !twoDoorLid.enabled)) return [];
            const g = getDoorLidGeometry(W_ext, D_ext, t);
            const rotatingReach = g.bodyRight - g.pivotX;
            const halfWidth = rotatingReach + 0.6 * t;
            const hinges = twoDoorLid.enabled
                ? [g.hingeOuterRadius, W_int - g.hingeOuterRadius]
                : [W_int - g.hingeOuterRadius];
            return hinges.map((hingeAlongWidth, hingeIndex) => {
                const localStart = Math.max(0, hingeAlongWidth - halfWidth - run.start);
                const localEnd = Math.min(run.end - run.start, hingeAlongWidth + halfWidth - run.start);
                if (localEnd - localStart <= 1e-7) return null;
                return {
                    x1: localStart,
                    x2: localEnd,
                    depth: rotatingReach + 0.2 * t,
                    radius: rotatingReach + 0.2 * t,
                    roundSide: twoDoorLid.enabled && hingeIndex === 0 ? 'right' : 'left'
                };
            }).filter(Boolean);
        }

        function getBottomJointFeatures(length, t, dividerPositions) {
            const centers = normalizeDividerPositions(dividerPositions).map(pos => pos * length);
            const features = [];
            let cellStart = 0;

            [...centers, length + t / 2].forEach(center => {
                const cellEnd = Math.min(length, center - t / 2);
                const clearLength = Math.max(0, cellEnd - cellStart);
                if (clearLength >= t) {
                    const tabLength = Math.min(clearLength, Math.max(t, clearLength * 0.3));
                    const tabCenter = (cellStart + cellEnd) / 2;
                    features.push({
                        center: tabCenter,
                        start: tabCenter - tabLength / 2,
                        end: tabCenter + tabLength / 2,
                        length: tabLength
                    });
                }
                cellStart = center + t / 2;
            });
            return features;
        }

        function addOpenEdgeSlots(cmds, w, h, edge, positions, t, slotDepth = h / 2) {
            const centers = normalizeDividerPositions(positions).map(pos => pos * w);
            if (!centers.length) return cmds;
            const edgeY = edge === 'bottom' ? 0 : h;
            const clampedDepth = Math.max(0, Math.min(h, slotDepth));
            const innerY = edge === 'bottom' ? clampedDepth : h - clampedDepth;
            const out = [];
            let inserted = false;

            for (let i = 0; i < cmds.length; i++) {
                const cmd = cmds[i];
                if (!inserted && i > 0 && cmd.type === 'L') {
                    const prev = cmds[i - 1];
                    const isEdge = prev && prev.type !== 'A' && Math.abs(prev.y - edgeY) < 1e-7 && Math.abs(cmd.y - edgeY) < 1e-7;
                    if (isEdge && Math.abs(cmd.x - prev.x) > w * 0.5) {
                        const forward = cmd.x > prev.x;
                        const ordered = forward ? centers : [...centers].reverse();
                        ordered.forEach(center => {
                            const before = center + (forward ? -t / 2 : t / 2);
                            const after = center + (forward ? t / 2 : -t / 2);
                            out.push({ type: 'L', x: before, y: edgeY });
                            appendPressFitSemicircle(out, before, edgeY, before, innerY, forward ? 1 : -1, 0);
                            out.push({ type: 'L', x: after, y: innerY });
                            appendPressFitSemicircle(out, after, innerY, after, edgeY, forward ? -1 : 1, 0);
                        });
                        inserted = true;
                    }
                }
                out.push(cmd);
            }
            return simplifyCollinearCmds(out);
        }

        function getPanelOuterCommands(def, dims, forceNoNotches = false) {
            let cmds = buildPanel(def.w, def.h, dims.t, state.fingerSize, def.edges, forceNoNotches, true, def.edgeProfiles || null);
            const doorLid = ensureDoorLidState();
            const twoDoorLid = ensureTwoDoorLidState();
            if (doorLid.enabled && state.boxType === 'open') {
                if (def.doorHingeEdge) cmds = addDoorHingeEar(cmds, def.w, def.h, dims.t, def.doorHingeEdge);
                if (def.doorHandleEdge) {
                    const D_ext = dims.D_int + 2 * dims.t;
                    const doorGeometry = getDoorLidGeometry(dims.W_int + 2 * dims.t, D_ext, dims.t);
                    cmds = addDoorHandleNotch(cmds, def.w, def.h, dims.t, def.doorHandleEdge, doorGeometry.handleLength);
                }
            }
            if (twoDoorLid.enabled && state.boxType === 'open') {
                if (def.twoDoorHingeEdge) cmds = addTwoDoorHingeEars(cmds, def.w, def.h, dims.t, def.twoDoorHingeEdge);
                if (def.twoDoorHandleEdge) {
                    const D_ext = dims.D_int + 2 * dims.t;
                    const twoDoorGeometry = getTwoDoorLidGeometry(dims.W_int + 2 * dims.t, D_ext, dims.t);
                    cmds = addDoorHandleNotch(cmds, def.w, def.h, dims.t, def.twoDoorHandleEdge, twoDoorGeometry.handleGap);
                }
            }
            if (!state.dividers.enabled || !state.dividers.addSideSlots || !def.sideSlotEdge) return cmds;

            let positions = [];
            if (def.name === 'Back') {
                positions = state.dividers.widthPositions.filter((pos, dividerIndex) => !isDividerSegmentRemoved('width', dividerIndex, 0));
            }
            if (def.name === 'Front') {
                const lastSegment = state.dividers.depthPositions.length;
                positions = state.dividers.widthPositions.filter((pos, dividerIndex) => !isDividerSegmentRemoved('width', dividerIndex, lastSegment));
            }
            if (def.name === 'Left') {
                positions = state.dividers.depthPositions
                    .filter((pos, dividerIndex) => !isDividerSegmentRemoved('depth', dividerIndex, 0))
                    .map(pos => 1 - pos);
            }
            if (def.name === 'Right') {
                const lastSegment = state.dividers.widthPositions.length;
                positions = state.dividers.depthPositions.filter((pos, dividerIndex) => !isDividerSegmentRemoved('depth', dividerIndex, lastSegment));
            }
            const dividerSideJointDepth = getDividerPanelHeight(getResolvedBoxDimensions()) / 2;
            return addOpenEdgeSlots(cmds, def.w, def.h, def.sideSlotEdge, positions, dims.t, dividerSideJointDepth);
        }

        function transformCmds2D(cmds, transform) {
            return cmds.map(cmd => {
                const pt = transform(cmd.x, cmd.y);
                if (cmd.type === 'A') {
                    const center = transform(cmd.cx, cmd.cy);
                    return {
                        ...cmd,
                        x: pt.x,
                        y: pt.y,
                        cx: center.x,
                        cy: center.y,
                        R: Math.hypot(pt.x - center.x, pt.y - center.y)
                    };
                }
                return { ...cmd, x: pt.x, y: pt.y };
            });
        }

        function appendCommandsToThreePath(path, cmds, offsetX = 0, offsetY = 0) {
            let previous = null;
            cmds.forEach((cmd, index) => {
                const x = cmd.x - offsetX;
                const y = cmd.y - offsetY;
                if (index === 0 || cmd.type === 'M') {
                    path.moveTo(x, y);
                } else if (cmd.type === 'A' && previous) {
                    const cx = cmd.cx - offsetX;
                    const cy = cmd.cy - offsetY;
                    const startAngle = Math.atan2(previous.y - cmd.cy, previous.x - cmd.cx);
                    const endAngle = Math.atan2(cmd.y - cmd.cy, cmd.x - cmd.cx);
                    path.absarc(cx, cy, cmd.R, startAngle, endAngle, cmd.bulge < 0);
                } else {
                    path.lineTo(x, y);
                }
                previous = { x: cmd.x, y: cmd.y };
            });
        }

        function addPanelPoints(cmds, allPoints) {
            cmds.forEach(cmd => {
                allPoints.push({ x: cmd.x, y: cmd.y });
                if (cmd.type === 'A') {
                    allPoints.push({ x: cmd.cx, y: cmd.cy });
                    allPoints.push({ x: cmd.cx - cmd.R, y: cmd.cy - cmd.R });
                    allPoints.push({ x: cmd.cx + cmd.R, y: cmd.cy + cmd.R });
                }
            });
        }

        function createDividerCutouts(def, dims) {
            const { W_int, D_int, t } = dims;
            const d = state.dividers;
            const cuts = [];
            const slotW = Math.max(t, 0.01);

            if (def.name === 'Bottom' && d.addBottomSlots) {
                d.widthPositions.forEach((pos, idx) => {
                    const x = pos * W_int - slotW / 2;
                    getBottomJointFeatures(D_int, t, d.depthPositions).forEach((feature, featureIdx) => {
                        if (isDividerSegmentRemoved('width', idx, featureIdx)) return;
                        const y = D_int - feature.center - feature.length / 2;
                        cuts.push({ name: `Bottom-width-divider-slot-${idx + 1}-${featureIdx + 1}`, cmds: rectangleCmds(x, y, slotW, feature.length) });
                    });
                });
                d.depthPositions.forEach((pos, idx) => {
                    const y = (1 - pos) * D_int - slotW / 2;
                    getBottomJointFeatures(W_int, t, d.widthPositions).forEach((feature, featureIdx) => {
                        if (isDividerSegmentRemoved('depth', idx, featureIdx)) return;
                        cuts.push({ name: `Bottom-depth-divider-slot-${idx + 1}-${featureIdx + 1}`, cmds: rectangleCmds(feature.start, y, feature.length, slotW) });
                    });
                });
            }

            return cuts;
        }

        function getDividerCellSpanAt(coordinate, positions, length, t) {
            const centers = normalizeDividerPositions(positions).map(pos => pos * length);
            let start = 0;
            for (const center of centers) {
                const end = center - t / 2;
                if (coordinate <= end) return Math.max(0, end - start);
                start = center + t / 2;
            }
            return Math.max(0, length - start);
        }

        function getDividerCellSizes(positions, length, t) {
            const centers = normalizeDividerPositions(positions).map(pos => pos * length);
            const sizes = [];
            let start = 0;
            centers.forEach(center => {
                const end = center - t / 2;
                sizes.push(Math.max(0, end - start));
                start = center + t / 2;
            });
            sizes.push(Math.max(0, length - start));
            return sizes;
        }

        function getDividerCellBoundsAt(coordinate, positions, length, t) {
            const centers = normalizeDividerPositions(positions).map(pos => pos * length);
            let start = 0;
            for (let index = 0; index < centers.length; index++) {
                const end = centers[index] - t / 2;
                if (coordinate <= centers[index]) {
                    return { index, start, end, size: Math.max(0, end - start), center: (start + end) / 2 };
                }
                start = centers[index] + t / 2;
            }
            const index = centers.length;
            return { index, start, end: length, size: Math.max(0, length - start), center: (start + length) / 2 };
        }

        function getDividerCellIndexAt(coordinate, positions, length) {
            const centers = normalizeDividerPositions(positions).map(pos => pos * length);
            for (let index = 0; index < centers.length; index++) {
                if (coordinate < centers[index]) return index;
            }
            return centers.length;
        }

        function positionsFromCellSizes(cellSizes, length, t) {
            const positions = [];
            let cursor = cellSizes[0] || 0;
            for (let index = 0; index < cellSizes.length - 1; index++) {
                const center = cursor + t / 2;
                positions.push(center / length);
                cursor += t + cellSizes[index + 1];
            }
            return positions;
        }

        function isAxisCellLocked(axis, cellIndex) {
            return Number.isFinite(Number(getAxisLocks(axis)[cellIndex]));
        }

        function isDividerBoundaryLocked(axis, dividerIndex) {
            return isAxisCellLocked(axis, dividerIndex) || isAxisCellLocked(axis, dividerIndex + 1);
        }

        function shiftAxisLocks(axis, startIndex, delta) {
            const sections = ensureLockedSectionStore();
            const nextSections = {};
            Object.values(sections).forEach(section => {
                const next = { ...section };
                const property = axis === 'width' ? 'widthCellIndex' : 'depthCellIndex';
                if (next[property] >= startIndex) next[property] += delta;
                if (next[property] < 0) return;
                nextSections[lockedSectionKey(next.widthCellIndex, next.depthCellIndex)] = next;
            });
            state.dividers.lockedSections = nextSections;
            rebuildSpecificAxisLocks();
        }

        function isCellSizeLocked(widthCellIndex, depthCellIndex) {
            return !!ensureLockedSectionStore()[lockedSectionKey(widthCellIndex, depthCellIndex)];
        }

        function updateCellLockButton(widthCellIndex, depthCellIndex) {
            if (!els.cellLockButton) return;
            const locked = isCellSizeLocked(widthCellIndex, depthCellIndex);
            els.cellLockButton.classList.toggle('active', locked);
            els.cellLockButton.setAttribute('aria-pressed', locked ? 'true' : 'false');
            els.cellLockButton.setAttribute('aria-label', locked ? 'Unlock cell size' : 'Lock cell size');
            els.cellLockButton.title = locked ? 'Unlock cell size' : 'Lock cell size';
            const icon = els.cellLockButton.querySelector('i');
            if (icon) {
                icon.classList.toggle('fa-lock', locked);
                icon.classList.toggle('fa-lock-open', !locked);
            }
        }

        function toggleCellSizeLock(widthCellIndex, depthCellIndex) {
            const dims = getResolvedBoxDimensions();
            const sections = ensureLockedSectionStore();
            const key = lockedSectionKey(widthCellIndex, depthCellIndex);
            if (isCellSizeLocked(widthCellIndex, depthCellIndex)) {
                delete sections[key];
            } else {
                const widthSizes = getDividerCellSizes(state.dividers.widthPositions, dims.W_int, dims.t);
                const depthSizes = getDividerCellSizes(state.dividers.depthPositions, dims.D_int, dims.t);
                sections[key] = {
                    widthCellIndex,
                    depthCellIndex,
                    width: widthSizes[widthCellIndex],
                    depth: depthSizes[depthCellIndex]
                };
            }
            rebuildSpecificAxisLocks();
            updateCellLockButton(widthCellIndex, depthCellIndex);
            els.cellWidthValue.readOnly = isAxisCellLocked('width', widthCellIndex);
            els.cellDepthValue.readOnly = isAxisCellLocked('depth', depthCellIndex);
            updateAll();
        }

        function updateAxisCellSizeLockButton(axis) {
            const button = axis === 'width' ? els.dividerCellWidthLock : els.dividerCellDepthLock;
            if (!button) return;
            const locked = getAxisCellSizeLock(axis) !== null;
            const name = axis === 'width' ? 'cell width' : 'cell depth';
            button.classList.toggle('active', locked);
            button.setAttribute('aria-pressed', locked ? 'true' : 'false');
            button.setAttribute('aria-label', `${locked ? 'Unlock' : 'Lock'} ${name}`);
            button.title = `${locked ? 'Unlock' : 'Lock'} ${name}`;
            const icon = button.querySelector('i');
            if (icon) {
                icon.classList.toggle('fa-lock', locked);
                icon.classList.toggle('fa-lock-open', !locked);
            }
        }

        function toggleAxisCellSizeLock(axis) {
            const locks = ensureAxisCellSizeLocks();
            if (getAxisCellSizeLock(axis) !== null) {
                locks[axis] = null;
                updateAxisCellSizeLockButton(axis);
                renderDividerControls();
                return;
            }
            const dims = getResolvedBoxDimensions();
            const positions = axis === 'width' ? state.dividers.widthPositions : state.dividers.depthPositions;
            const length = axis === 'width' ? dims.W_int : dims.D_int;
            const sizes = getDividerCellSizes(positions, length, dims.t);
            const input = axis === 'width' ? els.dividerCellWidth : els.dividerCellDepth;
            const factor = state.unit === 'in' ? MM_PER_INCH : 1;
            const entered = parseFloat(String(input.value).replace(',', '.')) * factor;
            locks[axis] = Math.max(getMinimumDividerCellSize(dims.t), Number.isFinite(entered) ? entered : sizes[0]);
            setUniformDividerCellSize(axis, locks[axis]);
        }

        function setUniformDividerCellSize(axis, desiredSizeMm) {
            const d = state.dividers;
            const dims = getResolvedBoxDimensions();
            const isWidth = axis === 'width';
            const positions = isWidth ? d.widthPositions : d.depthPositions;
            const dividerCount = positions.length;
            const minCell = getMinimumDividerCellSize(dims.t);
            const desired = Math.max(minCell, Number(desiredSizeMm) || minCell);
            if (getAxisCellSizeLock(axis) !== null) ensureAxisCellSizeLocks()[axis] = desired;
            const locks = getAxisLocks(axis);
            const nextSizes = Array.from({ length: dividerCount + 1 }, (_, index) => (
                isAxisCellLocked(axis, index) ? Math.max(minCell, Number(locks[index]) || minCell) : desired
            ));
            const internalLength = nextSizes.reduce((sum, size) => sum + size, 0) + dividerCount * dims.t;
            setInternalAxisLength(axis, internalLength, dims.t);
            const nextPositions = positionsFromCellSizes(nextSizes, internalLength, dims.t);
            if (isWidth) d.widthPositions = nextPositions;
            else d.depthPositions = nextPositions;
            updateAll();
        }

        function resizeDividerCell(axis, requestedCellIndex, desiredSizeMm) {
            const dims = getResolvedBoxDimensions();
            const d = state.dividers;
            const isWidth = axis === 'width';
            const length = isWidth ? dims.W_int : dims.D_int;
            const positions = isWidth ? d.widthPositions : d.depthPositions;
            const minCell = getMinimumDividerCellSize(dims.t);
            let desired = Math.max(minCell, Number(desiredSizeMm) || minCell);
            if (isAxisCellLocked(axis, requestedCellIndex)) return requestedCellIndex;

            if (!positions.length) {
                const property = isWidth ? 'width' : 'depth';
                state[property] = state.dimType === 'external' ? desired + 2 * dims.t : desired;
                updateAll();
                return 0;
            }

            let sizes = getDividerCellSizes(positions, length, dims.t);
            let cellIndex = Math.max(0, Math.min(sizes.length - 1, requestedCellIndex));
            const axisLocks = getAxisLocks(axis);
            const lockedIndexes = Object.keys(axisLocks)
                .map(Number)
                .filter(index => index >= 0 && index < sizes.length);

            if (lockedIndexes.length) {
                const fixedIndexes = new Set([...lockedIndexes, cellIndex]);
                const flexibleIndexes = sizes.map((value, index) => index).filter(index => !fixedIndexes.has(index));
                const fixedTotal = [...fixedIndexes].reduce((sum, index) => (
                    sum + (index === cellIndex ? desired : Math.max(minCell, Number(axisLocks[index]) || minCell))
                ), 0);
                const dividerSpace = (sizes.length - 1) * dims.t;
                let targetLength = flexibleIndexes.length
                    ? Math.max(length, fixedTotal + flexibleIndexes.length * minCell + dividerSpace)
                    : fixedTotal + dividerSpace;
                setInternalAxisLength(axis, targetLength, dims.t);
                const totalClear = targetLength - dividerSpace;
                const remaining = Math.max(0, totalClear - fixedTotal);
                const extra = Math.max(0, remaining - flexibleIndexes.length * minCell);
                const weights = flexibleIndexes.map(index => Math.max(0.001, sizes[index] - minCell));
                const weightTotal = weights.reduce((sum, value) => sum + value, 0) || 1;
                const nextSizes = sizes.map((value, index) => {
                    if (index === cellIndex) return desired;
                    if (isAxisCellLocked(axis, index)) return Math.max(minCell, Number(axisLocks[index]) || minCell);
                    return minCell;
                });
                flexibleIndexes.forEach((index, weightIndex) => {
                    nextSizes[index] += extra * weights[weightIndex] / weightTotal;
                });
                const nextPositions = positionsFromCellSizes(nextSizes, targetLength, dims.t);
                if (isWidth) d.widthPositions = nextPositions;
                else d.depthPositions = nextPositions;
                d.enabled = d.widthPositions.length > 0 || d.depthPositions.length > 0;
                updateAll();
                return cellIndex;
            }

            let topologyChanged = false;

            while (sizes.length > 1) {
                const dividerCount = sizes.length - 1;
                const maxTargetSize = length - dividerCount * dims.t - dividerCount * minCell;
                if (desired <= maxTargetSize + 1e-7) break;

                let removeAt = 0;
                let farthestDistance = -1;
                for (let dividerIndex = 0; dividerIndex < dividerCount; dividerIndex++) {
                    const distance = Math.min(Math.abs(dividerIndex - cellIndex), Math.abs(dividerIndex + 1 - cellIndex));
                    if (distance > farthestDistance) {
                        farthestDistance = distance;
                        removeAt = dividerIndex;
                    }
                }

                const merged = sizes[removeAt] + dims.t + sizes[removeAt + 1];
                sizes.splice(removeAt, 2, merged);
                if (removeAt < cellIndex) cellIndex--;
                topologyChanged = true;
            }

            const dividerCount = sizes.length - 1;
            const totalClear = length - dividerCount * dims.t;
            const otherCount = dividerCount;
            const maxTargetSize = Math.max(minCell, totalClear - otherCount * minCell);
            desired = Math.min(desired, maxTargetSize);

            const otherIndexes = sizes.map((value, index) => index).filter(index => index !== cellIndex);
            const remaining = Math.max(0, totalClear - desired);
            const extra = Math.max(0, remaining - otherCount * minCell);
            const weights = otherIndexes.map(index => Math.max(0.001, sizes[index] - minCell));
            const weightTotal = weights.reduce((sum, value) => sum + value, 0);
            const nextSizes = sizes.map((value, index) => index === cellIndex ? desired : minCell);
            otherIndexes.forEach((index, weightIndex) => {
                nextSizes[index] += extra * weights[weightIndex] / weightTotal;
            });

            const nextPositions = positionsFromCellSizes(nextSizes, length, dims.t);
            if (isWidth) {
                d.widthPositions = nextPositions;
                d.widthSections = nextPositions.length;
            } else {
                d.depthPositions = nextPositions;
                d.depthSections = nextPositions.length;
            }
            if (topologyChanged) resetRemovedDividerSegments();
            d.enabled = d.widthPositions.length > 0 || d.depthPositions.length > 0;
            updateAll();
            return cellIndex;
        }

        function addDividerAt(axis, normalizedPosition) {
            const dims = getResolvedBoxDimensions();
            const d = state.dividers;
            const isWidth = axis === 'width';
            const list = isWidth ? d.widthPositions : d.depthPositions;
            const length = isWidth ? dims.W_int : dims.D_int;
            if (list.length >= getMaxDividerCountForAxis(axis, length, dims.t)) return false;

            const splitCellIndex = getDividerCellIndexAt(normalizedPosition * length, list, length);
            if (isAxisCellLocked(axis, splitCellIndex)) return false;

            const candidate = normalizeDividerPositions([...list, normalizedPosition]);
            if (!isDividerLayoutValid(candidate, length, dims.t)) return false;
            if (!isDividerLayoutSafeForAxis(axis, candidate, length, dims.t)) return false;

            pushUndoSnapshot();

            if (isWidth) {
                d.widthPositions = candidate;
                d.widthSections = candidate.length;
            } else {
                d.depthPositions = candidate;
                d.depthSections = candidate.length;
            }
            shiftAxisLocks(axis, splitCellIndex + 1, 1);
            resetRemovedDividerSegments();
            d.enabled = true;
            renderDividerControls();
            updateAll();
            return true;
        }

        // ==========================================
        // 2. 3D VISUALIZATION ENGINE
        // ==========================================

        function initThree() {
            targetControlsTarget = new THREE.Vector3(0, 0, 0);

            const width = Math.max(1, els.canvasHolder.clientWidth);
            const height = Math.max(1, els.canvasHolder.clientHeight);
            
            scene = new THREE.Scene();
            // No scene.background set to keep WebGLRenderer transparent, showing body gradient.
            
            camera = new THREE.PerspectiveCamera(45, width / height, 1, 20000);
            camera.position.set(300, 250, 400);
            
            renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
            // High-density phone screens can otherwise render at 3x-4x resolution and become sluggish.
            renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
            renderer.setSize(width, height);
            renderer.domElement.style.touchAction = 'none';
            renderer.domElement.style.outline = 'none';
            renderer.domElement.tabIndex = 0;
            renderer.domElement.setAttribute('aria-label', 'Interactive three-dimensional preview of the generated finger-joint box');
            renderer.shadowMap.enabled = true;
            renderer.shadowMap.type = THREE.PCFSoftShadowMap;
            renderer.toneMapping = THREE.ACESFilmicToneMapping;
            renderer.toneMappingExposure = 0.85;
            els.canvasHolder.appendChild(renderer.domElement);
            
            controls = new THREE.OrbitControls(camera, renderer.domElement);
            controls.enableDamping = true;
            controls.dampingFactor = 0.05;
            controls.maxPolarAngle = Math.PI;
            controls.minDistance = 50;
            controls.maxDistance = 10000;
            controls.addEventListener('start', () => { 
                isInteracting = true; 
                cameraNeedsFit = false; 
            });
            controls.addEventListener('end', () => { 
                isInteracting = false; 
            });
            
            addSceneHelpers();
            addLights();
            applyViewTheme(state.viewTheme, false);
            
            panelGroup = new THREE.Group();
            scene.add(panelGroup);
            setupDividerDragHandlers();
            setupModelHoverEditors();
            
            animate();
        }

        function getPointerOnDividerPlane(event) {
            if (!renderer || !camera || !dividerRaycaster || !dividerPointer) return null;
            const rect = renderer.domElement.getBoundingClientRect();
            dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
            dividerRaycaster.setFromCamera(dividerPointer, camera);
            const plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
            const hit = new THREE.Vector3();
            return dividerRaycaster.ray.intersectPlane(plane, hit) ? hit : null;
        }

        function positionModelEditor(editor, event) {
            if (!editor || !els.viewportContainer) return;
            editor.hidden = false;
            const viewportRect = els.viewportContainer.getBoundingClientRect();
            const left = event.clientX - viewportRect.left + 12;
            const top = event.clientY - viewportRect.top + 12;
            editor.style.left = `${Math.max(8, Math.min(left, viewportRect.width - editor.offsetWidth - 8))}px`;
            editor.style.top = `${Math.max(8, Math.min(top, viewportRect.height - editor.offsetHeight - 8))}px`;
        }

        function hideModelHoverEditors(delay = 0) {
            window.clearTimeout(hoverEditorHideTimer);
            hoverEditorHideTimer = window.setTimeout(() => {
                if (els.segmentHoverEditor && !els.segmentHoverEditor.matches(':hover')) els.segmentHoverEditor.hidden = true;
            }, delay);
        }

        function clearCellSelection(refresh = true) {
            if (!hoveredCell && els.cellHoverEditor.hidden) return;
            hoveredCell = null;
            els.cellHoverEditor.hidden = true;
            delete els.cellHoverEditor.dataset.widthCellIndex;
            delete els.cellHoverEditor.dataset.depthCellIndex;
            if (refresh && panelGroup) updateBox3D();
        }

        function clearModelSelection(refresh = true) {
            const hadSelection = !!hoveredCell || !!hoveredDividerSegment ||
                selectedLidHandle || selectedAdjustableLidHandle || selectedBottom ||
                !els.cellHoverEditor.hidden || !els.segmentHoverEditor.hidden ||
                !els.handleSizeEditor.hidden || !els.lidHandleSizeEditor.hidden || !els.bottomLiftEditor.hidden;
            hoveredCell = null;
            hoveredDividerSegment = null;
            selectedLidHandle = false;
            selectedAdjustableLidHandle = null;
            selectedBottom = false;
            els.cellHoverEditor.hidden = true;
            els.segmentHoverEditor.hidden = true;
            els.handleSizeEditor.hidden = true;
            els.lidHandleSizeEditor.hidden = true;
            els.bottomLiftEditor.hidden = true;
            delete els.cellHoverEditor.dataset.widthCellIndex;
            delete els.cellHoverEditor.dataset.depthCellIndex;
            if (hadSelection && refresh && panelGroup) updateBox3D();
        }

        function showCellHoverEditor(event, widthCellIndex, depthCellIndex) {
            const dims = getResolvedBoxDimensions();
            const widthSizes = getDividerCellSizes(state.dividers.widthPositions, dims.W_int, dims.t);
            const depthSizes = getDividerCellSizes(state.dividers.depthPositions, dims.D_int, dims.t);
            const mergedCell = getMergedDividerCell(widthCellIndex, depthCellIndex, dims.W_int, dims.D_int, dims.t);
            const factor = state.unit === 'in' ? 1 / MM_PER_INCH : 1;
            const sameCell = !els.cellHoverEditor.hidden &&
                parseInt(els.cellHoverEditor.dataset.widthCellIndex, 10) === widthCellIndex &&
                parseInt(els.cellHoverEditor.dataset.depthCellIndex, 10) === depthCellIndex;
            hoveredCell = mergedCell;
            hoveredDividerSegment = null;
            selectedAdjustableLidHandle = null;
            selectedBottom = false;
            els.cellHoverEditor.dataset.widthCellIndex = String(widthCellIndex);
            els.cellHoverEditor.dataset.depthCellIndex = String(depthCellIndex);
            els.segmentHoverEditor.hidden = true;
            els.lidHandleSizeEditor.hidden = true;
            els.bottomLiftEditor.hidden = true;
            els.cellEditorTitle.textContent = `Cell ${widthCellIndex + 1} × ${depthCellIndex + 1}`;
            document.querySelectorAll('[data-cell-unit]').forEach(unit => { unit.textContent = state.unit; });
            [els.cellWidthValue, els.cellDepthValue].forEach(input => {
                input.min = fmtTrim(dims.t * factor, state.unit === 'in' ? 3 : 2);
                input.step = state.unit === 'in' ? '0.01' : '0.1';
            });
            if (document.activeElement !== els.cellWidthValue) {
                const mergedWidth = mergedCell.bounds.endX - mergedCell.bounds.startX;
                els.cellWidthValue.value = fmtTrim(mergedWidth * factor, state.unit === 'in' ? 3 : 2);
            }
            if (document.activeElement !== els.cellDepthValue) {
                const mergedDepth = mergedCell.bounds.endDepth - mergedCell.bounds.startDepth;
                els.cellDepthValue.value = fmtTrim(mergedDepth * factor, state.unit === 'in' ? 3 : 2);
            }
            els.cellWidthValue.readOnly = isAxisCellLocked('width', widthCellIndex);
            els.cellDepthValue.readOnly = isAxisCellLocked('depth', depthCellIndex);
            updateCellLockButton(widthCellIndex, depthCellIndex);
            if (!sameCell) positionModelEditor(els.cellHoverEditor, event);
        }

        function showSegmentHoverEditor(event, axis, dividerIndex, segmentIndex) {
            const hadCellSelection = !!hoveredCell || !els.cellHoverEditor.hidden;
            hoveredDividerSegment = { axis, dividerIndex, segmentIndex };
            hoveredCell = null;
            selectedAdjustableLidHandle = null;
            selectedBottom = false;
            els.cellHoverEditor.hidden = true;
            els.lidHandleSizeEditor.hidden = true;
            els.bottomLiftEditor.hidden = true;
            els.segmentEditorLabel.textContent = `${axis === 'width' ? 'W' : 'D'}${dividerIndex + 1} · segment ${segmentIndex + 1}`;
            positionModelEditor(els.segmentHoverEditor, event);
            if (hadCellSelection && panelGroup) updateBox3D();
        }

        function showLidHandleEditor(event) {
            const lid = ensureRemovableLidState();
            if (!lid.enabled || !lid.addHandle) return;
            const dims = getResolvedBoxDimensions();
            const geometry = getLidHandleGeometry(dims.t);
            const factor = state.unit === 'in' ? 1 / MM_PER_INCH : 1;
            const decimals = state.unit === 'in' ? 3 : 2;
            hoveredCell = null;
            hoveredDividerSegment = null;
            selectedLidHandle = true;
            selectedAdjustableLidHandle = null;
            selectedBottom = false;
            els.cellHoverEditor.hidden = true;
            els.segmentHoverEditor.hidden = true;
            els.lidHandleSizeEditor.hidden = true;
            els.bottomLiftEditor.hidden = true;
            els.handleWidthValue.min = fmtTrim(geometry.minimumWidth * factor, decimals);
            els.handleWidthValue.max = fmtTrim(geometry.maximumWidth * factor, decimals);
            els.handleWidthValue.step = state.unit === 'in' ? '0.01' : '0.1';
            els.handleWidthValue.value = fmtTrim(geometry.width * factor, decimals);
            els.handleWidthRange.min = els.handleWidthValue.min;
            els.handleWidthRange.max = els.handleWidthValue.max;
            els.handleWidthRange.step = els.handleWidthValue.step;
            els.handleWidthRange.value = els.handleWidthValue.value;
            els.handleWidthUnit.textContent = state.unit;
            positionModelEditor(els.handleSizeEditor, event);
        }

        function renderAdjustableLidHandleControls() {
            if (!els.lidHandleSizeValue || !selectedAdjustableLidHandle) return;
            const dims = getResolvedBoxDimensions();
            const geometry = selectedAdjustableLidHandle === 'door'
                ? getDoorLidGeometry(dims.W_ext, dims.D_ext, dims.t)
                : getTwoDoorLidGeometry(dims.W_ext, dims.D_ext, dims.t);
            const value = selectedAdjustableLidHandle === 'door' ? geometry.handleLength : geometry.handleGap;
            const factor = state.unit === 'in' ? 1 / MM_PER_INCH : 1;
            const decimals = state.unit === 'in' ? 3 : 2;
            const minimum = geometry.minimumHandleSize * factor;
            const maximum = geometry.maximumHandleSize * factor;
            const displayValue = value * factor;
            els.lidHandleSizeTitle.textContent = selectedAdjustableLidHandle === 'door'
                ? 'Door handle size'
                : 'Two-door handle size';
            els.lidHandleSizeValue.min = fmtTrim(minimum, decimals);
            els.lidHandleSizeValue.max = fmtTrim(maximum, decimals);
            els.lidHandleSizeValue.step = state.unit === 'in' ? '0.01' : '0.1';
            els.lidHandleSizeValue.value = fmtTrim(displayValue, decimals);
            els.lidHandleSizeRange.min = els.lidHandleSizeValue.min;
            els.lidHandleSizeRange.max = els.lidHandleSizeValue.max;
            els.lidHandleSizeRange.step = els.lidHandleSizeValue.step;
            els.lidHandleSizeRange.value = els.lidHandleSizeValue.value;
            els.lidHandleSizeUnit.textContent = state.unit;
        }

        function showAdjustableLidHandleEditor(event, type) {
            if (type !== 'door' && type !== 'two-door') return;
            hoveredCell = null;
            hoveredDividerSegment = null;
            selectedLidHandle = false;
            selectedAdjustableLidHandle = type;
            selectedBottom = false;
            els.cellHoverEditor.hidden = true;
            els.segmentHoverEditor.hidden = true;
            els.handleSizeEditor.hidden = true;
            els.bottomLiftEditor.hidden = true;
            renderAdjustableLidHandleControls();
            positionModelEditor(els.lidHandleSizeEditor, event);
        }

        function isDoorLidHandleHit(hit, geometry) {
            if (!hit || !hit.object || !geometry) return false;
            hit.object.updateMatrixWorld(true);
            const local = hit.object.worldToLocal(hit.point.clone());
            const rawX = local.x + geometry.pivotX;
            const rawY = local.y + geometry.bodyDepth / 2;
            const tolerance = state.thickness * 0.35;
            return rawX >= geometry.bodyLeft - geometry.handleOutset - tolerance
                && rawX <= geometry.bodyLeft + tolerance
                && rawY >= geometry.handleStart - tolerance
                && rawY <= geometry.handleEnd + tolerance;
        }

        function isTwoDoorLidHandleHit(hit, geometry, side) {
            if (!hit || !hit.object || !geometry) return false;
            hit.object.updateMatrixWorld(true);
            const local = hit.object.worldToLocal(hit.point.clone());
            const pivotX = side === 'left' ? geometry.leftPivotX : geometry.rightPivotX;
            const rawX = local.x + pivotX;
            const rawY = local.y + geometry.bodyDepth / 2;
            const tolerance = state.thickness * 0.35;
            const insideHandleWidth = side === 'left'
                ? rawX >= geometry.leftBodyInnerX - tolerance && rawX <= geometry.centerX + tolerance
                : rawX >= geometry.centerX - tolerance && rawX <= geometry.rightBodyInnerX + tolerance;
            const insideFrontOrBackHandle = (
                rawY >= -geometry.handleRadius - tolerance && rawY <= tolerance
            ) || (
                rawY >= geometry.bodyDepth - tolerance && rawY <= geometry.bodyDepth + geometry.handleRadius + tolerance
            );
            return insideHandleWidth && insideFrontOrBackHandle;
        }

        function showBottomLiftEditor(event) {
            hoveredCell = null;
            hoveredDividerSegment = null;
            selectedLidHandle = false;
            selectedAdjustableLidHandle = null;
            selectedBottom = true;
            els.cellHoverEditor.hidden = true;
            els.segmentHoverEditor.hidden = true;
            els.handleSizeEditor.hidden = true;
            els.lidHandleSizeEditor.hidden = true;
            renderBottomLiftControls();
            positionModelEditor(els.bottomLiftEditor, event);
        }

        function getSelectableDividerSegmentRange(axis, dividerIndex, segmentIndex, runStart, runEnd) {
            let segmentStart = Math.max(runStart, Math.min(runEnd, segmentIndex));
            let segmentEnd = segmentStart;
            while (segmentStart > runStart && !isDividerIntersectionNeeded(axis, dividerIndex, segmentStart - 1)) {
                segmentStart--;
            }
            while (segmentEnd < runEnd && !isDividerIntersectionNeeded(axis, dividerIndex, segmentEnd)) {
                segmentEnd++;
            }
            return { segmentStart, segmentEnd };
        }

        function selectDividerAtEvent(event, selectionType = 'divider') {
            if (state.boxType !== 'open' || !state.dividers.enabled || state.foldPercent > 8 || !dividerRaycaster) return false;
            const rect = renderer.domElement.getBoundingClientRect();
            dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
            dividerRaycaster.setFromCamera(dividerPointer, camera);

            const dividerHits = dividerRaycaster.intersectObjects(dividerMeshes, false);
            if (!dividerHits.length) return false;

            const hit = dividerHits[0];
            const meta = hit.object.userData && hit.object.userData.divider;
            if (!meta) return false;
            let segmentStart = meta.segmentStart;
            let segmentEnd = meta.segmentEnd;
            if (selectionType === 'segment') {
                const segmentIndex = meta.axis === 'width'
                    ? getDividerCellIndexAt(hit.point.z + meta.D_int / 2, state.dividers.depthPositions, meta.D_int)
                    : getDividerCellIndexAt(hit.point.x + meta.W_int / 2, state.dividers.widthPositions, meta.W_int);
                const selectedRange = getSelectableDividerSegmentRange(
                    meta.axis,
                    meta.index,
                    segmentIndex,
                    meta.segmentStart,
                    meta.segmentEnd
                );
                segmentStart = selectedRange.segmentStart;
                segmentEnd = selectedRange.segmentEnd;
            }
            hoveredDividerSegment = {
                selectionType,
                axis: meta.axis,
                dividerIndex: meta.index,
                segmentStart,
                segmentEnd
            };
            hoveredCell = null;
            els.cellHoverEditor.hidden = true;
            els.segmentHoverEditor.hidden = true;
            updateBox3D();
            return true;
        }

        function updateModelHoverEditors(event) {
            if (state.boxType !== 'open' || !state.dividers.enabled || state.foldPercent > 8 || !dividerRaycaster) {
                hideModelHoverEditors();
                return false;
            }
            const rect = renderer.domElement.getBoundingClientRect();
            dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
            dividerRaycaster.setFromCamera(dividerPointer, camera);

            const dividerHits = dividerRaycaster.intersectObjects(dividerMeshes, false);
            const bottomPanels = panelMeshes.filter(mesh => mesh.userData && mesh.userData.panelName === 'Bottom');
            const bottomHits = dividerRaycaster.intersectObjects(bottomPanels, false);
            const dividerIsNearest = dividerHits.length && (!bottomHits.length || dividerHits[0].distance <= bottomHits[0].distance + state.thickness * 0.2);
            if (dividerIsNearest) {
                const hit = dividerHits[0];
                const meta = hit.object.userData && hit.object.userData.divider;
                if (meta) {
                    const segmentIndex = meta.axis === 'width'
                        ? getDividerCellIndexAt(hit.point.z + meta.D_int / 2, state.dividers.depthPositions, meta.D_int)
                        : getDividerCellIndexAt(hit.point.x + meta.W_int / 2, state.dividers.widthPositions, meta.W_int);
                    if (segmentIndex >= meta.segmentStart && segmentIndex <= meta.segmentEnd) {
                        showSegmentHoverEditor(event, meta.axis, meta.index, segmentIndex);
                        return true;
                    }
                }
            }

            if (bottomHits.length) {
                const dims = getResolvedBoxDimensions();
                const point = bottomHits[0].point;
                const localX = Math.max(0, Math.min(dims.W_int, point.x + dims.W_int / 2));
                const localDepth = Math.max(0, Math.min(dims.D_int, point.z + dims.D_int / 2));
                showCellHoverEditor(
                    event,
                    getDividerCellIndexAt(localX, state.dividers.widthPositions, dims.W_int),
                    getDividerCellIndexAt(localDepth, state.dividers.depthPositions, dims.D_int)
                );
                return true;
            }

            hideModelHoverEditors();
            return false;
        }

        function updateCellCenterEditor(event) {
            if (state.boxType !== 'open' || !state.dividers.enabled || state.foldPercent > 8 || !dividerRaycaster) {
                hideModelHoverEditors(350);
                return;
            }
            const rect = renderer.domElement.getBoundingClientRect();
            dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
            dividerRaycaster.setFromCamera(dividerPointer, camera);
            const bottomPanels = panelMeshes.filter(mesh => mesh.userData && mesh.userData.panelName === 'Bottom');
            const bottomHits = dividerRaycaster.intersectObjects(bottomPanels, false);
            const dividerHits = dividerRaycaster.intersectObjects(dividerMeshes, false);
            if (!bottomHits.length || (dividerHits.length && dividerHits[0].distance < bottomHits[0].distance)) {
                hideModelHoverEditors(350);
                return;
            }

            const dims = getResolvedBoxDimensions();
            const point = bottomHits[0].point;
            const localX = Math.max(0, Math.min(dims.W_int, point.x + dims.W_int / 2));
            const localDepth = Math.max(0, Math.min(dims.D_int, point.z + dims.D_int / 2));
            const widthBounds = getDividerCellBoundsAt(localX, state.dividers.widthPositions, dims.W_int, dims.t);
            const depthBounds = getDividerCellBoundsAt(localDepth, state.dividers.depthPositions, dims.D_int, dims.t);
            const widthHotspot = Math.min(widthBounds.size / 2, Math.max(dims.t * 1.2, widthBounds.size * 0.28));
            const depthHotspot = Math.min(depthBounds.size / 2, Math.max(dims.t * 1.2, depthBounds.size * 0.28));
            const nearCenter = Math.abs(localX - widthBounds.center) <= widthHotspot &&
                Math.abs(localDepth - depthBounds.center) <= depthHotspot;
            if (nearCenter) {
                window.clearTimeout(hoverEditorHideTimer);
                showCellHoverEditor(event, widthBounds.index, depthBounds.index);
            } else {
                hideModelHoverEditors(350);
            }
        }

        function selectCellAtEvent(event) {
            if (state.boxType !== 'open' || state.foldPercent > 8 || !dividerRaycaster) {
                clearModelSelection();
                return false;
            }
            const rect = renderer.domElement.getBoundingClientRect();
            dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
            dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
            dividerRaycaster.setFromCamera(dividerPointer, camera);
            const hits = dividerRaycaster.intersectObjects(panelMeshes, false);
            const hit = hits[0];
            if (!hit || !hit.object.userData || hit.object.userData.panelName !== 'Bottom') {
                clearModelSelection();
                return false;
            }
            const dims = getResolvedBoxDimensions();
            const localX = Math.max(0, Math.min(dims.W_int, hit.point.x + dims.W_int / 2));
            const localDepth = Math.max(0, Math.min(dims.D_int, hit.point.z + dims.D_int / 2));
            showCellHoverEditor(
                event,
                getDividerCellIndexAt(localX, state.dividers.widthPositions, dims.W_int),
                getDividerCellIndexAt(localDepth, state.dividers.depthPositions, dims.D_int)
            );
            updateBox3D();
            return true;
        }

        function setupModelHoverEditors() {
            if (!renderer || renderer.domElement.dataset.modelHoverReady === 'true') return;
            renderer.domElement.dataset.modelHoverReady = 'true';

            const keepEditorOpen = () => window.clearTimeout(hoverEditorHideTimer);
            els.segmentHoverEditor.addEventListener('pointerenter', keepEditorOpen);

            const applyCellSize = (axis, input) => {
                const storedCell = {
                    widthCellIndex: parseInt(els.cellHoverEditor.dataset.widthCellIndex, 10),
                    depthCellIndex: parseInt(els.cellHoverEditor.dataset.depthCellIndex, 10)
                };
                if (!hoveredCell && (!Number.isInteger(storedCell.widthCellIndex) || !Number.isInteger(storedCell.depthCellIndex))) return;
                hoveredCell = hoveredCell || storedCell;
                const factor = state.unit === 'in' ? MM_PER_INCH : 1;
                const valueMm = parseFloat(String(input.value).replace(',', '.')) * factor;
                if (!Number.isFinite(valueMm)) return;
                const cellKey = axis === 'width' ? 'widthCellIndex' : 'depthCellIndex';
                hoveredCell[cellKey] = resizeDividerCell(axis, hoveredCell[cellKey], valueMm);
                const dims = getResolvedBoxDimensions();
                const displayFactor = state.unit === 'in' ? 1 / MM_PER_INCH : 1;
                const widthSizes = getDividerCellSizes(state.dividers.widthPositions, dims.W_int, dims.t);
                const depthSizes = getDividerCellSizes(state.dividers.depthPositions, dims.D_int, dims.t);
                els.cellWidthValue.value = fmtTrim(widthSizes[Math.min(hoveredCell.widthCellIndex, widthSizes.length - 1)] * displayFactor, state.unit === 'in' ? 3 : 2);
                els.cellDepthValue.value = fmtTrim(depthSizes[Math.min(hoveredCell.depthCellIndex, depthSizes.length - 1)] * displayFactor, state.unit === 'in' ? 3 : 2);
            };

            els.cellWidthValue.addEventListener('change', () => applyCellSize('width', els.cellWidthValue));
            els.cellDepthValue.addEventListener('change', () => applyCellSize('depth', els.cellDepthValue));
            [[els.cellWidthValue, 'width'], [els.cellDepthValue, 'depth']].forEach(([input, axis]) => {
                input.addEventListener('keydown', event => {
                    if (event.key === 'Enter') {
                        applyCellSize(axis, input);
                        input.blur();
                    }
                    if (event.key === 'Escape') hideModelHoverEditors();
                });
            });

            els.segmentHoverEditor.hidden = true;

            els.cellLockButton.addEventListener('click', () => {
                const widthCellIndex = parseInt(els.cellHoverEditor.dataset.widthCellIndex, 10);
                const depthCellIndex = parseInt(els.cellHoverEditor.dataset.depthCellIndex, 10);
                if (!Number.isInteger(widthCellIndex) || !Number.isInteger(depthCellIndex)) return;
                toggleCellSizeLock(widthCellIndex, depthCellIndex);
            });

            const applyHandleWidth = (source = els.handleWidthValue) => {
                if (!selectedLidHandle) return;
                const factor = state.unit === 'in' ? MM_PER_INCH : 1;
                const requested = parseFloat(String(source.value).replace(',', '.')) * factor;
                if (!Number.isFinite(requested)) return;
                const dims = getResolvedBoxDimensions();
                const geometry = getLidHandleGeometry(dims.t);
                ensureRemovableLidState().handleWidth = Math.max(geometry.minimumWidth, requested);
                ensureRemovableLidHandleFits();
                updateAll();
                const refreshed = getLidHandleGeometry(getResolvedBoxDimensions().t);
                const displayFactor = state.unit === 'in' ? 1 / MM_PER_INCH : 1;
                const displayValue = fmtTrim(refreshed.width * displayFactor, state.unit === 'in' ? 3 : 2);
                els.handleWidthValue.value = displayValue;
                els.handleWidthRange.value = displayValue;
            };
            els.handleWidthValue.addEventListener('change', () => applyHandleWidth(els.handleWidthValue));
            els.handleWidthValue.addEventListener('keydown', event => {
                if (event.key === 'Enter') {
                    applyHandleWidth(els.handleWidthValue);
                    els.handleWidthValue.blur();
                }
                if (event.key === 'Escape') clearModelSelection();
            });
            els.handleWidthRange.addEventListener('input', () => applyHandleWidth(els.handleWidthRange));
            els.handleWidthRange.addEventListener('keydown', event => {
                if (event.key === 'Escape') clearModelSelection();
            });

            const applyAdjustableLidHandleSize = (source = els.lidHandleSizeValue) => {
                if (!selectedAdjustableLidHandle) return;
                const factor = state.unit === 'in' ? MM_PER_INCH : 1;
                const requested = parseFloat(String(source.value).replace(',', '.')) * factor;
                if (!Number.isFinite(requested)) return;
                const dims = getResolvedBoxDimensions();
                const geometry = selectedAdjustableLidHandle === 'door'
                    ? getDoorLidGeometry(dims.W_ext, dims.D_ext, dims.t)
                    : getTwoDoorLidGeometry(dims.W_ext, dims.D_ext, dims.t);
                const nextValue = Math.max(geometry.minimumHandleSize, Math.min(geometry.maximumHandleSize, requested));
                if (selectedAdjustableLidHandle === 'door') {
                    ensureDoorLidState().handleSize = nextValue;
                } else {
                    ensureTwoDoorLidState().handleSize = nextValue;
                }
                updateAll();
                renderAdjustableLidHandleControls();
            };
            els.lidHandleSizeValue.addEventListener('change', () => applyAdjustableLidHandleSize(els.lidHandleSizeValue));
            els.lidHandleSizeValue.addEventListener('keydown', event => {
                if (event.key === 'Enter') {
                    applyAdjustableLidHandleSize(els.lidHandleSizeValue);
                    els.lidHandleSizeValue.blur();
                }
                if (event.key === 'Escape') clearModelSelection();
            });
            els.lidHandleSizeRange.addEventListener('input', () => applyAdjustableLidHandleSize(els.lidHandleSizeRange));
            els.lidHandleSizeRange.addEventListener('keydown', event => {
                if (event.key === 'Escape') clearModelSelection();
            });

            const applyBottomLift = () => {
                if (!selectedBottom) return;
                const factor = state.unit === 'in' ? MM_PER_INCH : 1;
                const requested = parseFloat(String(els.bottomLiftValue.value).replace(',', '.')) * factor;
                if (!Number.isFinite(requested)) return;
                state.bottomLift = Math.max(0, Math.min(getMaxBottomLift(), requested));
                updateAll();
            };
            els.bottomLiftValue.addEventListener('change', applyBottomLift);
            els.bottomLiftValue.addEventListener('keydown', event => {
                if (event.key === 'Enter') {
                    applyBottomLift();
                    els.bottomLiftValue.blur();
                }
                if (event.key === 'Escape') clearModelSelection();
            });

            document.addEventListener('pointerdown', event => {
                if (els.cellHoverEditor.contains(event.target) || els.segmentHoverEditor.contains(event.target) ||
                    els.handleSizeEditor.contains(event.target) || els.lidHandleSizeEditor.contains(event.target) ||
                    els.bottomLiftEditor.contains(event.target) ||
                    event.target === renderer.domElement) return;
                clearModelSelection();
            });

            document.addEventListener('keydown', event => {
                if (event.key !== 'Delete' || !hoveredDividerSegment) return;
                const targetElement = event.target;
                if (targetElement && typeof targetElement.matches === 'function' && targetElement.matches('input, textarea, select, [contenteditable="true"]')) return;
                const target = hoveredDividerSegment;
                hoveredDividerSegment = null;
                if (target.selectionType === 'divider') {
                    const segmentCount = target.axis === 'width'
                        ? state.dividers.depthPositions.length + 1
                        : state.dividers.widthPositions.length + 1;
                    removeDividerSegmentRange(target.axis, target.dividerIndex, 0, segmentCount - 1);
                } else {
                    removeDividerSegmentRange(target.axis, target.dividerIndex, target.segmentStart, target.segmentEnd);
                }
                event.preventDefault();
            });
        }

        function createDividerDragGhosts(axis, index) {
            return dividerMeshes
                .filter(mesh => {
                    const meta = mesh.userData && mesh.userData.divider;
                    return meta && meta.axis === axis && meta.index === index;
                })
                .map(source => {
                    const ghost = source.clone();
                    const sourceMaterials = Array.isArray(source.material) ? source.material : [source.material];
                    const ghostMaterials = sourceMaterials.map(material => {
                        const clone = material.clone();
                        clone.transparent = true;
                        clone.opacity = 0.24;
                        clone.depthWrite = false;
                        if (clone.color) clone.color.setHex(0x63c9ff);
                        if (clone.emissive) clone.emissive.setHex(0x16384a);
                        return clone;
                    });
                    ghost.material = Array.isArray(source.material) ? ghostMaterials : ghostMaterials[0];
                    ghost.userData = { dividerGhost: true };
                    ghost.castShadow = false;
                    ghost.receiveShadow = false;
                    ghost.raycast = () => {};
                    panelGroup.add(ghost);
                    return ghost;
                });
        }

        function removeDividerDragGhosts(ghosts) {
            (ghosts || []).forEach(ghost => {
                panelGroup.remove(ghost);
                const materials = Array.isArray(ghost.material) ? ghost.material : [ghost.material];
                materials.forEach(material => material.dispose());
            });
        }

        function setupDividerDragHandlers() {
            if (!renderer || renderer.domElement.dataset.dividerDragReady === 'true') return;
            renderer.domElement.dataset.dividerDragReady = 'true';
            dividerRaycaster = new THREE.Raycaster();
            dividerPointer = new THREE.Vector2();

            renderer.domElement.addEventListener('pointerdown', (event) => {
                renderer.domElement.focus({ preventScroll: true });
                canvasPointerStart = { x: event.clientX, y: event.clientY, moved: false };
                if (state.foldPercent > 8) return;
                clearModelSelection();
                hideModelHoverEditors();
                const rect = renderer.domElement.getBoundingClientRect();
                dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
                dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
                dividerRaycaster.setFromCamera(dividerPointer, camera);

                const bottomMesh = panelMeshes.find(mesh => mesh.userData && mesh.userData.panelName === 'Bottom');
                if (bottomMesh) {
                    const bottomHandles = cellVisuals.filter(visual => visual.userData && visual.userData.bottomLiftHandle);
                    const handleHit = bottomHandles.length
                        ? dividerRaycaster.intersectObjects(bottomHandles, false)[0]
                        : null;
                    const bottomHit = handleHit || dividerRaycaster.intersectObject(bottomMesh, false)
                        .find(hit => hit.face && hit.face.materialIndex === 1);
                    if (bottomHit) {
                        const hitPoint = bottomHit.point;
                        const planeNormal = new THREE.Vector3(
                            camera.position.x - hitPoint.x,
                            0,
                            camera.position.z - hitPoint.z
                        );
                        if (planeNormal.lengthSq() < 1e-8) planeNormal.set(0, 0, 1);
                        planeNormal.normalize();
                        const plane = new THREE.Plane().setFromNormalAndCoplanarPoint(planeNormal, hitPoint);
                        const startPoint = new THREE.Vector3();
                        if (dividerRaycaster.ray.intersectPlane(plane, startPoint)) {
                            pushUndoSnapshot();
                            activeBottomDrag = {
                                plane,
                                startPoint: startPoint.clone(),
                                startLift: state.bottomLift,
                                maxLift: getMaxBottomLift()
                            };
                            canvasPointerStart.dragType = 'bottom';
                            if (controls) controls.enabled = false;
                            renderer.domElement.style.cursor = 'ns-resize';
                            renderer.domElement.setPointerCapture(event.pointerId);
                            event.preventDefault();
                            return;
                        }
                    }
                }

                const slideLid = ensureSlideLidState();
                if (slideLid.enabled && slideLidMeshes.length) {
                    const slideHits = dividerRaycaster.intersectObjects(slideLidMeshes, false);
                    if (slideHits.length) {
                        if (slideLidAnimationFrame) cancelAnimationFrame(slideLidAnimationFrame);
                        slideLidAnimationFrame = 0;
                        const hitPoint = slideHits[0].point;
                        const plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), -hitPoint.y);
                        const startPoint = new THREE.Vector3();
                        const dims = getResolvedBoxDimensions();
                        const motion = getSlideLidMotionGeometry(dims.W_int, dims.D_ext, dims.t);
                        if (motion.travel > 1e-7 && dividerRaycaster.ray.intersectPlane(plane, startPoint)) {
                            pushUndoSnapshot();
                            activeSlideLidDrag = {
                                plane,
                                startPoint: startPoint.clone(),
                                startProgress: slideLid.openProgress,
                                travel: motion.travel,
                                meshStartXs: slideLidMeshes.map(mesh => ({ mesh, x: mesh.position.x }))
                            };
                            canvasPointerStart.dragType = 'slide-lid';
                            if (controls) controls.enabled = false;
                            renderer.domElement.style.cursor = 'ew-resize';
                            renderer.domElement.setPointerCapture(event.pointerId);
                            event.preventDefault();
                            return;
                        }
                    }
                }

                const doorLid = ensureDoorLidState();
                const twoDoorLid = ensureTwoDoorLidState();
                if (twoDoorLid.enabled && twoDoorLidMeshes.length) {
                    const lidHits = dividerRaycaster.intersectObjects(twoDoorLidMeshes, false);
                    if (lidHits.length) {
                        const firstHit = lidHits[0];
                        const dims = getResolvedBoxDimensions();
                        const geometry = getTwoDoorLidGeometry(dims.W_ext, dims.D_ext, dims.t);
                        const side = firstHit.object.userData.twoDoorLid;
                        if (isTwoDoorLidHandleHit(firstHit, geometry, side)) {
                            canvasPointerStart.dragType = 'two-door-handle';
                            showAdjustableLidHandleEditor(event, 'two-door');
                            event.preventDefault();
                            return;
                        }
                        if (twoDoorLidAnimationFrame) cancelAnimationFrame(twoDoorLidAnimationFrame);
                        twoDoorLidAnimationFrame = 0;
                        const hitPoint = firstHit.point;
                        const plane = new THREE.Plane(new THREE.Vector3(0, 0, 1), -hitPoint.z);
                        const startPoint = new THREE.Vector3();
                        if (dividerRaycaster.ray.intersectPlane(plane, startPoint)) {
                            const hingeX = side === 'left'
                                ? -dims.W_int / 2 + geometry.hingeOuterRadius
                                : dims.W_int / 2 - geometry.hingeOuterRadius;
                            const hingeY = dims.H_int / 2 - dims.t / 2;
                            pushUndoSnapshot();
                            activeTwoDoorLidDrag = {
                                plane,
                                hingeX,
                                hingeY,
                                direction: side === 'left' ? 1 : -1,
                                startPointerAngle: Math.atan2(startPoint.y - hingeY, startPoint.x - hingeX),
                                startAngle: twoDoorLid.openProgress * geometry.openAngle,
                                maxAngle: geometry.openAngle
                            };
                            canvasPointerStart.dragType = 'two-door-lid';
                            if (controls) controls.enabled = false;
                            renderer.domElement.style.cursor = 'grabbing';
                            renderer.domElement.setPointerCapture(event.pointerId);
                            event.preventDefault();
                            return;
                        }
                    }
                }
                if (doorLid.enabled && doorLidMeshes.length) {
                    const doorHits = dividerRaycaster.intersectObjects(doorLidMeshes, false);
                    if (doorHits.length) {
                        const firstHit = doorHits[0];
                        const dims = getResolvedBoxDimensions();
                        const geometry = getDoorLidGeometry(dims.W_ext, dims.D_ext, dims.t);
                        if (isDoorLidHandleHit(firstHit, geometry)) {
                            canvasPointerStart.dragType = 'door-handle';
                            showAdjustableLidHandleEditor(event, 'door');
                            event.preventDefault();
                            return;
                        }
                        if (doorLidAnimationFrame) cancelAnimationFrame(doorLidAnimationFrame);
                        doorLidAnimationFrame = 0;
                        const hitPoint = firstHit.point;
                        const plane = new THREE.Plane(new THREE.Vector3(0, 0, 1), -hitPoint.z);
                        const startPoint = new THREE.Vector3();
                        if (dividerRaycaster.ray.intersectPlane(plane, startPoint)) {
                            const hingeX = dims.W_int / 2 - geometry.hingeOuterRadius;
                            const hingeY = dims.H_int / 2 - dims.t / 2;
                            const startPointerAngle = Math.atan2(startPoint.y - hingeY, startPoint.x - hingeX);
                            pushUndoSnapshot();
                            activeDoorLidDrag = {
                                plane,
                                hingeX,
                                hingeY,
                                startPointerAngle,
                                startAngle: doorLid.openProgress * geometry.openAngle,
                                maxAngle: geometry.openAngle
                            };
                            canvasPointerStart.dragType = 'door-lid';
                            if (controls) controls.enabled = false;
                            renderer.domElement.style.cursor = 'grabbing';
                            renderer.domElement.setPointerCapture(event.pointerId);
                            event.preventDefault();
                            return;
                        }
                    }
                }

                const lid = ensureRemovableLidState();
                if (lid.enabled && removableLidMeshes.length) {
                    const lidHits = dividerRaycaster.intersectObjects(removableLidMeshes, false);
                    if (lidHits.length) {
                        if (lidAnimationFrame) cancelAnimationFrame(lidAnimationFrame);
                        lidAnimationFrame = 0;
                        const hitPoint = lidHits[0].point;
                        const planeNormal = new THREE.Vector3(
                            camera.position.x - hitPoint.x,
                            0,
                            camera.position.z - hitPoint.z
                        );
                        if (planeNormal.lengthSq() < 1e-8) planeNormal.set(0, 0, 1);
                        planeNormal.normalize();
                        const plane = new THREE.Plane().setFromNormalAndCoplanarPoint(planeNormal, hitPoint);
                        const startPoint = new THREE.Vector3();
                        if (dividerRaycaster.ray.intersectPlane(plane, startPoint)) {
                            pushUndoSnapshot();
                            const standardLift = getRemovableLidOpenLift();
                            activeLidDrag = {
                                plane,
                                startPoint: startPoint.clone(),
                                startLift: standardLift * lid.openProgress,
                                standardLift,
                                handleHit: !!(lidHits[0].object.userData && lidHits[0].object.userData.lidHandle),
                                meshStartYs: removableLidMeshes.map(mesh => ({ mesh, y: mesh.position.y }))
                            };
                            canvasPointerStart.dragType = 'lid';
                            if (controls) controls.enabled = false;
                            renderer.domElement.style.cursor = 'ns-resize';
                            renderer.domElement.setPointerCapture(event.pointerId);
                            event.preventDefault();
                            return;
                        }
                    }
                }

                if (!state.dividers.enabled || !dividerMeshes.length) return;
                const hits = dividerRaycaster.intersectObjects(dividerMeshes, false);
                if (!hits.length) return;

                const mesh = hits[0].object;
                const meta = mesh.userData && mesh.userData.divider;
                if (!meta) return;
                if (isDividerBoundaryLocked(meta.axis, meta.index)) {
                    event.preventDefault();
                    return;
                }
                const point = getPointerOnDividerPlane(event);
                if (!point) return;

                pushUndoSnapshot();

                activeDividerDrag = {
                    mesh,
                    axis: meta.axis,
                    index: meta.index,
                    startPoint: point.clone(),
                    startPosition: mesh.position.clone(),
                    W_int: meta.W_int,
                    D_int: meta.D_int,
                    ghosts: createDividerDragGhosts(meta.axis, meta.index)
                };
                if (controls) controls.enabled = false;
                renderer.domElement.setPointerCapture(event.pointerId);
                event.preventDefault();
            });

            renderer.domElement.addEventListener('pointermove', (event) => {
                if (canvasPointerStart && Math.hypot(event.clientX - canvasPointerStart.x, event.clientY - canvasPointerStart.y) > 5) {
                    canvasPointerStart.moved = true;
                }
                if (!activeDividerDrag) {
                    if (activeBottomDrag) {
                        const rect = renderer.domElement.getBoundingClientRect();
                        dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
                        dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
                        dividerRaycaster.setFromCamera(dividerPointer, camera);
                        const point = new THREE.Vector3();
                        if (!dividerRaycaster.ray.intersectPlane(activeBottomDrag.plane, point)) return;
                        state.bottomLift = Math.max(0, Math.min(
                            activeBottomDrag.maxLift,
                            activeBottomDrag.startLift + point.y - activeBottomDrag.startPoint.y
                        ));
                        renderBottomLiftControls();
                        updateSummary();
                        updateBox3D();
                        event.preventDefault();
                        return;
                    }
                    if (activeSlideLidDrag) {
                        const rect = renderer.domElement.getBoundingClientRect();
                        dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
                        dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
                        dividerRaycaster.setFromCamera(dividerPointer, camera);
                        const point = new THREE.Vector3();
                        if (!dividerRaycaster.ray.intersectPlane(activeSlideLidDrag.plane, point)) return;
                        const rawProgress = activeSlideLidDrag.startProgress +
                            (point.x - activeSlideLidDrag.startPoint.x) / activeSlideLidDrag.travel;
                        const nextProgress = Math.max(0, Math.min(3, rawProgress));
                        const positionDelta = (nextProgress - activeSlideLidDrag.startProgress) * activeSlideLidDrag.travel;
                        const slideLid = ensureSlideLidState();
                        slideLid.openProgress = nextProgress;
                        slideLid.open = nextProgress > 1e-6;
                        activeSlideLidDrag.meshStartXs.forEach(item => { item.mesh.position.x = item.x + positionDelta; });
                        renderSlideLidControls();
                        event.preventDefault();
                        return;
                    }
                    if (activeDoorLidDrag) {
                        const rect = renderer.domElement.getBoundingClientRect();
                        dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
                        dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
                        dividerRaycaster.setFromCamera(dividerPointer, camera);
                        const point = new THREE.Vector3();
                        if (!dividerRaycaster.ray.intersectPlane(activeDoorLidDrag.plane, point)) return;
                        const pointerAngle = Math.atan2(
                            point.y - activeDoorLidDrag.hingeY,
                            point.x - activeDoorLidDrag.hingeX
                        );
                        let angleDelta = activeDoorLidDrag.startPointerAngle - pointerAngle;
                        while (angleDelta > Math.PI) angleDelta -= Math.PI * 2;
                        while (angleDelta < -Math.PI) angleDelta += Math.PI * 2;
                        const rawAngle = activeDoorLidDrag.startAngle + angleDelta;
                        const nextProgress = Math.max(0, Math.min(1, rawAngle / activeDoorLidDrag.maxAngle));
                        const lid = ensureDoorLidState();
                        lid.openProgress = nextProgress;
                        lid.open = nextProgress > 1e-6;
                        renderDoorLidControls();
                        updateBox3D();
                        event.preventDefault();
                        return;
                    }
                    if (activeTwoDoorLidDrag) {
                        const rect = renderer.domElement.getBoundingClientRect();
                        dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
                        dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
                        dividerRaycaster.setFromCamera(dividerPointer, camera);
                        const point = new THREE.Vector3();
                        if (!dividerRaycaster.ray.intersectPlane(activeTwoDoorLidDrag.plane, point)) return;
                        const pointerAngle = Math.atan2(
                            point.y - activeTwoDoorLidDrag.hingeY,
                            point.x - activeTwoDoorLidDrag.hingeX
                        );
                        let delta = pointerAngle - activeTwoDoorLidDrag.startPointerAngle;
                        while (delta > Math.PI) delta -= Math.PI * 2;
                        while (delta < -Math.PI) delta += Math.PI * 2;
                        const rawAngle = activeTwoDoorLidDrag.startAngle + activeTwoDoorLidDrag.direction * delta;
                        const nextProgress = Math.max(0, Math.min(1, rawAngle / activeTwoDoorLidDrag.maxAngle));
                        const lid = ensureTwoDoorLidState();
                        lid.openProgress = nextProgress;
                        lid.open = nextProgress > 1e-6;
                        renderTwoDoorLidControls();
                        updateBox3D();
                        event.preventDefault();
                        return;
                    }
                    if (activeLidDrag) {
                        const rect = renderer.domElement.getBoundingClientRect();
                        dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
                        dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
                        dividerRaycaster.setFromCamera(dividerPointer, camera);
                        const point = new THREE.Vector3();
                        if (!dividerRaycaster.ray.intersectPlane(activeLidDrag.plane, point)) return;
                        const nextLift = Math.max(0, activeLidDrag.startLift + point.y - activeLidDrag.startPoint.y);
                        const liftDelta = nextLift - activeLidDrag.startLift;
                        const lid = ensureRemovableLidState();
                        lid.openProgress = nextLift / activeLidDrag.standardLift;
                        lid.open = nextLift > 1e-6;
                        activeLidDrag.meshStartYs.forEach(item => { item.mesh.position.y = item.y + liftDelta; });
                        renderRemovableLidControls();
                        event.preventDefault();
                    }
                    return;
                }
                const point = getPointerOnDividerPlane(event);
                if (!point) return;
                const drag = activeDividerDrag;
                const d = state.dividers;

                if (drag.axis === 'width') {
                    const rawX = drag.startPosition.x + (point.x - drag.startPoint.x);
                    const rawPosition = (rawX + drag.W_int / 2) / drag.W_int;
                    const nextPosition = clampDraggedDividerPosition(
                        d.widthPositions, drag.index, rawPosition, drag.W_int, state.thickness, 'width'
                    );
                    const nextX = nextPosition * drag.W_int - drag.W_int / 2;
                    dividerMeshes.forEach(mesh => {
                        const meta = mesh.userData && mesh.userData.divider;
                        if (meta && meta.axis === 'width' && meta.index === drag.index) mesh.position.x = nextX;
                    });
                    d.widthPositions[drag.index] = nextPosition;
                } else {
                    const rawZ = drag.startPosition.z + (point.z - drag.startPoint.z);
                    const rawPosition = (rawZ + drag.D_int / 2) / drag.D_int;
                    const nextPosition = clampDraggedDividerPosition(
                        d.depthPositions, drag.index, rawPosition, drag.D_int, state.thickness, 'depth'
                    );
                    const nextZ = nextPosition * drag.D_int - drag.D_int / 2;
                    dividerMeshes.forEach(mesh => {
                        const meta = mesh.userData && mesh.userData.divider;
                        if (meta && meta.axis === 'depth' && meta.index === drag.index) mesh.position.z = nextZ;
                    });
                    d.depthPositions[drag.index] = nextPosition;
                }
                renderDividerControls();
                event.preventDefault();
            });

            const finishDividerDrag = (event) => {
                if (!activeDividerDrag) return;
                removeDividerDragGhosts(activeDividerDrag.ghosts);
                activeDividerDrag = null;
                if (controls) controls.enabled = true;
                if (renderer.domElement.hasPointerCapture(event.pointerId)) {
                    renderer.domElement.releasePointerCapture(event.pointerId);
                }
                updateAll();
            };

            renderer.domElement.addEventListener('pointerup', finishDividerDrag);
            renderer.domElement.addEventListener('pointercancel', finishDividerDrag);
            const finishBottomDrag = (event) => {
                if (!activeBottomDrag) return;
                activeBottomDrag = null;
                if (controls) controls.enabled = true;
                renderer.domElement.style.cursor = '';
                if (renderer.domElement.hasPointerCapture(event.pointerId)) {
                    renderer.domElement.releasePointerCapture(event.pointerId);
                }
                updateAll();
                if (event.type === 'pointerup') showBottomLiftEditor(event);
            };
            renderer.domElement.addEventListener('pointerup', finishBottomDrag);
            renderer.domElement.addEventListener('pointercancel', finishBottomDrag);
            const finishSlideLidDrag = (event) => {
                if (!activeSlideLidDrag) return;
                activeSlideLidDrag = null;
                if (controls) controls.enabled = true;
                renderer.domElement.style.cursor = '';
                if (renderer.domElement.hasPointerCapture(event.pointerId)) {
                    renderer.domElement.releasePointerCapture(event.pointerId);
                }
                updateAll();
            };
            renderer.domElement.addEventListener('pointerup', finishSlideLidDrag);
            renderer.domElement.addEventListener('pointercancel', finishSlideLidDrag);
            const finishDoorLidDrag = (event) => {
                if (!activeDoorLidDrag) return;
                activeDoorLidDrag = null;
                if (controls) controls.enabled = true;
                renderer.domElement.style.cursor = '';
                if (renderer.domElement.hasPointerCapture(event.pointerId)) {
                    renderer.domElement.releasePointerCapture(event.pointerId);
                }
                updateAll();
            };
            renderer.domElement.addEventListener('pointerup', finishDoorLidDrag);
            renderer.domElement.addEventListener('pointercancel', finishDoorLidDrag);
            const finishTwoDoorLidDrag = (event) => {
                if (!activeTwoDoorLidDrag) return;
                activeTwoDoorLidDrag = null;
                if (controls) controls.enabled = true;
                renderer.domElement.style.cursor = '';
                if (renderer.domElement.hasPointerCapture(event.pointerId)) {
                    renderer.domElement.releasePointerCapture(event.pointerId);
                }
                updateAll();
            };
            renderer.domElement.addEventListener('pointerup', finishTwoDoorLidDrag);
            renderer.domElement.addEventListener('pointercancel', finishTwoDoorLidDrag);
            const finishLidDrag = (event) => {
                if (!activeLidDrag) return;
                const showHandleEditor = activeLidDrag.handleHit && canvasPointerStart && !canvasPointerStart.moved;
                activeLidDrag = null;
                if (controls) controls.enabled = true;
                renderer.domElement.style.cursor = '';
                if (renderer.domElement.hasPointerCapture(event.pointerId)) {
                    renderer.domElement.releasePointerCapture(event.pointerId);
                }
                updateAll();
                if (showHandleEditor) showLidHandleEditor(event);
            };
            renderer.domElement.addEventListener('pointerup', finishLidDrag);
            renderer.domElement.addEventListener('pointercancel', finishLidDrag);
            renderer.domElement.addEventListener('pointerup', event => {
                const pointer = canvasPointerStart;
                canvasPointerStart = null;
                if (pointer && (pointer.dragType === 'bottom' || pointer.dragType === 'lid' || pointer.dragType === 'slide-lid' ||
                    pointer.dragType === 'door-lid' || pointer.dragType === 'two-door-lid' ||
                    pointer.dragType === 'door-handle' || pointer.dragType === 'two-door-handle')) return;
                if (pointer && !pointer.moved && !selectDividerAtEvent(event, 'divider')) selectCellAtEvent(event);
            });
            renderer.domElement.addEventListener('pointercancel', () => { canvasPointerStart = null; });

            renderer.domElement.addEventListener('dblclick', (event) => {
                if (state.foldPercent > 8) return;
                if (selectDividerAtEvent(event, 'segment')) {
                    event.preventDefault();
                    return;
                }
                clearModelSelection(false);
                const rect = renderer.domElement.getBoundingClientRect();
                dividerPointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
                dividerPointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
                dividerRaycaster.setFromCamera(dividerPointer, camera);

                const boxPanels = panelMeshes.filter(mesh => mesh.userData && mesh.userData.panelName);
                const hits = dividerRaycaster.intersectObjects(boxPanels, false);
                if (!hits.length) return;

                const hit = hits[0];
                const panelName = hit.object.userData.panelName;
                const dims = getResolvedBoxDimensions();
                const localX = Math.max(0, Math.min(dims.W_int, hit.point.x + dims.W_int / 2));
                const localDepth = Math.max(0, Math.min(dims.D_int, hit.point.z + dims.D_int / 2));
                let axis;
                let position;

                if (panelName === 'Back' || panelName === 'Front') {
                    axis = 'width';
                    position = localX / dims.W_int;
                } else if (panelName === 'Left' || panelName === 'Right') {
                    axis = 'depth';
                    position = localDepth / dims.D_int;
                } else if (panelName === 'Bottom') {
                    const widthSpan = getDividerCellSpanAt(localX, state.dividers.widthPositions, dims.W_int, dims.t);
                    const depthSpan = getDividerCellSpanAt(localDepth, state.dividers.depthPositions, dims.D_int, dims.t);
                    axis = widthSpan >= depthSpan ? 'width' : 'depth';
                    position = axis === 'width' ? localX / dims.W_int : localDepth / dims.D_int;
                } else {
                    return;
                }

                addDividerAt(axis, position);
                event.preventDefault();
            });
        }

        function addSceneHelpers() {
            // No grid — model floats in empty space
        }

        function addLights() {
            ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
            scene.add(ambientLight);
            
            dirLight1 = new THREE.DirectionalLight(0xffffff, 0.8);
            dirLight1.position.set(200, 400, 300);
            dirLight1.castShadow = true;
            dirLight1.shadow.bias = -0.001;
            dirLight1.shadow.mapSize.width = 2048;
            dirLight1.shadow.mapSize.height = 2048;
            dirLight1.shadow.camera.near = 0.5;
            dirLight1.shadow.camera.far = 1500;
            const d = 400;
            dirLight1.shadow.camera.left = -d;
            dirLight1.shadow.camera.right = d;
            dirLight1.shadow.camera.top = d;
            dirLight1.shadow.camera.bottom = -d;
            scene.add(dirLight1);
            
            dirLight2 = new THREE.DirectionalLight(0xfffcf0, 0.2);
            dirLight2.position.set(-200, 200, -300);
            scene.add(dirLight2);

            pointLight = new THREE.PointLight(0xfff4e0, 0.3, 600);
            pointLight.position.set(0, 100, 0);
            scene.add(pointLight);
        }

        function applyViewTheme(theme, updateButtons = true) {
            const normalizedTheme = theme === 'night' ? 'night' : 'day';
            const isNight = normalizedTheme === 'night';
            state.viewTheme = normalizedTheme;

            if (els.appRoot) {
                els.appRoot.classList.toggle('is-night', isNight);
                els.appRoot.dataset.viewTheme = normalizedTheme;
            }

            if (els.viewportContainer) {
                els.viewportContainer.classList.toggle('is-night', isNight);
                els.viewportContainer.dataset.viewTheme = normalizedTheme;
            }

            if (updateButtons && els.viewThemeButtons) {
                els.viewThemeButtons.forEach(button => {
                    const active = button.dataset.viewTheme === normalizedTheme;
                    button.classList.toggle('active', active);
                    button.setAttribute('aria-pressed', active ? 'true' : 'false');
                });
            }

            if (renderer) {
                renderer.toneMappingExposure = isNight ? 0.85 : 1.08;
                renderer.setClearColor(0x000000, 0);
            }

            if (ambientLight) {
                ambientLight.color.setHex(isNight ? 0xffffff : 0xfffbf3);
                ambientLight.intensity = isNight ? 0.6 : 0.92;
            }

            if (dirLight1) {
                dirLight1.color.setHex(isNight ? 0xffffff : 0xfff1d9);
                dirLight1.intensity = isNight ? 0.8 : 1.12;
            }

            if (dirLight2) {
                dirLight2.color.setHex(isNight ? 0xfffcf0 : 0xdceeff);
                dirLight2.intensity = isNight ? 0.2 : 0.42;
            }

            if (pointLight) {
                pointLight.color.setHex(isNight ? 0xfff4e0 : 0xffe7bd);
                pointLight.intensity = isNight ? 0.3 : 0.18;
            }
        }

        // ---- Face (cap) material: solid flat colour, no texture ----

        // ---- PLYWOOD EDGE SANDWICH TEXTURE ----
        // Three.js r128 ExtrudeGeometry sets side-face UVs as:
        //   U = distance along perimeter (in mm, e.g. 0..600)
        //   V = depth fraction (0.0 at front surface, 1.0 at back surface)
        // We draw a VERTICAL gradient (along H = V-axis) so that:
        //   V = 0 (canvas top)    → dark charred edge
        //   V ≈ 0.5 (canvas mid)  → light birch core
        //   V = 1 (canvas bottom) → dark charred edge
        // This produces the natural dark-light-dark sandwich WITHOUT any UV remapping.
        function generatePlywoodEdgeTexture() {
            const W = 4, H = 512;
            const canvas = document.createElement('canvas');
            canvas.width = W; canvas.height = H;
            const ctx = canvas.getContext('2d');

            const grad = ctx.createLinearGradient(0, 0, 0, H);
            grad.addColorStop(0.00, '#0e0804');   // V=0   front veneer — very dark
            grad.addColorStop(0.27, '#321808');   // dark veneer body
            grad.addColorStop(0.34, '#6b3518');   // transition to brownish middle
            grad.addColorStop(0.50, '#7a3d1c');   // core centre — slightly lighter brown
            grad.addColorStop(0.66, '#6b3518');   // transition back to dark
            grad.addColorStop(0.73, '#321808');   // dark veneer body
            grad.addColorStop(1.00, '#0e0804');   // V=1   back veneer — very dark
            ctx.fillStyle = grad;
            ctx.fillRect(0, 0, W, H);

            const tex = new THREE.CanvasTexture(canvas);
            // U (perimeter): repeating is fine, the colour is uniform in U direction
            tex.wrapS = THREE.RepeatWrapping;
            // V (depth fraction 0..1): clamp so edges don't bleed
            tex.wrapT = THREE.ClampToEdgeWrapping;
            tex.needsUpdate = true;
            return tex;
        }

        // Edge sandwich texture — created once at script load time
        const woodSideTexture = generatePlywoodEdgeTexture();

        // Face (cap): solid flat colour, no texture
        const woodCapMaterial = new THREE.MeshStandardMaterial({
            color:     0xcdc8c0,
            roughness: 0.82,
            metalness: 0.0,
            side:      THREE.DoubleSide
        });

        // Edge: plywood sandwich texture
        const woodSideMaterial = new THREE.MeshStandardMaterial({
            map:       woodSideTexture,
            roughness: 0.85,
            metalness: 0.0
        });

        // Charred/burned wood material for laser-cut notches
        const woodBurnedMaterial = new THREE.MeshStandardMaterial({
            color:     0x1a110a, // dark charred wood color
            roughness: 0.9,
            metalness: 0.0
        });

        function add3DNotches(mesh, w, h, T, f, edges) {
            if (!state.addNotches) return;
            
            const R = state.notchDiameter / 2;
            const E = [
                { S: [0, 0], d: [1, 0],  L: w, nrm: [0, -1] },  // bottom
                { S: [w, 0], d: [0, 1],  L: h, nrm: [1, 0] },   // right
                { S: [w, h], d: [-1, 0], L: w, nrm: [0, 1] },   // top
                { S: [0, h], d: [0, -1], L: h, nrm: [-1, 0] }   // left
            ];
            
            const ox = w / 2;
            const oy = h / 2;
            
            // Recess the notch cylinder by only 0.025 mm on each end to make it wider and extremely close to the edges
            const cylinderHeight = Math.max(0.1, T - 0.05);
            const cylGeom = new THREE.CylinderGeometry(R, R, cylinderHeight, 16);
            // Rotate so cylinder axis is along Z
            cylGeom.rotateX(Math.PI / 2);
            
            edges.forEach((type, i) => {
                if (type !== 'B') return;
                const iv = protrusionIntervals(E[i].L, f, T, 'B');
                if (!iv) return;
                
                iv.forEach(([a, b]) => {
                    // Left notch
                    if (a >= R) {
                        const x = E[i].S[0] + E[i].d[0] * a + E[i].nrm[0] * (T / 2);
                        const y = E[i].S[1] + E[i].d[1] * a + E[i].nrm[1] * (T / 2);
                        const notchMesh = new THREE.Mesh(cylGeom, [woodSideMaterial, woodBurnedMaterial, woodBurnedMaterial]);
                        notchMesh.castShadow = true;
                        notchMesh.receiveShadow = true;
                        notchMesh.position.set(x - ox, y - oy, T / 2);
                        mesh.add(notchMesh);
                    }
                    // Right notch
                    if (b <= E[i].L - R) {
                        const x = E[i].S[0] + E[i].d[0] * b + E[i].nrm[0] * (T / 2);
                        const y = E[i].S[1] + E[i].d[1] * b + E[i].nrm[1] * (T / 2);
                        const notchMesh = new THREE.Mesh(cylGeom, [woodSideMaterial, woodBurnedMaterial, woodBurnedMaterial]);
                        notchMesh.castShadow = true;
                        notchMesh.receiveShadow = true;
                        notchMesh.position.set(x - ox, y - oy, T / 2);
                        mesh.add(notchMesh);
                    }
                });
            });
        }

        function getDividerCellBoundsByIndex(index, positions, length, t) {
            const sizes = getDividerCellSizes(positions, length, t);
            const safeIndex = Math.max(0, Math.min(sizes.length - 1, index));
            let start = 0;
            for (let i = 0; i < safeIndex; i++) start += sizes[i] + t;
            return {
                index: safeIndex,
                start,
                end: start + sizes[safeIndex],
                size: sizes[safeIndex],
                center: start + sizes[safeIndex] / 2
            };
        }

        function getMergedDividerCell(widthCellIndex, depthCellIndex, W_int, D_int, t) {
            const widthCount = state.dividers.widthPositions.length + 1;
            const depthCount = state.dividers.depthPositions.length + 1;
            const startWidth = Math.max(0, Math.min(widthCount - 1, widthCellIndex));
            const startDepth = Math.max(0, Math.min(depthCount - 1, depthCellIndex));
            const cells = [];
            const visited = new Set([`${startWidth}:${startDepth}`]);
            const queue = [{ widthCellIndex: startWidth, depthCellIndex: startDepth }];

            while (queue.length) {
                const cell = queue.shift();
                cells.push(cell);
                const w = cell.widthCellIndex;
                const d = cell.depthCellIndex;
                const neighbors = [];
                if (w > 0 && isDividerSegmentRemoved('width', w - 1, d)) neighbors.push({ widthCellIndex: w - 1, depthCellIndex: d });
                if (w < widthCount - 1 && isDividerSegmentRemoved('width', w, d)) neighbors.push({ widthCellIndex: w + 1, depthCellIndex: d });
                if (d > 0 && isDividerSegmentRemoved('depth', d - 1, w)) neighbors.push({ widthCellIndex: w, depthCellIndex: d - 1 });
                if (d < depthCount - 1 && isDividerSegmentRemoved('depth', d, w)) neighbors.push({ widthCellIndex: w, depthCellIndex: d + 1 });
                neighbors.forEach(neighbor => {
                    const key = `${neighbor.widthCellIndex}:${neighbor.depthCellIndex}`;
                    if (visited.has(key)) return;
                    visited.add(key);
                    queue.push(neighbor);
                });
            }

            const widthBounds = cells.map(cell => getDividerCellBoundsByIndex(cell.widthCellIndex, state.dividers.widthPositions, W_int, t));
            const depthBounds = cells.map(cell => getDividerCellBoundsByIndex(cell.depthCellIndex, state.dividers.depthPositions, D_int, t));
            const minWidthCell = Math.min(...cells.map(cell => cell.widthCellIndex));
            const maxWidthCell = Math.max(...cells.map(cell => cell.widthCellIndex));
            const minDepthCell = Math.min(...cells.map(cell => cell.depthCellIndex));
            const maxDepthCell = Math.max(...cells.map(cell => cell.depthCellIndex));
            const bounds = {
                startX: Math.min(...widthBounds.map(bound => bound.start)),
                endX: Math.max(...widthBounds.map(bound => bound.end)),
                startDepth: Math.min(...depthBounds.map(bound => bound.start)),
                endDepth: Math.max(...depthBounds.map(bound => bound.end))
            };
            return {
                widthCellIndex: startWidth,
                depthCellIndex: startDepth,
                cells,
                bounds,
                isRectangular: cells.length === (maxWidthCell - minWidthCell + 1) * (maxDepthCell - minDepthCell + 1)
            };
        }

        let cellLockMarkerTexture = null;
        function getCellLockMarkerTexture() {
            if (cellLockMarkerTexture) return cellLockMarkerTexture;
            const canvas = document.createElement('canvas');
            canvas.width = 96;
            canvas.height = 96;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = 'rgba(18, 34, 48, 0.88)';
            ctx.beginPath();
            ctx.roundRect(18, 38, 60, 45, 9);
            ctx.fill();
            ctx.strokeStyle = '#dff7ff';
            ctx.lineWidth = 8;
            ctx.beginPath();
            ctx.arc(48, 40, 19, Math.PI, 0);
            ctx.stroke();
            ctx.fillStyle = '#dff7ff';
            ctx.beginPath();
            ctx.arc(48, 58, 6, 0, Math.PI * 2);
            ctx.fill();
            cellLockMarkerTexture = new THREE.CanvasTexture(canvas);
            return cellLockMarkerTexture;
        }

        function addCellSelectionVisuals(W_int, H_int, D_int, t, assemblyProgress) {
            if (state.boxType !== 'open' || assemblyProgress > 0.08) return;
            const addVisual = visual => {
                visual.raycast = () => {};
                panelGroup.add(visual);
                cellVisuals.push(visual);
            };
            const floorY = -H_int / 2 + state.bottomLift + 0.08;

            if (hoveredDividerSegment && hoveredDividerSegment.selectionType === 'segment') {
                const selection = hoveredDividerSegment;
                const isWidthAxis = selection.axis === 'width';
                const crossPositions = isWidthAxis ? state.dividers.depthPositions : state.dividers.widthPositions;
                const length = isWidthAxis ? D_int : W_int;
                const centers = normalizeDividerPositions(crossPositions).map(position => position * length);
                const start = selection.segmentStart === 0 ? 0 : centers[selection.segmentStart - 1];
                const end = selection.segmentEnd >= centers.length ? length : centers[selection.segmentEnd];
                const span = Math.max(0.01, end - start);
                const geometry = isWidthAxis
                    ? new THREE.BoxGeometry(t + 0.24, H_int + 0.24, span)
                    : new THREE.BoxGeometry(span, H_int + 0.24, t + 0.24);
                const material = new THREE.MeshBasicMaterial({
                    color: 0x54c7e8,
                    transparent: true,
                    opacity: 0.34,
                    depthWrite: false
                });
                const highlight = new THREE.Mesh(geometry, material);
                if (isWidthAxis) {
                    highlight.position.set(
                        state.dividers.widthPositions[selection.dividerIndex] * W_int - W_int / 2,
                        0,
                        (start + end) / 2 - D_int / 2
                    );
                } else {
                    highlight.position.set(
                        (start + end) / 2 - W_int / 2,
                        0,
                        state.dividers.depthPositions[selection.dividerIndex] * D_int - D_int / 2
                    );
                }
                highlight.renderOrder = 10;
                highlight.userData.ownGeometry = true;
                addVisual(highlight);
            }

            if (hoveredCell) {
                const merged = getMergedDividerCell(hoveredCell.widthCellIndex, hoveredCell.depthCellIndex, W_int, D_int, t);
                const regions = merged.isRectangular
                    ? [{
                        x: merged.bounds.startX,
                        z: merged.bounds.startDepth,
                        width: merged.bounds.endX - merged.bounds.startX,
                        depth: merged.bounds.endDepth - merged.bounds.startDepth
                    }]
                    : merged.cells.map(cell => {
                        const width = getDividerCellBoundsByIndex(cell.widthCellIndex, state.dividers.widthPositions, W_int, t);
                        const depth = getDividerCellBoundsByIndex(cell.depthCellIndex, state.dividers.depthPositions, D_int, t);
                        return { x: width.start, z: depth.start, width: width.size, depth: depth.size };
                    });
                regions.forEach(region => {
                    const geometry = new THREE.PlaneGeometry(Math.max(0.01, region.width), Math.max(0.01, region.depth));
                    const material = new THREE.MeshBasicMaterial({
                        color: 0x4fc3e8,
                        transparent: true,
                        opacity: 0.24,
                        side: THREE.DoubleSide,
                        depthWrite: false
                    });
                    const highlight = new THREE.Mesh(geometry, material);
                    highlight.position.set(region.x + region.width / 2 - W_int / 2, floorY, region.z + region.depth / 2 - D_int / 2);
                    highlight.rotation.x = -Math.PI / 2;
                    highlight.renderOrder = 8;
                    highlight.userData.ownGeometry = true;
                    addVisual(highlight);
                });
            }

            Object.values(ensureLockedSectionStore()).forEach(section => {
                if (!section) return;
                const width = getDividerCellBoundsByIndex(section.widthCellIndex, state.dividers.widthPositions, W_int, t);
                const depth = getDividerCellBoundsByIndex(section.depthCellIndex, state.dividers.depthPositions, D_int, t);
                const material = new THREE.SpriteMaterial({
                    map: getCellLockMarkerTexture(),
                    transparent: true,
                    depthTest: false,
                    depthWrite: false
                });
                const marker = new THREE.Sprite(material);
                const markerSize = Math.max(4.5, Math.min(8, Math.min(width.size, depth.size) * 0.22));
                marker.scale.set(markerSize, markerSize, 1);
                marker.position.set(width.center - W_int / 2, floorY + 0.35, depth.center - D_int / 2);
                marker.renderOrder = 9;
                addVisual(marker);
            });
        }

        function updateBox3D() {
            dividerMeshes.length = 0;
            removableLidMeshes.length = 0;
            slideLidMeshes.length = 0;
            doorLidMeshes.length = 0;
            twoDoorLidMeshes.length = 0;
            while (cellVisuals.length > 0) {
                const visual = cellVisuals.pop();
                panelGroup.remove(visual);
                if (visual.userData.ownGeometry && visual.geometry) visual.geometry.dispose();
                if (visual.material) visual.material.dispose();
            }
            while (panelMeshes.length > 0) {
                const mesh = panelMeshes.pop();
                panelGroup.remove(mesh);
                mesh.geometry.dispose();
                if (mesh.userData && mesh.userData.ownsDividerMaterials) {
                    const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
                    materials.forEach(material => material.dispose());
                }
            }

            const { t, isOpen, W_ext, H_ext, D_ext, W_int, H_int, D_int, bottomLift } = getResolvedBoxDimensions();
            const removableLid = ensureRemovableLidState();
            const slideLid = ensureSlideLidState();
            const doorLid = ensureDoorLidState();
            const twoDoorLid = ensureTwoDoorLidState();

            // Gap between panels in the flat cross net layout
            const GAP = 4 * t;
            // How far each panel flies outward in the exploded intermediate state
            const EXP = 4 * t;
            const raisedBottom = bottomLift > 1e-7;
            const wallPanelHeight = H_int + (raisedBottom ? t : 0);
            const wallCenterY = raisedBottom ? -t / 2 : 0;
            const slideExitWallHeight = Math.min(H_int, Math.max(t, H_ext - 2 * t));
            const rightWallCut = slideLid.enabled && isOpen ? Math.max(0, H_int - slideExitWallHeight) : 0;
            const rightWallHeight = Math.max(t, wallPanelHeight - rightWallCut);
            const rightWallCenterY = wallCenterY - rightWallCut / 2;

            // Three-state animation:
            //  flatPos/flatRot      (s=0)   : flat cross net, all panels face viewer
            //  explodedPos/Rot      (s=0.5) : panels in box orientation but blown apart
            //  assembledPos/Rot     (s=1)   : final assembled box
            //
            // Cross layout:
            //        [Top]
            //        [Back]
            // [Left] [Bottom] [Right]
            //        [Front]
            const panelsDef = [
                {
                    name: 'Bottom',
                    w: W_int, h: D_int,
                    edges: raisedBottom ? ['A', 'A', 'A', 'A'] : ['B', 'B', 'B', 'B'],
                    flatPos:      { x: 0,                             y: 0,                                   z: 0 },
                    flatRot:      { x: 0, y: 0, z: 0 },
                    explodedPos:  { x: 0,                             y: -H_ext/2 - EXP - 0.01,               z: 0 },
                    explodedRot:  { x: -Math.PI/2,                    y: 0,                                   z: 0 },
                    assembledPos: { x: 0,                             y: -H_ext/2 - 0.01,                     z: 0 },
                    assembledRot: { x: -Math.PI/2,                    y: 0,                                   z: 0 }
                },
                {
                    name: 'Back',
                    w: W_int, h: wallPanelHeight,
                    edges: [raisedBottom ? 'flat' : 'A', 'B', isOpen ? (slideLid.enabled ? 'A' : 'flat') : 'A', 'B'],
                    raisedBottomSlotEdge: raisedBottom ? 'bottom' : null,
                    sideSlotEdge: isOpen ? 'top' : null,
                    doorHingeEdge: doorLid.enabled && isOpen ? 'top' : null,
                    twoDoorHingeEdge: twoDoorLid.enabled && isOpen ? 'top' : null,
                    twoDoorHandleEdge: twoDoorLid.enabled && isOpen ? 'top' : null,
                    flatPos:      { x: 0,                             y: D_int/2 + wallPanelHeight/2 + GAP,   z: 0 },
                    flatRot:      { x: 0, y: 0, z: 0 },
                    explodedPos:  { x: 0,                             y: 0,                                   z: -D_ext/2 - EXP - 0.01 },
                    explodedRot:  { x: -Math.PI/2,                    y: 0,                                   z: 0 },
                    assembledPos: { x: 0,                             y: wallCenterY,                         z: -D_ext/2 - 0.01 },
                    assembledRot: { x: 0,                             y: 0,                                   z: 0 }
                },
                {
                    name: 'Top',
                    w: W_int, h: D_int,
                    edges: ['B', 'B', 'B', 'B'],
                    flatPos:      { x: 0,                             y: D_int/2 + wallPanelHeight + D_int/2 + 2*GAP, z: 0 },
                    flatRot:      { x: Math.PI/2,                     y: 0,                                   z: 0 },
                    explodedPos:  { x: 0,                             y: H_ext/2 + EXP + 0.01,                z: 0 },
                    explodedRot:  { x: Math.PI/2,                     y: 0,                                   z: 0 },
                    assembledPos: { x: 0,                             y: H_ext/2 + 0.01,                      z: 0 },
                    assembledRot: { x: Math.PI/2,                     y: 0,                                   z: 0 }
                },
                {
                    name: 'Front',
                    w: W_int, h: wallPanelHeight,
                    edges: [raisedBottom ? 'flat' : 'A', 'B', isOpen ? (slideLid.enabled ? 'A' : 'flat') : 'A', 'B'],
                    raisedBottomSlotEdge: raisedBottom ? 'bottom' : null,
                    sideSlotEdge: isOpen ? 'top' : null,
                    doorHingeEdge: doorLid.enabled && isOpen ? 'top' : null,
                    twoDoorHingeEdge: twoDoorLid.enabled && isOpen ? 'top' : null,
                    twoDoorHandleEdge: twoDoorLid.enabled && isOpen ? 'top' : null,
                    flatPos:      { x: 0,                             y: -(D_int/2 + wallPanelHeight/2 + GAP), z: 0 },
                    flatRot:      { x: -Math.PI, y: 0, z: 0 },
                    explodedPos:  { x: 0,                             y: 0,                                   z: D_int/2 + EXP + 0.01 },
                    explodedRot:  { x: Math.PI/2,                     y: 0,                                   z: 0 },
                    assembledPos: { x: 0,                             y: wallCenterY,                         z: D_int/2 + 0.01 },
                    assembledRot: { x: 0,                             y: 0,                                   z: 0 }
                },
                {
                    name: 'Left',
                    w: D_int, h: wallPanelHeight,
                    edges: [raisedBottom ? 'flat' : 'A', 'A', isOpen ? (slideLid.enabled ? 'A' : 'flat') : 'A', 'A'],
                    raisedBottomSlotEdge: raisedBottom ? 'bottom' : null,
                    sideSlotEdge: isOpen ? 'top' : null,
                    doorHandleEdge: doorLid.enabled && isOpen ? 'top' : null,
                    flatPos:      { x: -(W_int/2 + wallPanelHeight/2 + GAP), y: 0,                            z: 0 },
                    flatRot:      { x: 0,                           y: 0,                                   z: Math.PI/2 },
                    explodedPos:  { x: -W_ext/2 - EXP - 0.01,        y: 0,                                    z: 0 },
                    explodedRot:  { x: -Math.PI/2,                    y: Math.PI/2,                           z: 0 },
                    assembledPos: { x: -W_ext/2 - 0.01,               y: wallCenterY,                          z: 0 },
                    assembledRot: { x: 0,                             y: Math.PI/2,                           z: 0 }
                },
                {
                    name: 'Right',
                    w: D_int, h: rightWallHeight,
                    edges: [raisedBottom ? 'flat' : 'A', 'A', isOpen ? 'flat' : 'A', 'A'],
                    raisedBottomSlotEdge: raisedBottom ? 'bottom' : null,
                    edgeProfiles: slideLid.enabled && isOpen ? [
                        null,
                        { length: wallPanelHeight, offset: 0 },
                        null,
                        { length: wallPanelHeight, offset: rightWallCut }
                    ] : null,
                    sideSlotEdge: isOpen ? 'top' : null,
                    flatPos:      { x: W_int/2 + rightWallHeight/2 + GAP, y: 0,                                 z: 0 },
                    flatRot:      { x: 0,                           y: 0,                                   z: -Math.PI/2 },
                    explodedPos:  { x: W_ext/2 + EXP + 0.01,         y: rightWallCenterY,                     z: 0 },
                    explodedRot:  { x: -Math.PI/2,                    y: -Math.PI/2,                          z: 0 },
                    assembledPos: { x: W_ext/2 + 0.01,                 y: rightWallCenterY,                     z: 0 },
                    assembledRot: { x: 0,                             y: -Math.PI/2,                          z: 0 }
                }
            ];

            // Bottom/Top sit exactly one wall-thickness beyond the internal cavity edge,
            // regardless of whether the opposite panel (Top, in open boxes) exists —
            // using H_ext/2 here would shift Bottom when H_ext isn't symmetric (open boxes).
            const hOuter = H_int / 2 + t;
            const bottomExplodedY = -hOuter - EXP - 0.01;
            
            panelsDef[0].explodedPos.y = bottomExplodedY;
            panelsDef[0].assembledPos.y = -hOuter + bottomLift - 0.01;
            
            panelsDef[2].explodedPos.y = bottomExplodedY;
            panelsDef[2].assembledPos.y = H_int/2 + t + 0.01; // Maintain exact physical top level when assembled

            // Align all sides to the bottom panel level in the exploded view
            panelsDef[1].explodedPos.y = bottomExplodedY;
            panelsDef[2].explodedPos.y = bottomExplodedY + t;
            panelsDef[3].explodedPos.y = bottomExplodedY + t;
            panelsDef[4].explodedPos.y = bottomExplodedY;
            panelsDef[5].explodedPos.y = bottomExplodedY;

            // Set their X and Z exploded positions so they lay flat around the Bottom panel
            panelsDef[1].explodedPos.z = -D_int/2 - wallPanelHeight/2 - EXP;
            panelsDef[3].explodedPos.z = D_int/2 + wallPanelHeight/2 + EXP;
            panelsDef[4].explodedPos.x = -W_int/2 - wallPanelHeight/2 - EXP;
            panelsDef[5].explodedPos.x = W_int/2 + wallPanelHeight/2 + EXP;

            // Set Top cover exploded position (flat behind Back panel)
            panelsDef[2].explodedPos.z = -D_int/2 - wallPanelHeight - D_int/2 - 2 * EXP;

            const s = state.foldPercent / 100;
            const slideInstructionEnabled = slideLid.enabled && isOpen;
            const doorInstructionEnabled = (doorLid.enabled || twoDoorLid.enabled) && isOpen;
            const slideEjectEnd = 0.2;
            const slideSideStageEnd = 0.36;
            const doorOpenEnd = 0.22;
            const doorWallStageEnd = 0.38;
            const doorLidLiftEnd = 0.52;
            const slideRailLiftLayoutProgress = Math.sqrt(0.30 / 2);
            const slideRailLiftEnd = slideSideStageEnd + (1 - slideSideStageEnd) * slideRailLiftLayoutProgress;
            const slideLayoutProgress = slideInstructionEnabled
                ? Math.max(0, Math.min(1, (s - slideSideStageEnd) / (1 - slideSideStageEnd)))
                : (doorInstructionEnabled
                    ? Math.max(0, Math.min(1, (s - doorLidLiftEnd) / (1 - doorLidLiftEnd)))
                    : s);

            // Custom UV generator for ExtrudeGeometry:
            // • generateTopUV:      raw local XY in mm — face texture handles mapping via
            //                       texture.repeat = 1/SCALE and texture.offset = 0.5
            // • generateSideWallUV: the DEFAULT r128 formula is V = 1 - z_mm, which for a
            //                       3mm panel gives V ∈ [-2, 1].  Negative V clamps to 0
            //                       (dark) with ClampToEdgeWrapping, making the whole edge
            //                       dark.  Instead we compute V = z / depth ∈ [0, 1] so
            //                       that V=0 (front veneer) = dark, V=0.5 (core) = light,
            //                       V=1 (back veneer) = dark — the correct plywood sandwich.
            const extrudeSettings = {
                steps: 1,
                depth: t,
                bevelEnabled: false,
                UVGenerator: {
                    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
                        var a_x = vertices[indexA * 3], a_y = vertices[indexA * 3 + 1];
                        var b_x = vertices[indexB * 3], b_y = vertices[indexB * 3 + 1];
                        var c_x = vertices[indexC * 3], c_y = vertices[indexC * 3 + 1];
                        return [
                            new THREE.Vector2(a_x, a_y),
                            new THREE.Vector2(b_x, b_y),
                            new THREE.Vector2(c_x, c_y)
                        ];
                    },
                    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
                        // V = z / thickness → always in [0, 1]
                        // U = 0..1: we don't care (edge texture is uniform in U direction)
                        var va = vertices[indexA * 3 + 2] / t;
                        var vb = vertices[indexB * 3 + 2] / t;
                        var vc = vertices[indexC * 3 + 2] / t;
                        var vd = vertices[indexD * 3 + 2] / t;
                        return [
                            new THREE.Vector2(0, va),
                            new THREE.Vector2(0, vb),
                            new THREE.Vector2(1, vc),
                            new THREE.Vector2(1, vd)
                        ];
                    }
                }
            };

            panelsDef.forEach(def => {
                if (state.boxType === 'open' && def.name === 'Top') return;

                const panelDims = { W_int, H_int, D_int, t };
                const outerCmds = getPanelOuterCommands(def, panelDims, true);
                const shape = new THREE.Shape();
                const ox = def.w / 2;
                const oy = def.h / 2;

                appendCommandsToThreePath(shape, outerCmds, ox, oy);
                shape.closePath();

                if (state.dividers.enabled) {
                    createDividerCutouts(def, panelDims).forEach(cut => {
                        const hole = new THREE.Path();
                        appendCommandsToThreePath(hole, cut.cmds, ox, oy);
                        hole.closePath();
                        shape.holes.push(hole);
                    });
                }

                if (def.raisedBottomSlotEdge) {
                    getRaisedBottomWallSlots(def.w, def.h, t, bottomLift, def.raisedBottomSlotEdge).forEach(cut => {
                        const hole = new THREE.Path();
                        appendCommandsToThreePath(hole, cut.cmds, ox, oy);
                        hole.closePath();
                        shape.holes.push(hole);
                    });
                }

                if (slideLid.enabled && isOpen && (def.name === 'Back' || def.name === 'Front' || def.name === 'Left')) {
                    getSlideLidWallSlots(def.w, def.h, t, 'top').forEach(cut => {
                        const hole = new THREE.Path();
                        appendCommandsToThreePath(hole, cut.cmds, ox, oy);
                        hole.closePath();
                        shape.holes.push(hole);
                    });
                }

                if (doorLid.enabled && isOpen && def.doorHingeEdge) {
                    const hole = new THREE.Path();
                    appendCommandsToThreePath(hole, getDoorHingeHoleCmds(def.w, def.h, t, def.doorHingeEdge), ox, oy);
                    hole.closePath();
                    shape.holes.push(hole);
                }

                if (twoDoorLid.enabled && isOpen && def.twoDoorHingeEdge) {
                    getTwoDoorHingeHoleCmds(def.w, def.h, t, def.twoDoorHingeEdge).forEach(holeCmds => {
                        const hole = new THREE.Path();
                        appendCommandsToThreePath(hole, holeCmds, ox, oy);
                        hole.closePath();
                        shape.holes.push(hole);
                    });
                }

                // ExtrudeGeometry: cap UVs = raw local XY in mm (handled by texture offset/repeat)
                //                  side UVs = {U: perimeter_mm, V: 0..1 depth fraction}
                // No manual UV remapping needed — texture parameters handle everything.
                const geom = new THREE.ExtrudeGeometry(shape, extrudeSettings);
                const mesh = new THREE.Mesh(geom, [woodCapMaterial, woodSideMaterial]);
                mesh.userData.panelName = def.name;
                mesh.castShadow = true;
                mesh.receiveShadow = true;
                
                add3DNotches(mesh, def.w, def.h, t, state.fingerSize, def.edges);



                // Animation transition from fully assembled box (s = 0) to lying flat layout on floor (s = 1)
                const ease = x => x < 0.5 ? 2*x*x : 1 - Math.pow(-2*x + 2, 2) / 2;
                const lerp = (a, b, k) => a + (b - a) * k;

                let px, py, pz, rx, ry, rz;
                const p = ease(slideLayoutProgress);
                const wallStageXDirection = def.name === 'Left' ? -1 : (def.name === 'Right' ? 1 : 0);
                const wallStageZDirection = def.name === 'Back' ? -1 : (def.name === 'Front' ? 1 : 0);
                const sideStageRaw = slideInstructionEnabled
                    ? Math.max(0, Math.min(1, (s - slideEjectEnd) / (slideSideStageEnd - slideEjectEnd)))
                    : 0;
                const wallStageDistance = 6 * t;
                const sideStageOffsetX = wallStageXDirection * wallStageDistance * ease(sideStageRaw);
                const sideStageOffsetZ = wallStageZDirection * wallStageDistance * ease(sideStageRaw);
                const doorWallDirection = def.name === 'Back' ? -1 : (def.name === 'Front' ? 1 : 0);
                const doorWallStageRaw = doorInstructionEnabled
                    ? Math.max(0, Math.min(1, (s - doorOpenEnd) / (doorWallStageEnd - doorOpenEnd)))
                    : 0;
                const doorWallStageOffsetZ = doorWallDirection * wallStageDistance * ease(doorWallStageRaw);
                const sequenceStartX = def.assembledPos.x + (slideInstructionEnabled ? wallStageXDirection * wallStageDistance : 0);
                const sequenceStartZ = def.assembledPos.z
                    + (slideInstructionEnabled ? wallStageZDirection * wallStageDistance : 0)
                    + (doorInstructionEnabled ? doorWallDirection * wallStageDistance : 0);

                if (doorInstructionEnabled && s < doorLidLiftEnd) {
                    px = def.assembledPos.x;
                    py = def.assembledPos.y;
                    pz = def.assembledPos.z + doorWallStageOffsetZ;
                    rx = def.assembledRot.x;
                    ry = def.assembledRot.y;
                    rz = def.assembledRot.z;
                } else if (slideInstructionEnabled && s < slideSideStageEnd) {
                    px = def.assembledPos.x + sideStageOffsetX;
                    py = def.assembledPos.y;
                    pz = def.assembledPos.z + sideStageOffsetZ;
                    rx = def.assembledRot.x;
                    ry = def.assembledRot.y;
                    rz = def.assembledRot.z;
                } else if (def.name === 'Top') {
                    const liftHeight = Math.max(t * 4, 14);
                    if (p <= 0.18) {
                        const k = ease(p / 0.18);
                        px = sequenceStartX;
                        py = lerp(def.assembledPos.y, def.assembledPos.y + liftHeight, k);
                        pz = sequenceStartZ;
                    } else if (p <= 0.38) {
                        const k = ease((p - 0.18) / 0.2);
                        px = sequenceStartX;
                        py = def.assembledPos.y + liftHeight;
                        pz = lerp(sequenceStartZ, def.explodedPos.z, k);
                    } else {
                        const k = ease((p - 0.38) / 0.62);
                        px = sequenceStartX;
                        py = lerp(def.assembledPos.y + liftHeight, def.explodedPos.y, k);
                        pz = def.explodedPos.z;
                    }
                    rx = def.assembledRot.x;
                    ry = def.assembledRot.y;
                    rz = def.assembledRot.z;
                } else {
                    // Slide outward first (p: 0 -> 0.5), then tilt & descend (p: 0.5 -> 1.0)
                    if (p <= 0.5) {
                        const k = p * 2;
                        px = lerp(sequenceStartX, def.explodedPos.x, k);
                        py = def.assembledPos.y;
                        pz = lerp(sequenceStartZ, def.explodedPos.z, k);
                        rx = def.assembledRot.x;
                        ry = def.assembledRot.y;
                        rz = def.assembledRot.z;
                    } else {
                        const k = (p - 0.5) * 2;
                        px = def.explodedPos.x;
                        py = lerp(def.assembledPos.y, def.explodedPos.y, k);
                        pz = def.explodedPos.z;
                        rx = lerp(def.assembledRot.x, def.explodedRot.x, k);
                        ry = lerp(def.assembledRot.y, def.explodedRot.y, k);
                        rz = lerp(def.assembledRot.z, def.explodedRot.z, k);
                    }
                }

                mesh.position.set(px, py, pz);
                mesh.rotation.set(rx, ry, rz, 'YXZ');

                panelGroup.add(mesh);
                panelMeshes.push(mesh);
            });

            if (s <= 0.08) {
                const handleThickness = Math.max(5, 1.8 * t);
                const handleHeight = Math.max(9, 3 * t);
                const handleY = -H_int / 2 + bottomLift - t / 2;
                const handleMaterial = new THREE.MeshBasicMaterial({
                    transparent: true,
                    opacity: 0,
                    depthWrite: false
                });
                const addBottomLiftHandle = (width, depth, x, z) => {
                    const geometry = new THREE.BoxGeometry(width, handleHeight, depth);
                    const handle = new THREE.Mesh(geometry, handleMaterial);
                    handle.position.set(x, handleY, z);
                    handle.userData.bottomLiftHandle = true;
                    handle.userData.ownGeometry = true;
                    panelGroup.add(handle);
                    cellVisuals.push(handle);
                };
                addBottomLiftHandle(W_ext, handleThickness, 0, -D_ext / 2);
                addBottomLiftHandle(W_ext, handleThickness, 0, D_ext / 2);
                addBottomLiftHandle(handleThickness, D_ext, -W_ext / 2, 0);
                addBottomLiftHandle(handleThickness, D_ext, W_ext / 2, 0);
            }

            if (doorLid.enabled && isOpen) {
                const easeDoor = x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
                const lerpDoor = (a, b, k) => a + (b - a) * k;
                const g = getDoorLidGeometry(W_ext, D_ext, t);
                const shape = new THREE.Shape();
                appendCommandsToThreePath(shape, doorLidPanelCmds(W_ext, D_ext, t), g.pivotX, g.bodyDepth / 2);
                shape.closePath();
                const geom = new THREE.ExtrudeGeometry(shape, extrudeSettings);
                geom.translate(0, 0, -t / 2);
                const mesh = new THREE.Mesh(geom, [woodCapMaterial, woodSideMaterial]);
                mesh.name = 'Door lid';
                mesh.userData.panelName = 'Door lid';
                mesh.userData.doorLid = true;
                mesh.castShadow = true;
                mesh.receiveShadow = true;

                const hingeX = W_int / 2 - g.hingeOuterRadius;
                const hingeY = H_int / 2 - t / 2;
                const currentAngle = doorLid.openProgress * g.openAngle;
                const maxInstructionAngle = g.openAngle;
                const mainLayoutRight = W_int / 2 + wallPanelHeight + GAP;
                const dividerLayoutGap = Math.max(2 * t, 2);
                const widthDividerPieceCount = state.dividers && state.dividers.enabled
                    ? state.dividers.widthPositions.reduce((count, position, index) => (
                        count + getDividerRuns('width', index, D_int, t, state.dividers.depthPositions).length
                    ), 0)
                    : 0;
                const widthDividerHeight = isOpen
                    ? Math.max(t, H_int - t - bottomLift)
                    : Math.max(t, H_int - bottomLift);
                const dividerJointAllowance = widthDividerPieceCount && state.dividers.addBottomSlots ? t : 0;
                const dividerLayoutRight = mainLayoutRight
                    + widthDividerPieceCount * (widthDividerHeight + dividerLayoutGap)
                    + dividerJointAllowance;
                const flatX = dividerLayoutRight + GAP + g.pivotX - g.minX;
                const raisedY = H_int + Math.max(H_int + t, 10 * t);
                let px = hingeX;
                let py = hingeY;
                let pz = 0;
                let angle = currentAngle;

                if (s <= doorOpenEnd) {
                    const k = easeDoor(s / doorOpenEnd);
                    angle = lerpDoor(currentAngle, maxInstructionAngle, k);
                } else if (s <= doorWallStageEnd) {
                    angle = maxInstructionAngle;
                } else if (s <= doorLidLiftEnd) {
                    const k = easeDoor((s - doorWallStageEnd) / (doorLidLiftEnd - doorWallStageEnd));
                    angle = maxInstructionAngle;
                    py = lerpDoor(hingeY, raisedY, k);
                } else if (s <= 0.8) {
                    const k = easeDoor((s - doorLidLiftEnd) / (0.8 - doorLidLiftEnd));
                    px = lerpDoor(hingeX, flatX, k);
                    py = raisedY;
                    angle = lerpDoor(maxInstructionAngle, 0, k);
                } else {
                    const k = easeDoor((s - 0.8) / 0.2);
                    px = flatX;
                    py = lerpDoor(raisedY, bottomExplodedY, k);
                    angle = 0;
                }

                const closedQ = new THREE.Quaternion().setFromEuler(new THREE.Euler(-Math.PI / 2, 0, 0, 'XYZ'));
                const hingeQ = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 0, 1), -angle);
                mesh.position.set(px, py, pz);
                mesh.quaternion.copy(hingeQ).multiply(closedQ);
                panelGroup.add(mesh);
                panelMeshes.push(mesh);
                if (s <= 0.08) doorLidMeshes.push(mesh);
            }

            if (twoDoorLid.enabled && isOpen) {
                const easeDoor = x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
                const lerpDoor = (a, b, k) => a + (b - a) * k;
                const g = getTwoDoorLidGeometry(W_ext, D_ext, t);
                const mainLayoutRight = W_int / 2 + wallPanelHeight + GAP;
                const dividerLayoutGap = Math.max(2 * t, 2);
                const widthDividerPieceCount = state.dividers && state.dividers.enabled
                    ? state.dividers.widthPositions.reduce((count, position, index) => (
                        count + getDividerRuns('width', index, D_int, t, state.dividers.depthPositions).length
                    ), 0)
                    : 0;
                const widthDividerHeight = isOpen
                    ? Math.max(t, H_int - t - bottomLift)
                    : Math.max(t, H_int - bottomLift);
                const dividerJointAllowance = widthDividerPieceCount && state.dividers.addBottomSlots ? t : 0;
                const layoutStart = mainLayoutRight
                    + widthDividerPieceCount * (widthDividerHeight + dividerLayoutGap)
                    + dividerJointAllowance + GAP;
                const leftWidth = g.centerX - g.leftBodyOuterX;
                const raisedY = H_int + Math.max(H_int + t, 10 * t);

                ['left', 'right'].forEach(side => {
                    const pivotXRaw = side === 'left' ? g.leftPivotX : g.rightPivotX;
                    const rawMinX = side === 'left' ? g.leftBodyOuterX : g.centerX;
                    const flatLeft = side === 'left' ? layoutStart : layoutStart + leftWidth + GAP;
                    const flatX = flatLeft + pivotXRaw - rawMinX;
                    const shape = new THREE.Shape();
                    appendCommandsToThreePath(shape, twoDoorLidPanelCmds(W_ext, D_ext, t, side), pivotXRaw, g.bodyDepth / 2);
                    shape.closePath();
                    const geom = new THREE.ExtrudeGeometry(shape, extrudeSettings);
                    geom.translate(0, 0, -t / 2);
                    const mesh = new THREE.Mesh(geom, [woodCapMaterial, woodSideMaterial]);
                    mesh.name = `Two-door lid ${side}`;
                    mesh.userData.panelName = mesh.name;
                    mesh.userData.twoDoorLid = side;
                    mesh.castShadow = true;
                    mesh.receiveShadow = true;

                    const hingeX = side === 'left'
                        ? -W_int / 2 + g.hingeOuterRadius
                        : W_int / 2 - g.hingeOuterRadius;
                    const hingeY = H_int / 2 - t / 2;
                    const direction = side === 'left' ? 1 : -1;
                    const currentAngle = twoDoorLid.openProgress * g.openAngle;
                    let px = hingeX;
                    let py = hingeY;
                    let angle = currentAngle;
                    if (s <= doorOpenEnd) {
                        angle = lerpDoor(currentAngle, g.openAngle, easeDoor(s / doorOpenEnd));
                    } else if (s <= doorWallStageEnd) {
                        angle = g.openAngle;
                    } else if (s <= doorLidLiftEnd) {
                        py = lerpDoor(hingeY, raisedY, easeDoor((s - doorWallStageEnd) / (doorLidLiftEnd - doorWallStageEnd)));
                        angle = g.openAngle;
                    } else if (s <= 0.8) {
                        const k = easeDoor((s - doorLidLiftEnd) / (0.8 - doorLidLiftEnd));
                        px = lerpDoor(hingeX, flatX, k);
                        py = raisedY;
                        angle = lerpDoor(g.openAngle, 0, k);
                    } else {
                        px = flatX;
                        py = lerpDoor(raisedY, bottomExplodedY, easeDoor((s - 0.8) / 0.2));
                        angle = 0;
                    }

                    const closedQ = new THREE.Quaternion().setFromEuler(new THREE.Euler(-Math.PI / 2, 0, 0, 'XYZ'));
                    const hingeQ = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 0, 1), direction * angle);
                    mesh.position.set(px, py, 0);
                    mesh.quaternion.copy(hingeQ).multiply(closedQ);
                    panelGroup.add(mesh);
                    panelMeshes.push(mesh);
                    if (s <= 0.08) twoDoorLidMeshes.push(mesh);
                });

                if (s <= 1e-4 && twoDoorLid.openProgress <= 1e-4) {
                    const seamHalfLength = g.bodyDepth / 2 + g.handleRadius;
                    const seamGeometry = new THREE.BufferGeometry().setFromPoints([
                        new THREE.Vector3(0, H_int / 2 + 0.06, -seamHalfLength),
                        new THREE.Vector3(0, H_int / 2 + 0.06, seamHalfLength)
                    ]);
                    const seamMaterial = new THREE.LineBasicMaterial({
                        color: 0x655044,
                        transparent: true,
                        opacity: 0.78,
                        depthTest: true,
                        depthWrite: false
                    });
                    const seam = new THREE.Line(seamGeometry, seamMaterial);
                    seam.renderOrder = 12;
                    seam.raycast = () => {};
                    seam.userData.ownGeometry = true;
                    panelGroup.add(seam);
                    cellVisuals.push(seam);
                }
            }

            if (removableLid.enabled && isOpen) {
                const ease = x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
                const lerp = (a, b, k) => a + (b - a) * k;
                const flatProgress = ease(s);
                const lidLift = getRemovableLidOpenLift({ H_ext, t }) * removableLid.openProgress;
                const flatX = -(W_int / 2 + H_int + W_ext / 2 + 2 * GAP);
                const highestDividerLiftY = 2 * H_int + 5 * t;
                const instructionLiftY = highestDividerLiftY + Math.max(H_int + t, 10 * t);

                const getLidPartPose = (assembledY, flatZ) => {
                    const relativeY = assembledY - H_int / 2;
                    const raisedY = instructionLiftY + relativeY;
                    let x = 0;
                    let y = assembledY + lidLift;
                    let z = 0;
                    if (flatProgress <= 0.28) {
                        const k = ease(flatProgress / 0.28);
                        y = lerp(y, raisedY, k);
                    } else if (flatProgress <= 0.72) {
                        const k = ease((flatProgress - 0.28) / 0.44);
                        x = lerp(0, flatX, k);
                        y = raisedY;
                        z = lerp(0, flatZ, k);
                    } else {
                        const k = ease((flatProgress - 0.72) / 0.28);
                        x = flatX;
                        y = lerp(raisedY, bottomExplodedY, k);
                        z = flatZ;
                    }
                    return { x, y, z };
                };

                const addLidMesh = (name, w, h, cmds, assembledY, flatZ, holes = []) => {
                    const shape = new THREE.Shape();
                    appendCommandsToThreePath(shape, cmds, w / 2, h / 2);
                    shape.closePath();
                    holes.forEach(holeCmds => {
                        const hole = new THREE.Path();
                        appendCommandsToThreePath(hole, holeCmds, w / 2, h / 2);
                        hole.closePath();
                        shape.holes.push(hole);
                    });
                    const geom = new THREE.ExtrudeGeometry(shape, extrudeSettings);
                    const mesh = new THREE.Mesh(geom, [woodCapMaterial, woodSideMaterial]);
                    mesh.name = name;
                    mesh.userData.panelName = name;
                    mesh.castShadow = true;
                    mesh.receiveShadow = true;
                    const pose = getLidPartPose(assembledY, flatZ);
                    mesh.position.set(pose.x, pose.y, pose.z);
                    mesh.rotation.set(-Math.PI / 2, 0, 0, 'YXZ');
                    panelGroup.add(mesh);
                    panelMeshes.push(mesh);
                    if (s <= 0.08) removableLidMeshes.push(mesh);
                };

                const handleGeometry = getLidHandleGeometry(t);
                const topHandleHole = removableLid.addHandle ? [symmetricCrossSlotCmds(
                    W_ext / 2, D_ext / 2,
                    handleGeometry.topHoleWidth, t
                )] : [];
                const lowerHandleHole = removableLid.addHandle ? [symmetricCrossSlotCmds(
                    W_int / 2, D_int / 2,
                    handleGeometry.lowerHoleSize, t
                )] : [];

                addLidMesh(
                    'Removable lid top',
                    W_ext,
                    D_ext,
                    rectangleCmds(0, 0, W_ext, D_ext),
                    H_int / 2,
                    0,
                    topHandleHole
                );
                addLidMesh(
                    'Removable lid lower insert',
                    W_int,
                    D_int,
                    roundedRectangleCmds(0, 0, W_int, D_int, removableLid.cornerRadius),
                    H_int / 2 - t,
                    D_ext / 2 + D_int / 2 + GAP,
                    lowerHandleHole
                );

                if (removableLid.addHandle) {
                    const handleFlatStart = D_ext / 2 + D_int + handleGeometry.radius + 2 * GAP;
                    const addHandleMesh = (name, piece, assembledRotationY, flatZ) => {
                        const cmds = lidHandlePanelCmds(piece, t);
                        const shape = new THREE.Shape();
                        appendCommandsToThreePath(shape, cmds, handleGeometry.radius, 0);
                        shape.closePath();
                        const geom = new THREE.ExtrudeGeometry(shape, extrudeSettings);
                        const mesh = new THREE.Mesh(geom, [woodCapMaterial, woodSideMaterial]);
                        mesh.name = name;
                        mesh.userData.panelName = name;
                        mesh.userData.lidHandle = true;
                        mesh.castShadow = true;
                        mesh.receiveShadow = true;
                        const pose = getLidPartPose(H_int / 2 - t, flatZ);
                        const flattenK = flatProgress <= 0.72 ? 0 : ease((flatProgress - 0.72) / 0.28);
                        const assembledOffsetX = Math.abs(assembledRotationY) > 1e-7 ? -t / 2 : 0;
                        const assembledOffsetZ = Math.abs(assembledRotationY) > 1e-7 ? 0 : -t / 2;
                        mesh.position.set(
                            pose.x + assembledOffsetX * (1 - flattenK),
                            pose.y,
                            pose.z + assembledOffsetZ * (1 - flattenK)
                        );
                        if (flatProgress <= 0.72) {
                            mesh.rotation.set(0, assembledRotationY, 0, 'YXZ');
                        } else {
                            mesh.rotation.set(lerp(0, -Math.PI / 2, flattenK), lerp(assembledRotationY, 0, flattenK), 0, 'YXZ');
                        }
                        panelGroup.add(mesh);
                        panelMeshes.push(mesh);
                        if (s <= 0.08) removableLidMeshes.push(mesh);
                    };

                    addHandleMesh('Removable lid handle A', 'bottom-slot', 0, handleFlatStart);
                    addHandleMesh('Removable lid handle B', 'cross-slot', Math.PI / 2, handleFlatStart + 2 * handleGeometry.radius + GAP);
                }
            }

            if (slideLid.enabled && isOpen) {
                const easeSlide = x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
                const lerpSlide = (a, b, k) => a + (b - a) * k;
                const slidePartLayoutRaw = Math.max(0, Math.min(1, (s - slideSideStageEnd) / (1 - slideSideStageEnd)));
                const assemblyProgress = easeSlide(slidePartLayoutRaw);
                const ejectionProgress = easeSlide(Math.max(0, Math.min(1, s / slideEjectEnd)));
                const slideMotion = getSlideLidMotionGeometry(W_int, D_ext, t);
                const sliderGeometry = getSlideLidPanelGeometry(W_ext, D_ext, t);
                const slideTravel = slideMotion.travel;
                const closedSliderX = W_ext / 2 - sliderGeometry.bodyWidth / 2;
                const assembledSliderX = closedSliderX + slideTravel * slideLid.openProgress;
                const flatX = W_ext / 2 + H_int + W_ext / 2 + 2 * GAP;
                const instructionLift = H_int + Math.max(H_int, 10 * t);

                const getSlidePartPose = (assembledX, assembledY, flatZ, ejectFirst = false) => {
                    const sequenceX = ejectFirst ? Math.max(assembledX, slideTravel) : assembledX;
                    const instructionY = assembledY + instructionLift;
                    let x = ejectFirst ? lerpSlide(assembledX, sequenceX, ejectionProgress) : assembledX;
                    let y = assembledY;
                    let z = 0;
                    if (s <= slideSideStageEnd) {
                        return { x, y, z };
                    }

                    if (ejectFirst) {
                        if (assemblyProgress <= 0.72) {
                            const k = easeSlide(assemblyProgress / 0.72);
                            x = lerpSlide(sequenceX, flatX, k);
                            y = assembledY;
                            z = lerpSlide(0, flatZ, k);
                        } else {
                            const k = easeSlide((assemblyProgress - 0.72) / 0.28);
                            x = flatX;
                            y = lerpSlide(assembledY, bottomExplodedY, k);
                            z = flatZ;
                        }
                        return { x, y, z };
                    }

                    x = sequenceX;
                    if (assemblyProgress <= 0.3) {
                        y = lerpSlide(assembledY, instructionY, easeSlide(assemblyProgress / 0.3));
                    } else if (assemblyProgress <= 0.72) {
                        const k = easeSlide((assemblyProgress - 0.3) / 0.42);
                        x = lerpSlide(sequenceX, flatX, k);
                        y = instructionY;
                        z = lerpSlide(0, flatZ, k);
                    } else {
                        const k = easeSlide((assemblyProgress - 0.72) / 0.28);
                        x = flatX;
                        y = lerpSlide(instructionY, bottomExplodedY, k);
                        z = flatZ;
                    }
                    return { x, y, z };
                };

                const addSlideMesh = (name, cmds, offsetX, offsetY, assembledX, assembledY, flatZ, draggable = false, ejectFirst = false) => {
                    const shape = new THREE.Shape();
                    appendCommandsToThreePath(shape, cmds, offsetX, offsetY);
                    shape.closePath();
                    const geom = new THREE.ExtrudeGeometry(shape, extrudeSettings);
                    const mesh = new THREE.Mesh(geom, [woodCapMaterial, woodSideMaterial]);
                    mesh.name = name;
                    mesh.userData.panelName = name;
                    mesh.castShadow = true;
                    mesh.receiveShadow = true;
                    const pose = getSlidePartPose(assembledX, assembledY, flatZ, ejectFirst);
                    mesh.position.set(pose.x, pose.y, pose.z);
                    mesh.rotation.set(-Math.PI / 2, 0, 0, 'YXZ');
                    panelGroup.add(mesh);
                    panelMeshes.push(mesh);
                    if (draggable && s <= 0.08) slideLidMeshes.push(mesh);
                };

                const lowerRailCmds = slideRailFrameCmds(W_ext, D_ext, t, false);
                const upperRailCmds = slideRailFrameCmds(W_ext, D_ext, t, true);
                const sliderCmds = slideLidPanelCmds(W_ext, D_ext, t);

                addSlideMesh('Slide lid lower rail', lowerRailCmds, W_ext / 2, D_ext / 2, 0, H_int / 2 - 2 * t, D_ext + GAP);
                addSlideMesh(
                    'Slide lid panel', sliderCmds,
                    sliderGeometry.bodyWidth / 2,
                    sliderGeometry.bodyDepth / 2,
                    assembledSliderX, H_int / 2 - t, 0, true, true
                );
                addSlideMesh('Slide lid upper rail', upperRailCmds, W_ext / 2, D_ext / 2, 0, H_int / 2, -(D_ext + GAP));
            }

            if (state.dividers.enabled) {
                const d = state.dividers;
                const ease = x => x < 0.5 ? 2*x*x : 1 - Math.pow(-2*x + 2, 2) / 2;
                const lerp = (a, b, k) => a + (b - a) * k;
                const dividerTimeline = slideInstructionEnabled
                    ? Math.max(0, Math.min(1, (s - slideRailLiftEnd) / (1 - slideRailLiftEnd)))
                    : (doorInstructionEnabled
                        ? Math.max(0, Math.min(1, (s - doorLidLiftEnd) / (1 - doorLidLiftEnd)))
                        : s);
                const p = ease(dividerTimeline);
                const compactGap = Math.max(2 * t, 2);
                const dividerHeight = getDividerPanelHeight({
                    t, isOpen, H_int, lidHeightInset: getLidInternalHeightInset(t, isOpen), bottomLift
                });
                const dividerCenterY = (dividerHeight - H_int) / 2 + bottomLift;
                const slideFlatCenterX = W_ext + wallPanelHeight + 2 * GAP;
                const slideFlatHalfWidth = Math.max(W_ext, getSlideLidPanelGeometry(W_ext, D_ext, t).totalWidth) / 2;
                const mainRight = slideInstructionEnabled
                    ? slideFlatCenterX + slideFlatHalfWidth + GAP
                    : W_int / 2 + H_int + GAP;
                const mainTop = isOpen
                    ? D_int / 2 + H_int + GAP
                    : D_int / 2 + H_int + D_int + 2 * GAP;
                const dividerP = isOpen ? p : Math.max(0, Math.min(1, (p - 0.35) / 0.65));
                const liftY1 = H_int + 4 * t + (isOpen ? 0 : Math.max(12, 4 * t));
                const widthDividerLiftY = liftY1 + H_int + t;
                let widthPieceIndex = 0;
                let depthPieceIndex = 0;

                function addDividerMesh(name, w, h, assembledPos, assembledRot, flatPos, flatRot, options, meta) {
                    const cmds = dividerPanelCmds(w, h, t, options);
                    const shape = new THREE.Shape();
                    const ox = w / 2;
                    const oy = h / 2;
                    appendCommandsToThreePath(shape, cmds, ox, oy);
                    shape.closePath();

                    const geom = new THREE.ExtrudeGeometry(shape, extrudeSettings);
                    geom.translate(0, 0, -t / 2);
                    const isSelectedDivider = !!hoveredDividerSegment &&
                        hoveredDividerSegment.selectionType === 'divider' &&
                        hoveredDividerSegment.axis === meta.axis &&
                        hoveredDividerSegment.dividerIndex === meta.index;
                    const isSelected = isSelectedDivider;
                    const dividerMaterials = isSelected
                        ? [woodCapMaterial, woodSideMaterial].map(material => {
                            const selectedMaterial = material.clone();
                            if (selectedMaterial.color) selectedMaterial.color.lerp(new THREE.Color(0x54c7e8), 0.48);
                            if (selectedMaterial.emissive) {
                                selectedMaterial.emissive.setHex(0x123d52);
                                selectedMaterial.emissiveIntensity = 0.85;
                            }
                            return selectedMaterial;
                        })
                        : [woodCapMaterial, woodSideMaterial];
                    const mesh = new THREE.Mesh(geom, dividerMaterials);
                    mesh.name = name;
                    mesh.userData.divider = meta;
                    mesh.userData.ownsDividerMaterials = isSelected;
                    mesh.castShadow = true;
                    mesh.receiveShadow = true;

                    // A panel placed on the depth axis physically spans the box Width.
                    const isPhysicalWidthDivider = meta.axis === 'depth';
                    const familyLiftY = isPhysicalWidthDivider ? widthDividerLiftY : liftY1;
                    const stagingProgress = 0.56;
                    const familyStage = {
                        x: lerp(assembledPos.x, flatPos.x, stagingProgress),
                        z: lerp(assembledPos.z, flatPos.z, stagingProgress)
                    };
                    let px, py, pz, rx, ry, rz;
                    if (dividerP <= 0.30) {
                        const k = ease(dividerP / 0.30);
                        px = assembledPos.x;
                        py = lerp(assembledPos.y, liftY1, k);
                        pz = assembledPos.z;
                        rx = assembledRot.x;
                        ry = assembledRot.y;
                        rz = assembledRot.z;
                    } else if (dividerP <= 0.50) {
                        const k = ease((dividerP - 0.30) / 0.20);
                        px = assembledPos.x;
                        py = isPhysicalWidthDivider ? lerp(liftY1, widthDividerLiftY, k) : liftY1;
                        pz = assembledPos.z;
                        rx = assembledRot.x;
                        ry = assembledRot.y;
                        rz = assembledRot.z;
                    } else if (dividerP <= 0.76) {
                        const k = ease((dividerP - 0.50) / 0.26);
                        px = lerp(assembledPos.x, familyStage.x, k);
                        py = familyLiftY;
                        pz = lerp(assembledPos.z, familyStage.z, k);
                        rx = assembledRot.x;
                        ry = assembledRot.y;
                        rz = assembledRot.z;
                    } else {
                        const k = ease((dividerP - 0.76) / 0.24);
                        px = lerp(familyStage.x, flatPos.x, k);
                        py = lerp(familyLiftY, flatPos.y, k);
                        pz = lerp(familyStage.z, flatPos.z, k);
                        rx = lerp(assembledRot.x, flatRot.x, k);
                        ry = lerp(assembledRot.y, flatRot.y, k);
                        rz = lerp(assembledRot.z, flatRot.z, k);
                    }

                    mesh.position.set(px, py, pz);
                    mesh.rotation.set(rx, ry, rz, 'YXZ');
                    panelGroup.add(mesh);
                    panelMeshes.push(mesh);
                    if (s <= 0.08) dividerMeshes.push(mesh);
                }

                d.widthPositions.forEach((pos, idx) => {
                    getDividerRuns('width', idx, D_int, t, d.depthPositions).forEach((run, runIndex) => {
                        const runLength = run.end - run.start;
                        const flatX = mainRight + compactGap + dividerHeight / 2 + widthPieceIndex * (dividerHeight + compactGap);
                        addDividerMesh(
                            `Width divider ${idx + 1}${runIndex ? ` part ${runIndex + 1}` : ''}`,
                            runLength,
                            dividerHeight,
                            {
                                x: pos * W_int - W_int / 2,
                                y: dividerCenterY,
                                z: (run.start + run.end) / 2 - D_int / 2
                            },
                            { x: 0, y: -Math.PI / 2, z: 0 },
                            { x: flatX, y: bottomExplodedY, z: 0 },
                            { x: -Math.PI / 2, y: 0, z: -Math.PI / 2 },
                            {
                                sideTabs: d.addSideSlots,
                                sideTabsStart: run.start <= 1e-7,
                                sideTabsEnd: run.end >= D_int - 1e-7,
                                bottomTabs: d.addBottomSlots,
                                crossPositions: run.crossPositions,
                                crossFromTop: true,
                                pressFitCrossSlots: state.addNotches
                            },
                            { axis: 'width', index: idx, segmentStart: run.segmentStart, segmentEnd: run.segmentEnd, W_int, D_int }
                        );
                        widthPieceIndex++;
                    });
                });

                d.depthPositions.forEach((pos, idx) => {
                    getDividerRuns('depth', idx, W_int, t, d.widthPositions).forEach((run, runIndex) => {
                        const runLength = run.end - run.start;
                        const flatY = mainTop + compactGap + dividerHeight / 2 + depthPieceIndex * (dividerHeight + compactGap);
                        addDividerMesh(
                            `Depth divider ${idx + 1}${runIndex ? ` part ${runIndex + 1}` : ''}`,
                            runLength,
                            dividerHeight,
                            {
                                x: (run.start + run.end) / 2 - W_int / 2,
                                y: dividerCenterY,
                                z: pos * D_int - D_int / 2
                            },
                            { x: 0, y: 0, z: 0 },
                            { x: 0, y: bottomExplodedY, z: -flatY },
                            { x: -Math.PI / 2, y: 0, z: 0 },
                            {
                                sideTabs: d.addSideSlots,
                                sideTabsStart: run.start <= 1e-7,
                                sideTabsEnd: run.end >= W_int - 1e-7,
                                 bottomTabs: d.addBottomSlots,
                                 crossPositions: run.crossPositions,
                                 crossFromTop: false,
                                 topClearanceCuts: getDoorDividerTopClearanceCuts(run, W_int, W_ext, D_ext, t)
                            },
                            { axis: 'depth', index: idx, segmentStart: run.segmentStart, segmentEnd: run.segmentEnd, W_int, D_int }
                        );
                        depthPieceIndex++;
                    });
                });
            }

            addCellSelectionVisuals(W_int, H_int, D_int, t, s);

            // Recalculate camera targets to fit the box in the viewport
            if (panelGroup && camera && controls) {
                panelGroup.updateMatrixWorld(true);
                const bbox = new THREE.Box3().setFromObject(panelGroup);
                const center = new THREE.Vector3();
                bbox.getCenter(center);
                const size = new THREE.Vector3();
                bbox.getSize(size);
                
                const W_total = els.canvasHolder.clientWidth;
                const H_total = els.canvasHolder.clientHeight;
                
                if (W_total > 200 && H_total > 200) {
                    const fovRad = THREE.MathUtils.degToRad(camera.fov);
                    
                    // Use the diagonal length of the box to fit the entire object under any rotation
                    const D = size.length();
                    
                    const isCompactViewport = window.matchMedia('(max-width: 749px)').matches;
                    const verticalUiAllowance = isCompactViewport ? 92 : 250;
                    const horizontalUiAllowance = isCompactViewport ? 34 : 900;

                    // On phones the controls live below the canvas, so the model can use almost
                    // the full preview area. Desktop keeps the original generous clearances.
                    const visibleHeight = Math.max(isCompactViewport ? 145 : 200, H_total - verticalUiAllowance);
                    const distY = D / (2 * Math.tan(fovRad / 2));
                    const reqDistY = distY * (H_total / visibleHeight);
                    
                    const visibleWidth = Math.max(isCompactViewport ? 220 : 300, W_total - horizontalUiAllowance);
                    const distX = D / (2 * Math.tan(fovRad / 2) * camera.aspect);
                    const reqDistX = distX * (W_total / visibleWidth);
                    
                    targetDistance = Math.max(reqDistY, reqDistX);
                    
                    // Clamp targetDistance to orbit controls limits
                    if (targetDistance < controls.minDistance) targetDistance = controls.minDistance;
                    if (targetDistance > controls.maxDistance) targetDistance = controls.maxDistance;
                    
                    targetControlsTarget.copy(center);
                    cameraNeedsFit = true; // Trigger zoom interpolation
                }
            }
        }



        function animate() {
            requestAnimationFrame(animate);
            
            if (controls) {
                if (cameraNeedsFit && !isInteracting && targetControlsTarget) {
                    // Temporarily disable damping to prevent fighting
                    controls.enableDamping = false;
                    
                    const currentDistance = camera.position.distanceTo(controls.target);
                    // Smoothly interpolate the distance
                    const newDistance = currentDistance + (targetDistance - currentDistance) * 0.05;
                    const dir = new THREE.Vector3().subVectors(camera.position, controls.target).normalize();
                    
                    // Position camera at new distance along current direction
                    camera.position.copy(controls.target).addScaledVector(dir, newDistance);
                    // Smoothly interpolate the controls target
                    controls.target.lerp(targetControlsTarget, 0.05);
                    
                    // Stop interpolating once we are very close to allow manual zoom
                    if (Math.abs(currentDistance - targetDistance) < 1.0 && 
                        controls.target.distanceTo(targetControlsTarget) < 1.0) {
                        cameraNeedsFit = false;
                        controls.enableDamping = true;
                    }
                } else {
                    controls.enableDamping = true;
                }
                controls.update();
            }
            
            if (dirLight1 && camera) {
                // Keep the shadow-casting light offset relative to the camera
                // so that visible faces remain illuminated and shadows move with camera orbit
                dirLight1.position.set(
                    camera.position.x + 150,
                    camera.position.y + 350,
                    camera.position.z + 150
                );
            }
            
            renderer.render(scene, camera);
        }

        function onWindowResize() {
            if (!els.canvasHolder || !camera || !renderer) return;
            const width = Math.max(1, els.canvasHolder.clientWidth);
            const height = Math.max(1, els.canvasHolder.clientHeight);
            if (width < 2 || height < 2) return;
            camera.aspect = width / height;
            camera.updateProjectionMatrix();
            renderer.setSize(width, height, false);
            updateBox3D();
        }

        // ==========================================
        // 3. EXPORTS ENGINE (SVG & DXF)
           function offsetClosedPath(cmds, d) {
            if (!d || Math.abs(d) < 1e-6) return cmds;

            // buildPanel() now guarantees an incoming command list of length > 1 is a closed ring
            // whose last vertex duplicates the first (see buildPanel's closing block). Closure is
            // therefore known structurally - no need to re-measure distance to detect it.
            let workingCmds = [...cmds];
            let wasClosed = workingCmds.length > 1;
            if (wasClosed) workingCmds.pop();

            // Filter out adjacent duplicate points, but never drop an 'A' (arc) command: an arc
            // can legitimately start/end very close to its neighbouring vertex (small-radius
            // notch), and discarding it here would silently delete that notch's bulge data,
            // leaving a gap in the exported contour.
            let filtered = [];
            for (let i = 0; i < workingCmds.length; i++) {
                const curr = workingCmds[i];
                if (filtered.length > 0 && curr.type !== 'A') {
                    const prev = filtered[filtered.length - 1];
                    if (Math.hypot(curr.x - prev.x, curr.y - prev.y) < 1e-4) {
                        continue; // Skip duplicate point
                    }
                }
                filtered.push(curr);
            }
            workingCmds = filtered;

            const n = workingCmds.length;
            if (n < 3) return cmds;

            const segments = [];
            for (let i = 0; i < n; i++) {
                const cmdPrev = workingCmds[(i - 1 + n) % n];
                const cmdCurr = workingCmds[i];
                
                const p1 = { x: cmdPrev.x, y: cmdPrev.y };
                const p2 = { x: cmdCurr.x, y: cmdCurr.y };
                
                const dx = p2.x - p1.x;
                const dy = p2.y - p1.y;
                const len = Math.hypot(dx, dy);
                
                let nx = 0, ny = 0;
                if (len > 1e-6) {
                    nx = dy / len;
                    ny = -dx / len;
                }
                
                segments.push({
                    p1, p2, dx, dy, len, nx, ny,
                    cmd: cmdCurr
                });
            }

            const newCoords = [];
            for (let i = 0; i < n; i++) {
                const segPrev = segments[i];
                const segNext = segments[(i + 1) % n];
                
                const xi = segPrev.p2.x;
                const yi = segPrev.p2.y;
                
                const nx1 = segPrev.nx, ny1 = segPrev.ny;
                const nx2 = segNext.nx, ny2 = segNext.ny;
                
                const C1 = nx1 * xi + ny1 * yi + d;
                const C2 = nx2 * xi + ny2 * yi + d;
                
                const det = nx1 * ny2 - ny1 * nx2;
                let newX = xi, newY = yi;
                
                if (Math.abs(det) > 1e-5) {
                    newX = (C1 * ny2 - C2 * ny1) / det;
                    newY = (nx1 * C2 - nx2 * C1) / det;
                } else {
                    newX = xi + d * nx1;
                    newY = yi + d * ny1;
                }
                
                newCoords.push({ x: newX, y: newY });
            }

            const newCmds = [];
            for (let i = 0; i < n; i++) {
                const origCmd = workingCmds[i];
                const prevCoord = newCoords[(i - 1 + n) % n];
                const currCoord = newCoords[i];
                
                if (origCmd.type === 'M') {
                    newCmds.push({
                        type: 'M',
                        x: currCoord.x,
                        y: currCoord.y
                    });
                } else if (origCmd.type === 'L') {
                    newCmds.push({
                        type: 'L',
                        x: currCoord.x,
                        y: currCoord.y
                    });
                } else if (origCmd.type === 'A') {
                    const cx = (prevCoord.x + currCoord.x) / 2;
                    const cy = (prevCoord.y + currCoord.y) / 2;
                    const R = Math.hypot(currCoord.x - prevCoord.x, currCoord.y - prevCoord.y) / 2;
                    
                    newCmds.push({
                        type: 'A',
                        cx: cx,
                        cy: cy,
                        R: R,
                        startAngle: origCmd.startAngle,
                        endAngle: origCmd.endAngle,
                        sweep: origCmd.sweep,
                        bulge: origCmd.bulge,
                        x: currCoord.x,
                        y: currCoord.y
                    });
                }
            }

            if (wasClosed && newCmds.length > 0) {
                const first = newCmds[0];
                newCmds.push({
                    type: 'L',
                    x: first.x,
                    y: first.y
                });
            }
            
            return newCmds;
        }

        function getFlatPanelsLayoutData() {
            const { t, isOpen, W_ext, H_ext, D_ext, W_int, H_int, D_int, bottomLift } = getResolvedBoxDimensions();

            const GAP = 4 * t; // Same gap as in the 3D scene
            const removableLid = ensureRemovableLidState();
            const slideLid = ensureSlideLidState();
            const doorLid = ensureDoorLidState();
            const twoDoorLid = ensureTwoDoorLidState();
            const raisedBottom = bottomLift > 1e-7;
            const wallPanelHeight = H_int + (raisedBottom ? t : 0);
            const dividerHeight = getDividerPanelHeight({
                t, isOpen, H_int, lidHeightInset: getLidInternalHeightInset(t, isOpen), bottomLift
            });
            const slideExitWallHeight = Math.min(H_int, Math.max(t, H_ext - 2 * t));
            const rightWallCut = slideLid.enabled && isOpen ? Math.max(0, H_int - slideExitWallHeight) : 0;
            const rightWallHeight = Math.max(t, wallPanelHeight - rightWallCut);

            // 2D flat cross-net layout configuration matching the 3D engine at s=0
            const panelsDef = [
                {
                    name: 'Bottom',
                    w: W_int, h: D_int,
                    edges: raisedBottom ? ['A', 'A', 'A', 'A'] : ['B', 'B', 'B', 'B'],
                    flatPos: { x: 0, y: 0 },
                    flatRotZ: 0
                },
                {
                    name: 'Back',
                    w: W_int, h: wallPanelHeight,
                    edges: [raisedBottom ? 'flat' : 'A', 'B', isOpen ? (slideLid.enabled ? 'A' : 'flat') : 'A', 'B'],
                    raisedBottomSlotEdge: raisedBottom ? 'bottom' : null,
                    sideSlotEdge: isOpen ? 'top' : null,
                    doorHingeEdge: doorLid.enabled && isOpen ? 'top' : null,
                    twoDoorHingeEdge: twoDoorLid.enabled && isOpen ? 'top' : null,
                    twoDoorHandleEdge: twoDoorLid.enabled && isOpen ? 'top' : null,
                    flatPos: { x: 0, y: D_int/2 + wallPanelHeight/2 + GAP },
                    flatRotZ: 0
                },
                {
                    name: 'Top',
                    w: W_int, h: D_int,
                    edges: ['B', 'B', 'B', 'B'],
                    flatPos: { x: 0, y: D_int/2 + wallPanelHeight + D_int/2 + 2*GAP },
                    flatRotZ: 0
                },
                {
                    name: 'Front',
                    w: W_int, h: wallPanelHeight,
                    edges: [isOpen ? (slideLid.enabled ? 'A' : 'flat') : 'A', 'B', raisedBottom ? 'flat' : 'A', 'B'],
                    raisedBottomSlotEdge: raisedBottom ? 'top' : null,
                    sideSlotEdge: isOpen ? 'bottom' : null,
                    doorHingeEdge: doorLid.enabled && isOpen ? 'bottom' : null,
                    twoDoorHingeEdge: twoDoorLid.enabled && isOpen ? 'bottom' : null,
                    twoDoorHandleEdge: twoDoorLid.enabled && isOpen ? 'bottom' : null,
                    flatPos: { x: 0, y: -(D_int/2 + wallPanelHeight/2 + GAP) },
                    flatRotZ: 0
                },
                {
                    name: 'Left',
                    w: D_int, h: wallPanelHeight,
                    edges: [raisedBottom ? 'flat' : 'A', 'A', isOpen ? (slideLid.enabled ? 'A' : 'flat') : 'A', 'A'],
                    raisedBottomSlotEdge: raisedBottom ? 'bottom' : null,
                    sideSlotEdge: isOpen ? 'top' : null,
                    doorHandleEdge: doorLid.enabled && isOpen ? 'top' : null,
                    flatPos: { x: -(W_int/2 + wallPanelHeight/2 + GAP), y: 0 },
                    flatRotZ: Math.PI/2
                },
                {
                    name: 'Right',
                    w: D_int, h: rightWallHeight,
                    edges: [raisedBottom ? 'flat' : 'A', 'A', isOpen ? 'flat' : 'A', 'A'],
                    raisedBottomSlotEdge: raisedBottom ? 'bottom' : null,
                    edgeProfiles: slideLid.enabled && isOpen ? [
                        null,
                        { length: wallPanelHeight, offset: 0 },
                        null,
                        { length: wallPanelHeight, offset: rightWallCut }
                    ] : null,
                    sideSlotEdge: isOpen ? 'top' : null,
                    flatPos: { x: W_int/2 + rightWallHeight/2 + GAP, y: 0 },
                    flatRotZ: -Math.PI/2
                }
            ];
            
            const results = [];
            let allPoints = [];
            
            panelsDef.forEach(def => {
                if (state.boxType === 'open' && def.name === 'Top') {
                    return; // Skip top panel if box is open
                }
                
                let cmdsOrig = getPanelOuterCommands(def, { W_int, H_int, D_int, t }, false);
                let cmdsKerfed = null;
                if (state.addKerf && state.kerf && Math.abs(state.kerf) > 1e-6) {
                    cmdsKerfed = offsetClosedPath(cmdsOrig, state.kerf);
                }
                
                function transform(x, y) {
                    let cx = x - def.w / 2;
                    let cy = y - def.h / 2;
                    
                    let rx = cx * Math.cos(def.flatRotZ) - cy * Math.sin(def.flatRotZ);
                    let ry = cx * Math.sin(def.flatRotZ) + cy * Math.cos(def.flatRotZ);
                    
                    let wx = def.flatPos.x + rx;
                    let wy = def.flatPos.y + ry;
                    
                    return { x: wx, y: wy };
                }
                
                function transformCmds(cmdsList) {
                    return cmdsList.map(cmd => {
                        if (cmd.type === 'M' || cmd.type === 'L') {
                            const pt = transform(cmd.x, cmd.y);
                            return { type: cmd.type, x: pt.x, y: pt.y };
                        } else if (cmd.type === 'A') {
                            const ptEnd = transform(cmd.x, cmd.y);
                            const ptCenter = transform(cmd.cx, cmd.cy);
                            
                            let startAngle = cmd.startAngle + def.flatRotZ;
                            let endAngle = cmd.endAngle + def.flatRotZ;
                            
                            return {
                                type: 'A',
                                cx: ptCenter.x,
                                cy: ptCenter.y,
                                R: cmd.R,
                                startAngle: startAngle,
                                endAngle: endAngle,
                                sweep: cmd.sweep,
                                bulge: cmd.bulge,
                                x: ptEnd.x,
                                y: ptEnd.y
                            };
                        }
                    });
                }
                
                let transformedCmdsOrig = transformCmds(cmdsOrig);
                let transformedCmdsKerfed = cmdsKerfed ? transformCmds(cmdsKerfed) : null;
                
                results.push({
                    name: def.name,
                    cmds: transformedCmdsKerfed || transformedCmdsOrig,
                    cmdsOriginal: transformedCmdsOrig,
                    hasKerf: !!transformedCmdsKerfed
                });
                
                const activeCmds = transformedCmdsKerfed || transformedCmdsOrig;
                addPanelPoints(activeCmds, allPoints);
                if (transformedCmdsKerfed) {
                    addPanelPoints(transformedCmdsOrig, allPoints);
                }

                if (state.dividers.enabled) {
                    const slotCuts = createDividerCutouts(def, { W_int, H_int, D_int, t });
                    slotCuts.forEach(cut => {
                        const transformedCut = transformCmds2D(cut.cmds, transform);
                        results.push({
                            name: cut.name,
                            cmds: transformedCut,
                            cmdsOriginal: transformedCut,
                            hasKerf: false
                        });
                        addPanelPoints(transformedCut, allPoints);
                    });
                }

                if (def.raisedBottomSlotEdge) {
                    getRaisedBottomWallSlots(def.w, def.h, t, bottomLift, def.raisedBottomSlotEdge).forEach(cut => {
                        const transformedCut = transformCmds2D(cut.cmds, transform);
                        results.push({
                            name: `${def.name}-${cut.name}`,
                            cmds: transformedCut,
                            cmdsOriginal: transformedCut,
                            hasKerf: false
                        });
                        addPanelPoints(transformedCut, allPoints);
                    });
                }

                if (slideLid.enabled && isOpen && (def.name === 'Back' || def.name === 'Front' || def.name === 'Left')) {
                    const slotEdge = def.name === 'Front' ? 'bottom' : 'top';
                    getSlideLidWallSlots(def.w, def.h, t, slotEdge).forEach(cut => {
                        const transformedCut = transformCmds2D(cut.cmds, transform);
                        results.push({
                            name: `${def.name}-${cut.name}`,
                            cmds: transformedCut,
                            cmdsOriginal: transformedCut,
                            hasKerf: false
                        });
                        addPanelPoints(transformedCut, allPoints);
                    });
                }

                if (doorLid.enabled && isOpen && def.doorHingeEdge) {
                    const transformedCut = transformCmds2D(
                        getDoorHingeHoleCmds(def.w, def.h, t, def.doorHingeEdge),
                        transform
                    );
                    results.push({
                        name: `${def.name}-door-hinge-hole`,
                        cmds: transformedCut,
                        cmdsOriginal: transformedCut,
                        hasKerf: false
                    });
                    addPanelPoints(transformedCut, allPoints);
                }

                if (twoDoorLid.enabled && isOpen && def.twoDoorHingeEdge) {
                    getTwoDoorHingeHoleCmds(def.w, def.h, t, def.twoDoorHingeEdge).forEach((holeCmds, index) => {
                        const transformedCut = transformCmds2D(holeCmds, transform);
                        results.push({
                            name: `${def.name}-two-door-hinge-hole-${index + 1}`,
                            cmds: transformedCut,
                            cmdsOriginal: transformedCut,
                            hasKerf: false
                        });
                        addPanelPoints(transformedCut, allPoints);
                    });
                }
            });

            if (state.dividers.enabled) {
                const d = state.dividers;
                const compactGap = Math.max(2 * t, 2);
                const mainRight = W_int / 2 + wallPanelHeight + GAP;
                const mainTop = isOpen
                    ? D_int / 2 + wallPanelHeight + GAP
                    : D_int / 2 + wallPanelHeight + D_int + 2 * GAP;
                let widthPieceIndex = 0;
                let depthPieceIndex = 0;

                function addFlatDividerPanel(name, w, h, flatPos, flatRotZ, options) {
                    let cmds = dividerPanelCmds(w, h, t, options);
                    if (state.addKerf && state.kerf && Math.abs(state.kerf) > 1e-6) {
                        cmds = offsetClosedPath(cmds, state.kerf);
                    }
                    const transformDivider = (x, y) => {
                        const cx = x - w / 2;
                        const cy = y - h / 2;
                        return {
                            x: flatPos.x + cx * Math.cos(flatRotZ) - cy * Math.sin(flatRotZ),
                            y: flatPos.y + cx * Math.sin(flatRotZ) + cy * Math.cos(flatRotZ)
                        };
                    };
                    const transformed = transformCmds2D(cmds, transformDivider);
                    results.push({
                        name,
                        cmds: transformed,
                        cmdsOriginal: transformed,
                        hasKerf: state.addKerf && state.kerf && Math.abs(state.kerf) > 1e-6
                    });
                    addPanelPoints(transformed, allPoints);
                }

                d.widthPositions.forEach((pos, idx) => {
                    getDividerRuns('width', idx, D_int, t, d.depthPositions).forEach((run, runIndex) => {
                        const runLength = run.end - run.start;
                        const flatX = mainRight + compactGap + dividerHeight / 2 + widthPieceIndex * (dividerHeight + compactGap);
                        addFlatDividerPanel(
                            `Width-divider-${idx + 1}${runIndex ? `-part-${runIndex + 1}` : ''}`,
                            runLength,
                            dividerHeight,
                            { x: flatX, y: 0 },
                            Math.PI / 2,
                            {
                                sideTabs: d.addSideSlots,
                                sideTabsStart: run.start <= 1e-7,
                                sideTabsEnd: run.end >= D_int - 1e-7,
                                bottomTabs: d.addBottomSlots,
                                crossPositions: run.crossPositions,
                                crossFromTop: true,
                                pressFitCrossSlots: state.addNotches
                            }
                        );
                        widthPieceIndex++;
                    });
                });

                d.depthPositions.forEach((pos, idx) => {
                    getDividerRuns('depth', idx, W_int, t, d.widthPositions).forEach((run, runIndex) => {
                        const runLength = run.end - run.start;
                        const flatY = mainTop + compactGap + dividerHeight / 2 + depthPieceIndex * (dividerHeight + compactGap);
                        addFlatDividerPanel(
                            `Depth-divider-${idx + 1}${runIndex ? `-part-${runIndex + 1}` : ''}`,
                            runLength,
                            dividerHeight,
                            { x: 0, y: flatY },
                            0,
                            {
                                sideTabs: d.addSideSlots,
                                sideTabsStart: run.start <= 1e-7,
                                sideTabsEnd: run.end >= W_int - 1e-7,
                                 bottomTabs: d.addBottomSlots,
                                 crossPositions: run.crossPositions,
                                 crossFromTop: false,
                                 topClearanceCuts: getDoorDividerTopClearanceCuts(run, W_int, W_ext, D_ext, t)
                            }
                        );
                        depthPieceIndex++;
                    });
                });
            }

            if (slideLid.enabled && isOpen) {
                const existingMaxX = Math.max(...allPoints.map(point => point.x));
                const existingMinY = Math.min(...allPoints.map(point => point.y));
                const slideX = existingMaxX + GAP + t;
                const sliderGeometry = getSlideLidPanelGeometry(W_ext, D_ext, t);

                const addFlatSlidePanel = (name, rawCmds, offsetX, offsetY) => {
                    const original = transformCmds2D(rawCmds, (x, y) => ({ x: x + offsetX, y: y + offsetY }));
                    let active = original;
                    let hasKerf = false;
                    if (state.addKerf && state.kerf && Math.abs(state.kerf) > 1e-6) {
                        active = transformCmds2D(offsetClosedPath(rawCmds, state.kerf), (x, y) => ({ x: x + offsetX, y: y + offsetY }));
                        hasKerf = true;
                    }
                    results.push({ name, cmds: active, cmdsOriginal: original, hasKerf });
                    addPanelPoints(active, allPoints);
                    if (hasKerf) addPanelPoints(original, allPoints);
                };

                addFlatSlidePanel(
                    'Slide-lid-lower-rail',
                    slideRailFrameCmds(W_ext, D_ext, t, false),
                    slideX,
                    existingMinY + t
                );
                addFlatSlidePanel(
                    'Slide-lid-panel',
                    slideLidPanelCmds(W_ext, D_ext, t),
                    slideX,
                    existingMinY + D_ext + GAP
                );
                addFlatSlidePanel(
                    'Slide-lid-upper-rail',
                    slideRailFrameCmds(W_ext, D_ext, t, true),
                    slideX,
                    existingMinY + D_ext + GAP + sliderGeometry.bodyDepth + GAP + t
                );
            }

            if (removableLid.enabled && isOpen) {
                const existingMaxX = Math.max(...allPoints.map(point => point.x));
                const existingMinY = Math.min(...allPoints.map(point => point.y));
                const lidX = existingMaxX + GAP;

                const addFlatLidPanel = (name, rawCmds, offsetX, offsetY) => {
                    const transformedOriginal = transformCmds2D(rawCmds, (x, y) => ({ x: x + offsetX, y: y + offsetY }));
                    let active = transformedOriginal;
                    let hasKerf = false;
                    if (state.addKerf && state.kerf && Math.abs(state.kerf) > 1e-6) {
                        const kerfed = offsetClosedPath(rawCmds, state.kerf);
                        active = transformCmds2D(kerfed, (x, y) => ({ x: x + offsetX, y: y + offsetY }));
                        hasKerf = true;
                    }
                    results.push({ name, cmds: active, cmdsOriginal: transformedOriginal, hasKerf });
                    addPanelPoints(active, allPoints);
                    if (hasKerf) addPanelPoints(transformedOriginal, allPoints);
                };

                const addFlatLidCut = (name, rawCmds, offsetX, offsetY) => {
                    const transformed = transformCmds2D(rawCmds, (x, y) => ({ x: x + offsetX, y: y + offsetY }));
                    results.push({ name, cmds: transformed, cmdsOriginal: transformed, hasKerf: false });
                    addPanelPoints(transformed, allPoints);
                };

                addFlatLidPanel(
                    'Removable-lid-top',
                    rectangleCmds(0, 0, W_ext, D_ext),
                    lidX,
                    existingMinY
                );
                addFlatLidPanel(
                    'Removable-lid-lower-insert',
                    roundedRectangleCmds(0, 0, W_int, D_int, removableLid.cornerRadius),
                    lidX,
                    existingMinY + D_ext + GAP
                );

                if (removableLid.addHandle) {
                    const handleGeometry = getLidHandleGeometry(t);
                    addFlatLidCut(
                        'Removable-lid-top-handle-opening',
                        symmetricCrossSlotCmds(W_ext / 2, D_ext / 2, handleGeometry.topHoleWidth, t),
                        lidX,
                        existingMinY
                    );
                    addFlatLidCut(
                        'Removable-lid-lower-handle-opening',
                        symmetricCrossSlotCmds(W_int / 2, D_int / 2, handleGeometry.lowerHoleSize, t),
                        lidX,
                        existingMinY + D_ext + GAP
                    );
                    const handleY = existingMinY + D_ext + GAP + D_int + GAP;
                    addFlatLidPanel(
                        'Removable-lid-handle-A',
                        lidHandlePanelCmds('bottom-slot', t),
                        lidX,
                        handleY
                    );
                    addFlatLidPanel(
                        'Removable-lid-handle-B',
                        lidHandlePanelCmds('cross-slot', t),
                        lidX + 2 * handleGeometry.radius + GAP,
                        handleY
                    );
                }
            }

            if (doorLid.enabled && isOpen) {
                const existingMaxX = Math.max(...allPoints.map(point => point.x));
                const g = getDoorLidGeometry(W_ext, D_ext, t);
                const rawCmds = doorLidPanelCmds(W_ext, D_ext, t);
                const offsetX = existingMaxX + GAP - g.minX;
                const offsetY = -g.bodyDepth / 2;
                const original = transformCmds2D(rawCmds, (x, y) => ({ x: x + offsetX, y: y + offsetY }));
                let active = original;
                let hasKerf = false;
                if (state.addKerf && state.kerf && Math.abs(state.kerf) > 1e-6) {
                    active = transformCmds2D(offsetClosedPath(rawCmds, state.kerf), (x, y) => ({ x: x + offsetX, y: y + offsetY }));
                    hasKerf = true;
                }
                results.push({ name: 'Door-lid', cmds: active, cmdsOriginal: original, hasKerf });
                addPanelPoints(active, allPoints);
                if (hasKerf) addPanelPoints(original, allPoints);
            }

            if (twoDoorLid.enabled && isOpen) {
                const g = getTwoDoorLidGeometry(W_ext, D_ext, t);
                let existingMaxX = Math.max(...allPoints.map(point => point.x));
                ['left', 'right'].forEach(side => {
                    const rawCmds = twoDoorLidPanelCmds(W_ext, D_ext, t, side);
                    const rawPoints = [];
                    addPanelPoints(rawCmds, rawPoints);
                    const rawMinX = Math.min(...rawPoints.map(point => point.x));
                    const rawMaxX = Math.max(...rawPoints.map(point => point.x));
                    const offsetX = existingMaxX + GAP - rawMinX;
                    const offsetY = -g.bodyDepth / 2;
                    const transform = (x, y) => ({ x: x + offsetX, y: y + offsetY });
                    const original = transformCmds2D(rawCmds, transform);
                    let active = original;
                    let hasKerf = false;
                    if (state.addKerf && state.kerf && Math.abs(state.kerf) > 1e-6) {
                        active = transformCmds2D(offsetClosedPath(rawCmds, state.kerf), transform);
                        hasKerf = true;
                    }
                    results.push({ name: `Two-door-lid-${side}`, cmds: active, cmdsOriginal: original, hasKerf });
                    addPanelPoints(active, allPoints);
                    if (hasKerf) addPanelPoints(original, allPoints);
                    existingMaxX += rawMaxX - rawMinX + GAP;
                });
            }
            
            // Find global bounding box
            let minX = Infinity, maxX = -Infinity;
            let minY = Infinity, maxY = -Infinity;
            allPoints.forEach(pt => {
                if (pt.x < minX) minX = pt.x;
                if (pt.x > maxX) maxX = pt.x;
                if (pt.y < minY) minY = pt.y;
                if (pt.y > maxY) maxY = pt.y;
            });
            
            const padding = 10;
            const totalWidth = (maxX - minX) + 2 * padding;
            const totalHeight = (maxY - minY) + 2 * padding;
            
            return {
                panels: results,
                totalWidth: totalWidth,
                        totalHeight: totalHeight,
                minX: minX,
                maxX: maxX,
                minY: minY,
                maxY: maxY,
                padding: padding
            };
        }
 
        function exportSVG() {
            requestBoxDownload('svg');
        }
 
        function exportDXF() {
            requestBoxDownload('dxf');
        }


        // Builds an export filename like "vector-painter-box-3-mm-120x30x40-mm" or "vector-painter-box-0_118-in-4_5x5x6-in":
        // thickness and outer WxHxD, both in whichever unit (mm/in) the UI currently displays,
        // with underscores standing in for the decimal separator (dot or comma) so the name
        // stays a single filesystem-safe token per number instead of using a literal '.' or ','.
        function buildBoxFilename(extension) {
            const { t, W_ext, H_ext, D_ext } = getResolvedBoxDimensions();
            const factor = (state.unit === 'in') ? (1 / MM_PER_INCH) : 1;

            const thicknessDec = (state.unit === 'in') ? 3 : 3;
            const dimDec = (state.unit === 'in') ? 3 : 1;
            const under = (v, dec) => fmtTrim(v, dec).replace(/[.,]/g, '_');

            const thicknessStr = under(t * factor, thicknessDec);
            const wStr = under(W_ext * factor, dimDec);
            const hStr = under(H_ext * factor, dimDec);
            const dStr = under(D_ext * factor, dimDec);
            const unitLabel = state.unit;

            return `vector-painter-box-${thicknessStr}-${unitLabel}-${wStr}x${hStr}x${dStr}-${unitLabel}.${extension}`;
        }

        function downloadBlob(blob, filename) {
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }

        const BOX_DOWNLOAD_ENDPOINT = '/apps/vector-painter-nest/api/free-apps/box/download';

        function openBoxLoginDialog() {
            const overlay = document.getElementById('vp-box-download-overlay');
            if (!overlay) return;
            overlay.hidden = false;
            overlay.setAttribute('aria-hidden', 'false');
            document.getElementById('vp-box-download-login')?.focus({ preventScroll: true });
        }

        function closeBoxLoginDialog() {
            const overlay = document.getElementById('vp-box-download-overlay');
            if (!overlay) return;
            overlay.hidden = true;
            overlay.setAttribute('aria-hidden', 'true');
        }

        async function requestBoxDownload(format) {
            const button = format === 'dxf' ? els.btnDxf : els.btnSvg;
            const originalHtml = button?.innerHTML;
            if (button) {
                button.disabled = true;
                button.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Preparing…';
            }

            try {
                const response = await fetch(BOX_DOWNLOAD_ENDPOINT, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'content-type': 'application/json', 'accept': '*/*' },
                    body: JSON.stringify({
                        app: 'box-generator',
                        version: 1,
                        format,
                        settings: cloneApplicationState()
                    })
                });

                if (response.status === 401) {
                    openBoxLoginDialog();
                    return;
                }

                if (!response.ok) {
                    const data = await response.json().catch(() => null);
                    throw new Error(data?.error?.message || 'We could not prepare your cutting file. Please try again.');
                }

                const disposition = response.headers.get('content-disposition') || '';
                const encodedName = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
                const plainName = disposition.match(/filename="?([^";]+)"?/i)?.[1];
                const filename = encodedName
                    ? decodeURIComponent(encodedName)
                    : (plainName || buildBoxFilename(format));
                downloadBlob(await response.blob(), filename);
            } catch (error) {
                console.error('Box download failed:', error);
                window.alert(error?.message || 'We could not prepare your cutting file. Please try again.');
            } finally {
                if (button) {
                    button.disabled = false;
                    button.innerHTML = originalHtml;
                }
            }
        }

        const THICKNESS_PRESETS = [
            { mm: 3, labelMm: '3 mm (0.118")', labelIn: '0.118" (3 mm)' },
            { mm: 3.175, labelMm: '3.175 mm (1/8")', labelIn: '1/8" (3.175 mm)' },
            { mm: 4, labelMm: '4 mm (0.157")', labelIn: '0.157" (4 mm)' },
            { mm: 5, labelMm: '5 mm (0.197")', labelIn: '0.197" (5 mm)' },
            { mm: 6, labelMm: '6 mm (0.236")', labelIn: '0.236" (6 mm)' },
            { mm: 6.35, labelMm: '6.35 mm (1/4")', labelIn: '1/4" (6.35 mm)' }
        ];

        function updateThicknessDropdownOptions() {
            const select = els.thicknessSelect;
            select.innerHTML = "";
            
            // 1. Check if current state.thickness matches any preset
            let matched = false;
            THICKNESS_PRESETS.forEach(p => {
                if (Math.abs(p.mm - state.thickness) < 1e-4) {
                    matched = true;
                }
            });
            
            // 2. If it's custom, create a temporary custom option and select it
            if (!matched) {
                const opt = document.createElement("option");
                opt.value = state.thickness.toString();
                
                const factor = (state.unit === 'in') ? (1 / MM_PER_INCH) : 1;
                const displayVal = state.thickness * factor;
                
                if (state.unit === 'in') {
                    opt.textContent = `${displayVal.toFixed(3)}" (${state.thickness.toFixed(1)} mm)`;
                } else {
                    opt.textContent = `${displayVal.toFixed(1)} mm (${(state.thickness / MM_PER_INCH).toFixed(3)}")`;
                }
                select.appendChild(opt);
            }
            
            // 3. Add standard presets
            THICKNESS_PRESETS.forEach(p => {
                const opt = document.createElement("option");
                opt.value = p.mm.toString();
                opt.textContent = (state.unit === 'in') ? p.labelIn : p.labelMm;
                select.appendChild(opt);
            });
            
            // 4. Force select current value
            for (let opt of select.options) {
                if (opt.value && Math.abs(parseFloat(opt.value) - state.thickness) < 1e-4) {
                    select.value = opt.value;
                    break;
                }
            }
        }

        // ==========================================
        // 4. USER INTERFACE & INTERACTION
        // ==========================================

        function renderDividerControls() {
            if (!els.dividerPositionList) return;
            syncDividerPositionsFromCounts(false);
            const d = state.dividers;
            const dims = getResolvedBoxDimensions();
            const expandableInternalMax = Math.max(dims.t, MAX_DIMENSION_MM - 2 * dims.t);
            els.dividerWidthCount.max = String(getMaxDividerCountForAxis(
                'width',
                getAxisCellSizeLock('width') === null ? dims.W_int : expandableInternalMax,
                dims.t
            ));
            els.dividerDepthCount.max = String(getMaxDividerCount(
                getAxisCellSizeLock('depth') === null ? dims.D_int : expandableInternalMax,
                dims.t
            ));
            els.dividerWidthCount.value = d.widthSections;
            els.dividerDepthCount.value = d.depthSections;
            const factor = state.unit === 'in' ? 1 / MM_PER_INCH : 1;
            const decimals = state.unit === 'in' ? 3 : 2;
            const minCell = getMinimumDividerCellSize(dims.t);
            const renderAxisCellSize = (axis, input, positions, length) => {
                const sizes = getDividerCellSizes(positions, length, dims.t);
                const uniform = sizes.every(size => Math.abs(size - sizes[0]) <= 1e-5);
                const lockedSize = getAxisCellSizeLock(axis);
                input.min = fmtTrim(minCell * factor, decimals);
                input.step = state.unit === 'in' ? '0.01' : '0.1';
                input.placeholder = uniform || lockedSize !== null ? '' : 'Mixed';
                if (document.activeElement !== input) {
                    input.value = lockedSize !== null
                        ? fmtTrim(lockedSize * factor, decimals)
                        : (uniform ? fmtTrim(sizes[0] * factor, decimals) : '');
                }
                updateAxisCellSizeLockButton(axis);
            };
            renderAxisCellSize('width', els.dividerCellWidth, d.widthPositions, dims.W_int);
            renderAxisCellSize('depth', els.dividerCellDepth, d.depthPositions, dims.D_int);
            document.querySelectorAll('[data-divider-unit]').forEach(unit => { unit.textContent = state.unit; });
            const sideJointsUnavailable = state.boxType === 'closed'
                || ensureRemovableLidState().enabled
                || ensureSlideLidState().enabled
                || ensureDoorLidState().enabled
                || ensureTwoDoorLidState().enabled;
            if (sideJointsUnavailable) d.addSideSlots = false;
            els.dividerSideSlots.checked = d.addSideSlots;
            els.dividerSideSlots.disabled = sideJointsUnavailable;
            els.dividerSideSlots.title = sideJointsUnavailable
                ? (state.boxType === 'closed' ? 'Available for open boxes only' : 'Unavailable with a lid')
                : '';
            els.dividerBottomSlots.checked = d.addBottomSlots;
            els.dividersButton.classList.toggle('active', d.enabled);
            els.removeAllDividers.disabled = !d.enabled;

            els.dividerPositionList.innerHTML = '';
            const rows = [
                ...d.widthPositions.map((pos, idx) => ({ axis: 'width', label: `W${idx + 1}`, pos, idx })),
                ...d.depthPositions.map((pos, idx) => ({ axis: 'depth', label: `D${idx + 1}`, pos, idx }))
            ];

            rows.forEach(row => {
                const wrap = document.createElement('div');
                wrap.className = 'divider-row';

                const label = document.createElement('span');
                label.textContent = `${row.label} ${Math.round(row.pos * 100)}%`;

                const remove = document.createElement('button');
                remove.type = 'button';
                remove.className = 'divider-remove';
                remove.innerHTML = '<i class="fa-solid fa-trash" aria-hidden="true"></i>';
                remove.setAttribute('aria-label', `Remove ${row.axis} divider ${row.idx + 1}`);
                remove.disabled = isDividerBoundaryLocked(row.axis, row.idx);
                remove.addEventListener('click', () => {
                    if (isDividerBoundaryLocked(row.axis, row.idx)) return;
                    pushUndoSnapshot();
                    removeDividerDefinition(row.axis, row.idx);
                    renderDividerControls();
                    updateAll();
                });

                wrap.appendChild(label);
                wrap.appendChild(remove);
                els.dividerPositionList.appendChild(wrap);
            });
        }

        function clearAllDividers() {
            const d = state.dividers;
            d.enabled = false;
            d.widthSections = 0;
            d.depthSections = 0;
            d.widthPositions = [];
            d.depthPositions = [];
            d.removedSegments = { width: {}, depth: {} };
            d.lockedCells = { width: {}, depth: {} };
            d.lockedSections = {};
            d.axisCellSizeLocks = { width: null, depth: null };
            hoveredCell = null;
            hoveredDividerSegment = null;
            activeDividerDrag = null;
            els.cellHoverEditor.hidden = true;
            els.segmentHoverEditor.hidden = true;
            renderDividerControls();
            updateAll();
        }

        function renderBottomLiftControls() {
            if (!els.bottomLiftValue) return;
            const dims = getResolvedBoxDimensions();
            const factor = state.unit === 'in' ? 1 / MM_PER_INCH : 1;
            const decimals = state.unit === 'in' ? 3 : 2;
            const maxDisplay = getMaxBottomLift(dims) * factor;
            els.bottomLiftValue.min = '0';
            els.bottomLiftValue.max = fmtTrim(maxDisplay, decimals);
            els.bottomLiftValue.step = state.unit === 'in' ? '0.01' : '0.1';
            els.bottomLiftUnit.textContent = state.unit;
            if (document.activeElement !== els.bottomLiftValue) {
                els.bottomLiftValue.value = fmtTrim(state.bottomLift * factor, decimals);
            }
        }

        function renderRemovableLidControls() {
            if (!els.removableLidButton) return;
            const lid = ensureRemovableLidState();
            const factor = state.unit === 'in' ? 1 / MM_PER_INCH : 1;
            const decimals = state.unit === 'in' ? 3 : 2;
            const dims = getResolvedBoxDimensions();
            const maxRadius = Math.max(0, Math.min(dims.W_int, dims.D_int) / 2);
            lid.cornerRadius = Math.max(0, Math.min(lid.cornerRadius, maxRadius));
            els.removableLidButton.classList.toggle('active', lid.enabled);
            els.removeRemovableLid.disabled = !lid.enabled;
            els.lidCornerRadius.max = fmtTrim(maxRadius * factor, decimals);
            els.lidCornerRadius.step = state.unit === 'in' ? '0.01' : '0.1';
            if (document.activeElement !== els.lidCornerRadius) {
                els.lidCornerRadius.value = fmtTrim(lid.cornerRadius * factor, decimals);
            }
            els.lidRadiusUnit.textContent = state.unit;
            els.lidAddHandle.checked = lid.addHandle;
            els.lidAddHandle.disabled = !lid.enabled;
            if (!lid.enabled || !lid.addHandle) {
                selectedLidHandle = false;
                els.handleSizeEditor.hidden = true;
            }
            els.lidModeButtons.forEach(button => {
                const active = button.dataset.lidMode === (lid.open ? 'open' : 'closed');
                button.classList.toggle('active', active);
                button.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
        }

        function animateRemovableLid(open) {
            const lid = ensureRemovableLidState();
            if (!lid.enabled) return;
            if (lidAnimationFrame) cancelAnimationFrame(lidAnimationFrame);
            const from = lid.openProgress;
            const to = open ? 1 : 0;
            lid.open = open;
            renderRemovableLidControls();
            if (Math.abs(to - from) <= 1e-6) {
                lid.openProgress = to;
                updateBox3D();
                return;
            }
            const started = performance.now();
            const duration = 520;
            const tick = now => {
                const raw = Math.min(1, (now - started) / duration);
                const eased = raw < 0.5 ? 2 * raw * raw : 1 - Math.pow(-2 * raw + 2, 2) / 2;
                lid.openProgress = from + (to - from) * eased;
                updateBox3D();
                if (raw < 1) lidAnimationFrame = requestAnimationFrame(tick);
                else lidAnimationFrame = 0;
            };
            lidAnimationFrame = requestAnimationFrame(tick);
        }

        function renderSlideLidControls() {
            if (!els.slideLidButton) return;
            const lid = ensureSlideLidState();
            els.slideLidButton.classList.toggle('active', lid.enabled);
            els.removeSlideLid.disabled = !lid.enabled;
            els.removeSlideLid.classList.toggle('active', lid.enabled);
            els.removeSlideLid.setAttribute('aria-pressed', lid.enabled ? 'true' : 'false');
            els.slideLidModeButtons.forEach(button => {
                const active = button.dataset.slideLidMode === (lid.open ? 'open' : 'closed');
                button.classList.toggle('active', active);
                button.setAttribute('aria-pressed', active ? 'true' : 'false');
                button.disabled = !lid.enabled;
            });
        }

        function animateSlideLid(open) {
            const lid = ensureSlideLidState();
            if (!lid.enabled) return;
            if (slideLidAnimationFrame) cancelAnimationFrame(slideLidAnimationFrame);
            const from = lid.openProgress;
            const to = open ? 1 : 0;
            lid.open = open;
            renderSlideLidControls();
            if (Math.abs(to - from) <= 1e-6) {
                lid.openProgress = to;
                updateBox3D();
                return;
            }
            const started = performance.now();
            const duration = 560;
            const tick = now => {
                const raw = Math.min(1, (now - started) / duration);
                const eased = raw < 0.5 ? 2 * raw * raw : 1 - Math.pow(-2 * raw + 2, 2) / 2;
                lid.openProgress = from + (to - from) * eased;
                updateBox3D();
                if (raw < 1) slideLidAnimationFrame = requestAnimationFrame(tick);
                else slideLidAnimationFrame = 0;
            };
            slideLidAnimationFrame = requestAnimationFrame(tick);
        }

        function renderDoorLidControls() {
            if (!els.doorLidButton) return;
            const lid = ensureDoorLidState();
            els.doorLidButton.classList.toggle('active', lid.enabled);
            els.removeDoorLid.disabled = !lid.enabled;
            els.removeDoorLid.classList.toggle('active', lid.enabled);
            els.removeDoorLid.setAttribute('aria-pressed', lid.enabled ? 'true' : 'false');
            els.doorLidModeButtons.forEach(button => {
                const active = button.dataset.doorLidMode === (lid.open ? 'open' : 'closed');
                button.classList.toggle('active', active);
                button.setAttribute('aria-pressed', active ? 'true' : 'false');
                button.disabled = !lid.enabled;
            });
        }

        function animateDoorLid(open) {
            const lid = ensureDoorLidState();
            if (!lid.enabled) return;
            if (doorLidAnimationFrame) cancelAnimationFrame(doorLidAnimationFrame);
            const from = lid.openProgress;
            const to = open ? 1 : 0;
            lid.open = open;
            renderDoorLidControls();
            if (Math.abs(to - from) <= 1e-6) {
                lid.openProgress = to;
                updateBox3D();
                return;
            }
            const started = performance.now();
            const duration = 620;
            const tick = now => {
                const raw = Math.min(1, (now - started) / duration);
                const eased = raw < 0.5 ? 2 * raw * raw : 1 - Math.pow(-2 * raw + 2, 2) / 2;
                lid.openProgress = from + (to - from) * eased;
                updateBox3D();
                if (raw < 1) doorLidAnimationFrame = requestAnimationFrame(tick);
                else doorLidAnimationFrame = 0;
            };
            doorLidAnimationFrame = requestAnimationFrame(tick);
        }

        function renderTwoDoorLidControls() {
            if (!els.twoDoorLidButton) return;
            const lid = ensureTwoDoorLidState();
            els.twoDoorLidButton.classList.toggle('active', lid.enabled);
            els.removeTwoDoorLid.disabled = !lid.enabled;
            els.removeTwoDoorLid.classList.toggle('active', lid.enabled);
            els.removeTwoDoorLid.setAttribute('aria-pressed', lid.enabled ? 'true' : 'false');
            els.twoDoorLidModeButtons.forEach(button => {
                const active = button.dataset.twoDoorLidMode === (lid.open ? 'open' : 'closed');
                button.classList.toggle('active', active);
                button.setAttribute('aria-pressed', active ? 'true' : 'false');
                button.disabled = !lid.enabled;
            });
        }

        function animateTwoDoorLid(open) {
            const lid = ensureTwoDoorLidState();
            if (!lid.enabled) return;
            if (twoDoorLidAnimationFrame) cancelAnimationFrame(twoDoorLidAnimationFrame);
            const from = lid.openProgress;
            const to = open ? 1 : 0;
            lid.open = open;
            renderTwoDoorLidControls();
            if (Math.abs(to - from) <= 1e-6) {
                lid.openProgress = to;
                updateBox3D();
                return;
            }
            const started = performance.now();
            const duration = 620;
            const tick = now => {
                const raw = Math.min(1, (now - started) / duration);
                const eased = raw < 0.5 ? 2 * raw * raw : 1 - Math.pow(-2 * raw + 2, 2) / 2;
                lid.openProgress = from + (to - from) * eased;
                updateBox3D();
                if (raw < 1) twoDoorLidAnimationFrame = requestAnimationFrame(tick);
                else twoDoorLidAnimationFrame = 0;
            };
            twoDoorLidAnimationFrame = requestAnimationFrame(tick);
        }

        function setupUI() {
            const downloadOverlay = document.getElementById('vp-box-download-overlay');
            const downloadClose = document.getElementById('vp-box-download-close');
            const downloadCancel = document.getElementById('vp-box-download-cancel');
            [downloadClose, downloadCancel].forEach(button => button?.addEventListener('click', closeBoxLoginDialog));
            downloadOverlay?.addEventListener('click', event => {
                if (event.target === downloadOverlay) closeBoxLoginDialog();
            });
            document.addEventListener('keydown', event => {
                if (event.key === 'Escape' && downloadOverlay && !downloadOverlay.hidden) closeBoxLoginDialog();
            });

            if (!els.appRoot.dataset.undoReady) {
                els.appRoot.dataset.undoReady = 'true';
                els.appRoot.addEventListener('pointerdown', event => {
                    const control = event.target.closest('button, input, select');
                    if (control && els.appRoot.contains(control)) pushUndoSnapshot();
                }, true);
                els.appRoot.addEventListener('keydown', event => {
                    if (event.ctrlKey || event.metaKey) return;
                    const control = event.target.closest && event.target.closest('input, select, textarea');
                    if (control && els.appRoot.contains(control)) pushUndoSnapshot();
                }, true);
                document.addEventListener('keydown', event => {
                    const undoKey = (event.ctrlKey || event.metaKey) && !event.shiftKey && event.key.toLowerCase() === 'z';
                    if (!undoKey) return;
                    if (undoLastOperation()) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }, true);
            }

            // The page may still contain older max attributes in its HTML.
            // Override them here so manual entry works immediately without requiring a unit toggle.
            const initialDimensionMax = (state.unit === 'in') ? (MAX_DIMENSION_MM / MM_PER_INCH) : MAX_DIMENSION_MM;
            const initialThicknessMax = (state.unit === 'in') ? (MAX_THICKNESS_MM / MM_PER_INCH) : MAX_THICKNESS_MM;

            [els.widthNum, els.heightNum, els.depthNum].forEach(input => {
                if (input) input.max = String(initialDimensionMax);
            });
            if (els.thicknessNum) {
                els.thicknessNum.max = String(initialThicknessMax);
            }

            if (els.viewThemeButtons && els.viewThemeButtons.length) {
                els.viewThemeButtons.forEach(button => {
                    button.addEventListener('click', () => {
                        applyViewTheme(button.dataset.viewTheme || 'night');
                    });
                });
            }

            if (els.dividersButton && els.dividersPopover) {
                els.dividersButton.addEventListener('click', () => {
                    const willOpen = els.dividersPopover.hidden;
                    if (willOpen && !state.dividers.enabled) {
                        state.dividers.widthSections = 1;
                        state.dividers.depthSections = 1;
                        resetRemovedDividerSegments();
                        syncDividerPositionsFromCounts(true);
                        updateAll();
                    }
                    els.dividersPopover.hidden = !willOpen;
                    els.dividersButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
                    if (willOpen && els.removableLidPopover) {
                        els.removableLidPopover.hidden = true;
                        els.removableLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.slideLidPopover) {
                        els.slideLidPopover.hidden = true;
                        els.slideLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.doorLidPopover) {
                        els.doorLidPopover.hidden = true;
                        els.doorLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.twoDoorLidPopover) {
                        els.twoDoorLidPopover.hidden = true;
                        els.twoDoorLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen) renderDividerControls();
                });

                document.addEventListener('click', (event) => {
                    if (els.dividersPopover.hidden) return;
                    const tool = els.dividersPopover.closest('.divider-tool');
                    if (tool && !tool.contains(event.target)) {
                        els.dividersPopover.hidden = true;
                        els.dividersButton.setAttribute('aria-expanded', 'false');
                    }
                });

                const handleDividerCount = (axis) => {
                    const dims = getResolvedBoxDimensions();
                    if (axis === 'width') {
                        const requested = parseInt(els.dividerWidthCount.value, 10);
                        if (!Number.isFinite(requested)) return;
                        const countLength = getAxisCellSizeLock('width') === null
                            ? dims.W_int
                            : Math.max(dims.t, MAX_DIMENSION_MM - 2 * dims.t);
                        state.dividers.widthSections = Math.min(
                            requested,
                            getMaxDividerCountForAxis('width', countLength, dims.t)
                        );
                        state.dividers.widthPositions = evenDividerPositions(state.dividers.widthSections, dims.W_int, dims.t);
                    } else {
                        const requested = parseInt(els.dividerDepthCount.value, 10);
                        if (!Number.isFinite(requested)) return;
                        state.dividers.depthSections = requested;
                        state.dividers.depthPositions = evenDividerPositions(state.dividers.depthSections, dims.D_int, dims.t);
                    }
                    resetRemovedDividerSegments();
                    syncDividerPositionsFromCounts(false);
                    renderDividerControls();
                    updateAll();
                };

                els.dividerWidthCount.addEventListener('input', () => handleDividerCount('width'));
                els.dividerDepthCount.addEventListener('input', () => handleDividerCount('depth'));
                els.dividerWidthCount.addEventListener('change', () => handleDividerCount('width'));
                els.dividerDepthCount.addEventListener('change', () => handleDividerCount('depth'));

                const handleUniformCellSize = (axis, input) => {
                    const factor = state.unit === 'in' ? MM_PER_INCH : 1;
                    const valueMm = parseFloat(String(input.value).replace(',', '.')) * factor;
                    if (!Number.isFinite(valueMm)) return;
                    setUniformDividerCellSize(axis, valueMm);
                };
                els.dividerCellWidth.addEventListener('change', () => handleUniformCellSize('width', els.dividerCellWidth));
                els.dividerCellDepth.addEventListener('change', () => handleUniformCellSize('depth', els.dividerCellDepth));
                els.dividerCellWidthLock.addEventListener('click', event => {
                    event.preventDefault();
                    toggleAxisCellSizeLock('width');
                });
                els.dividerCellDepthLock.addEventListener('click', event => {
                    event.preventDefault();
                    toggleAxisCellSizeLock('depth');
                });
                [[els.dividerCellWidth, 'width'], [els.dividerCellDepth, 'depth']].forEach(([input, axis]) => {
                    input.addEventListener('keydown', event => {
                        if (event.key === 'Enter') {
                            handleUniformCellSize(axis, input);
                            input.blur();
                        }
                    });
                });
                els.dividerSideSlots.addEventListener('change', () => {
                    state.dividers.addSideSlots = state.boxType === 'open'
                        && !ensureRemovableLidState().enabled
                        && !ensureSlideLidState().enabled
                        && !ensureDoorLidState().enabled
                        && !ensureTwoDoorLidState().enabled
                        && els.dividerSideSlots.checked;
                    updateAll();
                });
                els.dividerBottomSlots.addEventListener('change', () => {
                    state.dividers.addBottomSlots = els.dividerBottomSlots.checked;
                    if (state.dividers.addBottomSlots) {
                        ensureCurrentDividerLayoutFits('width');
                        ensureCurrentDividerLayoutFits('depth');
                    }
                    syncDividerPositionsFromCounts(false);
                    updateAll();
                });
                els.removeAllDividers.addEventListener('click', event => {
                    event.preventDefault();
                    if (!state.dividers.enabled) return;
                    clearAllDividers();
                });
                renderDividerControls();
            }

            if (els.removableLidButton && els.removableLidPopover) {
                els.removableLidButton.addEventListener('click', () => {
                    const willOpen = els.removableLidPopover.hidden;
                    const lid = ensureRemovableLidState();
                    if (willOpen && !lid.enabled) {
                        deactivateOtherLids('removable');
                        const slideLid = ensureSlideLidState();
                        if (slideLidAnimationFrame) cancelAnimationFrame(slideLidAnimationFrame);
                        slideLidAnimationFrame = 0;
                        slideLid.enabled = false;
                        slideLid.open = false;
                        slideLid.openProgress = 0;
                        const doorLid = ensureDoorLidState();
                        if (doorLidAnimationFrame) cancelAnimationFrame(doorLidAnimationFrame);
                        doorLidAnimationFrame = 0;
                        doorLid.enabled = false;
                        doorLid.open = false;
                        doorLid.openProgress = 0;
                        lid.enabled = true;
                        lid.addHandle = true;
                        lid.open = false;
                        lid.openProgress = 0;
                        state.dividers.addSideSlots = false;
                        state.boxType = 'open';
                        syncInterfaceFromState();
                        updateAll();
                    }
                    els.removableLidPopover.hidden = !willOpen;
                    els.removableLidButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
                    if (willOpen && els.dividersPopover) {
                        els.dividersPopover.hidden = true;
                        els.dividersButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.slideLidPopover) {
                        els.slideLidPopover.hidden = true;
                        els.slideLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.doorLidPopover) {
                        els.doorLidPopover.hidden = true;
                        els.doorLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.twoDoorLidPopover) {
                        els.twoDoorLidPopover.hidden = true;
                        els.twoDoorLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen) renderRemovableLidControls();
                });

                els.removeRemovableLid.addEventListener('click', event => {
                    event.preventDefault();
                    const lid = ensureRemovableLidState();
                    if (!lid.enabled) return;
                    if (lidAnimationFrame) cancelAnimationFrame(lidAnimationFrame);
                    lidAnimationFrame = 0;
                    lid.enabled = false;
                    lid.open = false;
                    lid.openProgress = 0;
                    renderRemovableLidControls();
                    updateAll();
                });

                const updateLidRadius = () => {
                    const factor = state.unit === 'in' ? MM_PER_INCH : 1;
                    const value = parseFloat(String(els.lidCornerRadius.value).replace(',', '.'));
                    if (!Number.isFinite(value)) return;
                    ensureRemovableLidState().cornerRadius = Math.max(0, value * factor);
                    updateAll();
                };
                els.lidCornerRadius.addEventListener('change', updateLidRadius);
                els.lidCornerRadius.addEventListener('keydown', event => {
                    if (event.key !== 'Enter') return;
                    updateLidRadius();
                    els.lidCornerRadius.blur();
                });
                els.lidAddHandle.addEventListener('change', () => {
                    const lid = ensureRemovableLidState();
                    lid.addHandle = lid.enabled && els.lidAddHandle.checked;
                    if (!lid.addHandle) {
                        selectedLidHandle = false;
                        els.handleSizeEditor.hidden = true;
                    }
                    updateAll();
                });
                els.lidModeButtons.forEach(button => {
                    button.addEventListener('click', () => {
                        animateRemovableLid(button.dataset.lidMode === 'open');
                    });
                });

                document.addEventListener('click', event => {
                    if (els.removableLidPopover.hidden) return;
                    const tool = els.removableLidPopover.closest('.removable-lid-tool');
                    if (tool && !tool.contains(event.target)) {
                        els.removableLidPopover.hidden = true;
                        els.removableLidButton.setAttribute('aria-expanded', 'false');
                    }
                });
                renderRemovableLidControls();
            }

            if (els.slideLidButton && els.slideLidPopover) {
                els.slideLidButton.addEventListener('click', () => {
                    const willOpen = els.slideLidPopover.hidden;
                    const lid = ensureSlideLidState();
                    if (willOpen && !lid.enabled) {
                        deactivateOtherLids('slide');
                        if (lidAnimationFrame) cancelAnimationFrame(lidAnimationFrame);
                        lidAnimationFrame = 0;
                        const removableLid = ensureRemovableLidState();
                        removableLid.enabled = false;
                        removableLid.open = false;
                        removableLid.openProgress = 0;
                        const doorLid = ensureDoorLidState();
                        if (doorLidAnimationFrame) cancelAnimationFrame(doorLidAnimationFrame);
                        doorLidAnimationFrame = 0;
                        doorLid.enabled = false;
                        doorLid.open = false;
                        doorLid.openProgress = 0;
                        lid.enabled = true;
                        lid.open = false;
                        lid.openProgress = 0;
                        state.boxType = 'open';
                        state.dividers.addSideSlots = false;
                        syncInterfaceFromState();
                        updateAll();
                    }
                    els.slideLidPopover.hidden = !willOpen;
                    els.slideLidButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
                    if (willOpen && els.dividersPopover) {
                        els.dividersPopover.hidden = true;
                        els.dividersButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.removableLidPopover) {
                        els.removableLidPopover.hidden = true;
                        els.removableLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.doorLidPopover) {
                        els.doorLidPopover.hidden = true;
                        els.doorLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.twoDoorLidPopover) {
                        els.twoDoorLidPopover.hidden = true;
                        els.twoDoorLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen) renderSlideLidControls();
                });

                els.removeSlideLid.addEventListener('click', event => {
                    event.preventDefault();
                    const lid = ensureSlideLidState();
                    if (!lid.enabled) return;
                    if (slideLidAnimationFrame) cancelAnimationFrame(slideLidAnimationFrame);
                    slideLidAnimationFrame = 0;
                    lid.enabled = false;
                    lid.open = false;
                    lid.openProgress = 0;
                    renderSlideLidControls();
                    updateAll();
                });

                els.slideLidModeButtons.forEach(button => {
                    button.addEventListener('click', () => {
                        animateSlideLid(button.dataset.slideLidMode === 'open');
                    });
                });

                document.addEventListener('click', event => {
                    if (els.slideLidPopover.hidden) return;
                    const tool = els.slideLidPopover.closest('.slide-lid-tool');
                    if (tool && !tool.contains(event.target)) {
                        els.slideLidPopover.hidden = true;
                        els.slideLidButton.setAttribute('aria-expanded', 'false');
                    }
                });
                renderSlideLidControls();
            }

            if (els.doorLidButton && els.doorLidPopover) {
                els.doorLidButton.addEventListener('click', () => {
                    const willOpen = els.doorLidPopover.hidden;
                    const lid = ensureDoorLidState();
                    if (willOpen && !lid.enabled) {
                        deactivateOtherLids('door');
                        if (lidAnimationFrame) cancelAnimationFrame(lidAnimationFrame);
                        if (slideLidAnimationFrame) cancelAnimationFrame(slideLidAnimationFrame);
                        lidAnimationFrame = 0;
                        slideLidAnimationFrame = 0;
                        const removableLid = ensureRemovableLidState();
                        const slideLid = ensureSlideLidState();
                        removableLid.enabled = false;
                        removableLid.open = false;
                        removableLid.openProgress = 0;
                        slideLid.enabled = false;
                        slideLid.open = false;
                        slideLid.openProgress = 0;
                        lid.enabled = true;
                        lid.open = false;
                        lid.openProgress = 0;
                        state.boxType = 'open';
                        state.dividers.addSideSlots = false;
                        syncInterfaceFromState();
                        updateAll();
                    }
                    els.doorLidPopover.hidden = !willOpen;
                    els.doorLidButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
                    if (willOpen && els.dividersPopover) {
                        els.dividersPopover.hidden = true;
                        els.dividersButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.removableLidPopover) {
                        els.removableLidPopover.hidden = true;
                        els.removableLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.slideLidPopover) {
                        els.slideLidPopover.hidden = true;
                        els.slideLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.twoDoorLidPopover) {
                        els.twoDoorLidPopover.hidden = true;
                        els.twoDoorLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen) renderDoorLidControls();
                });

                els.removeDoorLid.addEventListener('click', event => {
                    event.preventDefault();
                    const lid = ensureDoorLidState();
                    if (!lid.enabled) return;
                    if (doorLidAnimationFrame) cancelAnimationFrame(doorLidAnimationFrame);
                    doorLidAnimationFrame = 0;
                    lid.enabled = false;
                    lid.open = false;
                    lid.openProgress = 0;
                    renderDoorLidControls();
                    updateAll();
                });

                els.doorLidModeButtons.forEach(button => {
                    button.addEventListener('click', () => {
                        animateDoorLid(button.dataset.doorLidMode === 'open');
                    });
                });

                document.addEventListener('click', event => {
                    if (els.doorLidPopover.hidden) return;
                    const tool = els.doorLidPopover.closest('.door-lid-tool');
                    if (tool && !tool.contains(event.target)) {
                        els.doorLidPopover.hidden = true;
                        els.doorLidButton.setAttribute('aria-expanded', 'false');
                    }
                });
                renderDoorLidControls();
            }

            if (els.twoDoorLidButton && els.twoDoorLidPopover) {
                els.twoDoorLidButton.addEventListener('click', () => {
                    const willOpen = els.twoDoorLidPopover.hidden;
                    const lid = ensureTwoDoorLidState();
                    if (willOpen && !lid.enabled) {
                        deactivateOtherLids('two-door');
                        lid.enabled = true;
                        lid.open = false;
                        lid.openProgress = 0;
                        state.boxType = 'open';
                        state.dividers.addSideSlots = false;
                        syncInterfaceFromState();
                        updateAll();
                    }
                    els.twoDoorLidPopover.hidden = !willOpen;
                    els.twoDoorLidButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
                    if (willOpen && els.dividersPopover) {
                        els.dividersPopover.hidden = true;
                        els.dividersButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.removableLidPopover) {
                        els.removableLidPopover.hidden = true;
                        els.removableLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.slideLidPopover) {
                        els.slideLidPopover.hidden = true;
                        els.slideLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen && els.doorLidPopover) {
                        els.doorLidPopover.hidden = true;
                        els.doorLidButton.setAttribute('aria-expanded', 'false');
                    }
                    if (willOpen) renderTwoDoorLidControls();
                });

                els.removeTwoDoorLid.addEventListener('click', event => {
                    event.preventDefault();
                    const lid = ensureTwoDoorLidState();
                    if (!lid.enabled) return;
                    if (twoDoorLidAnimationFrame) cancelAnimationFrame(twoDoorLidAnimationFrame);
                    twoDoorLidAnimationFrame = 0;
                    lid.enabled = false;
                    lid.open = false;
                    lid.openProgress = 0;
                    renderTwoDoorLidControls();
                    updateAll();
                });

                els.twoDoorLidModeButtons.forEach(button => {
                    button.addEventListener('click', () => {
                        animateTwoDoorLid(button.dataset.twoDoorLidMode === 'open');
                    });
                });

                document.addEventListener('click', event => {
                    if (els.twoDoorLidPopover.hidden) return;
                    const tool = els.twoDoorLidPopover.closest('.two-door-lid-tool');
                    if (tool && !tool.contains(event.target)) {
                        els.twoDoorLidPopover.hidden = true;
                        els.twoDoorLidButton.setAttribute('aria-expanded', 'false');
                    }
                });
                renderTwoDoorLidControls();
            }

            bindInput('width-input', 'width-num', 'width', true);
            bindInput('height-input', 'height-num', 'height', true);
            bindInput('depth-input', 'depth-num', 'depth', true);
            // Thickness input & preset handling
            els.thicknessSelect.addEventListener('change', () => {
                const val = parseFloat(els.thicknessSelect.value);
                if (isNaN(val)) return;
                state.thickness = val;
                
                // Sync the number input
                const factor = (state.unit === 'in') ? (1 / MM_PER_INCH) : 1;
                const displayVal = val * factor;
                els.thicknessNum.value = (state.unit === 'in') ? displayVal.toFixed(3) : fmtTrim(displayVal, 3);
                
                updateAll();
            });

            function handleThicknessInput(valStr) {
                if (typeof valStr === 'string') {
                    valStr = valStr.replace(',', '.');
                }
                let val = parseFloat(valStr);
                if (isNaN(val)) return;
                
                const factor = (state.unit === 'in') ? (1 / MM_PER_INCH) : 1;
                const min = 1.0 * factor;
                const max = MAX_THICKNESS_MM * factor;
                
                if (val < min) val = min;
                if (val > max) val = max;
                
                if (state.unit === 'in') {
                    state.thickness = val * MM_PER_INCH;
                } else {
                    state.thickness = val;
                }
                
                els.thicknessSelect.value = ""; // Clear preset select when user types manually
                updateAll();
            }
            
            els.thicknessNum.addEventListener('change', () => handleThicknessInput(els.thicknessNum.value));
            updateThicknessDropdownOptions();
            bindInput('finger-size-input', 'finger-size-num', 'fingerSize', true);
            
            const unitBtns = els.unitCtrl.querySelectorAll('.segment-btn');
            unitBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    const newUnit = btn.dataset.unit;
                    if (newUnit !== state.unit) {
                        unitBtns.forEach(b => {
                            b.classList.remove('active');
                            b.setAttribute('aria-pressed', 'false');
                        });
                        btn.classList.add('active');
                        btn.setAttribute('aria-pressed', 'true');
                        changeUnit(newUnit);
                    }
                });
            });
            
            const dimBtns = els.dimTypeCtrl.querySelectorAll('.segment-btn');
            dimBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    const newType = btn.dataset.type;
                    if (newType !== state.dimType) {
                        dimBtns.forEach(b => {
                            b.classList.remove('active');
                            b.setAttribute('aria-pressed', 'false');
                        });
                        btn.classList.add('active');
                        btn.setAttribute('aria-pressed', 'true');
                        state.dimType = newType;
                        updateAll();
                    }
                });
            });
            
            const boxTypeBtns = els.boxTypeCtrl.querySelectorAll('.segment-btn');
            boxTypeBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    const newType = btn.dataset.type;
                    if (newType !== state.boxType) {
                        boxTypeBtns.forEach(b => {
                            b.classList.remove('active');
                            b.setAttribute('aria-pressed', 'false');
                        });
                        btn.classList.add('active');
                        btn.setAttribute('aria-pressed', 'true');
                        state.boxType = newType;
                        if (newType === 'closed') {
                            if (lidAnimationFrame) cancelAnimationFrame(lidAnimationFrame);
                            lidAnimationFrame = 0;
                            state.dividers.addSideSlots = false;
                            const lid = ensureRemovableLidState();
                            lid.enabled = false;
                            lid.open = false;
                            lid.openProgress = 0;
                            if (els.removableLidPopover) els.removableLidPopover.hidden = true;
                            if (els.removableLidButton) els.removableLidButton.setAttribute('aria-expanded', 'false');
                            if (slideLidAnimationFrame) cancelAnimationFrame(slideLidAnimationFrame);
                            slideLidAnimationFrame = 0;
                            const slideLid = ensureSlideLidState();
                            slideLid.enabled = false;
                            slideLid.open = false;
                            slideLid.openProgress = 0;
                            if (els.slideLidPopover) els.slideLidPopover.hidden = true;
                            if (els.slideLidButton) els.slideLidButton.setAttribute('aria-expanded', 'false');
                            if (doorLidAnimationFrame) cancelAnimationFrame(doorLidAnimationFrame);
                            doorLidAnimationFrame = 0;
                            const doorLid = ensureDoorLidState();
                            doorLid.enabled = false;
                            doorLid.open = false;
                            doorLid.openProgress = 0;
                            if (els.doorLidPopover) els.doorLidPopover.hidden = true;
                            if (els.doorLidButton) els.doorLidButton.setAttribute('aria-expanded', 'false');
                            if (twoDoorLidAnimationFrame) cancelAnimationFrame(twoDoorLidAnimationFrame);
                            twoDoorLidAnimationFrame = 0;
                            const twoDoorLid = ensureTwoDoorLidState();
                            twoDoorLid.enabled = false;
                            twoDoorLid.open = false;
                            twoDoorLid.openProgress = 0;
                            if (els.twoDoorLidPopover) els.twoDoorLidPopover.hidden = true;
                            if (els.twoDoorLidButton) els.twoDoorLidButton.setAttribute('aria-expanded', 'false');
                            els.cellHoverEditor.hidden = true;
                            els.segmentHoverEditor.hidden = true;
                        }
                        updateAll();
                    }
                });
            });
            

            
            els.kerfNum.addEventListener('change', () => {
                let val = parseFloat(els.kerfNum.value);
                if (isNaN(val)) val = 0.10;
                
                let t = state.thickness;
                let maxAbsKerf = t / 2;
                let limitKerf = maxAbsKerf - (state.unit === 'in' ? 0.001 : 0.01);
                
                if (state.unit === 'in') {
                    let valMm = val * MM_PER_INCH;
                    if (Math.abs(valMm) >= maxAbsKerf) {
                        valMm = Math.sign(valMm) * limitKerf;
                    }
                    state.kerf = valMm;
                } else {
                    if (Math.abs(val) >= maxAbsKerf) {
                        val = Math.sign(val) * limitKerf;
                    }
                    state.kerf = val;
                }
                
                const factor = (state.unit === 'in') ? (1 / MM_PER_INCH) : 1;
                const displayVal = state.kerf * factor;
                els.kerfNum.value = (state.unit === 'in') ? displayVal.toFixed(3) : displayVal.toFixed(2);
                updateAll();
            });
            
            els.foldInput.addEventListener('input', () => {
                state.foldPercent = parseInt(els.foldInput.value);
                els.foldVal.textContent = state.foldPercent + '%';
                updateBox3D();
            });
            
            els.notchesCheckbox.addEventListener('change', () => {
                state.addNotches = els.notchesCheckbox.checked;
                els.notchDiameterContainer.style.display = state.addNotches ? 'flex' : 'none';
                updateAll();
            });

            els.kerfCheckbox.addEventListener('change', () => {
                state.addKerf = els.kerfCheckbox.checked;
                els.kerfInputContainer.style.display = state.addKerf ? 'flex' : 'none';
                updateAll();
            });

            els.notchDiameterNum.addEventListener('change', () => {
                let val = parseFloat(els.notchDiameterNum.value);
                if (isNaN(val) || val <= 0) val = 0.05;
                
                let t = state.thickness;
                let maxRadius = t / 4;
                
                if (state.unit === 'in') {
                    let maxRadiusDisplay = maxRadius / MM_PER_INCH;
                    if (val > maxRadiusDisplay) val = maxRadiusDisplay;
                    state.notchDiameter = val * 2 * MM_PER_INCH;
                } else {
                    if (val > maxRadius) val = maxRadius;
                    state.notchDiameter = val * 2;
                }
                
                const factor = (state.unit === 'in') ? (1 / MM_PER_INCH) : 1;
                const displayVal = (state.notchDiameter / 2) * factor;
                els.notchDiameterNum.value = (state.unit === 'in') ? displayVal.toFixed(3) : displayVal.toFixed(1);
                updateAll();
            });
            
            // Sync initial checkbox values and containers visibility
            els.notchesCheckbox.checked = state.addNotches;
            els.notchDiameterContainer.style.display = state.addNotches ? 'flex' : 'none';
            els.kerfCheckbox.checked = state.addKerf;
            els.kerfInputContainer.style.display = state.addKerf ? 'flex' : 'none';

            els.btnSvg.addEventListener('click', exportSVG);
            els.btnDxf.addEventListener('click', exportDXF);
            
            // About popup modal listeners. Keep it truly hidden until requested so it is
            // not treated as an intrusive interstitial by browsers or audit tools.
            const aboutOverlay = document.getElementById('about-popup-overlay');
            const aboutClose = document.getElementById('about-popup-close');
            if (els.btnAbout && aboutOverlay && aboutClose) {
                let aboutLastFocus = null;

                const openAboutPopup = () => {
                    aboutLastFocus = document.activeElement;
                    aboutOverlay.hidden = false;
                    aboutOverlay.setAttribute('aria-hidden', 'false');
                    window.requestAnimationFrame(() => {
                        aboutOverlay.classList.add('active');
                        aboutClose.focus({ preventScroll: true });
                    });
                };

                const closeAboutPopup = () => {
                    aboutOverlay.classList.remove('active');
                    aboutOverlay.setAttribute('aria-hidden', 'true');
                    window.setTimeout(() => {
                        if (!aboutOverlay.classList.contains('active')) {
                            aboutOverlay.hidden = true;
                        }
                    }, 320);
                    if (aboutLastFocus && typeof aboutLastFocus.focus === 'function') {
                        aboutLastFocus.focus({ preventScroll: true });
                    }
                };

                els.btnAbout.addEventListener('click', openAboutPopup);
                aboutClose.addEventListener('click', closeAboutPopup);
                aboutOverlay.addEventListener('click', (event) => {
                    if (event.target === aboutOverlay) closeAboutPopup();
                });
                document.addEventListener('keydown', (event) => {
                    if (event.key === 'Escape' && !aboutOverlay.hidden) closeAboutPopup();
                });
            }
        }

        function bindInput(sliderId, numId, stateProperty, integerOnly) {
            const slider = document.getElementById(sliderId);
            const num = document.getElementById(numId);
            
            function handleUpdate(valStr) {
                if (typeof valStr === 'string') {
                    valStr = valStr.replace(',', '.');
                }
                let val = parseFloat(valStr);
                if (isNaN(val)) return;
                
                let min = parseFloat(num.min);
                let max = parseFloat(num.max);
                if (val < min) val = min;
                if (val > max) val = max;
                
                if (integerOnly && state.unit === 'mm') val = Math.round(val);
                
                slider.value = val;
                num.value = val;
                
                let stateVal = val;
                if (stateProperty === 'fingerSize') {
                    stateVal = val * 2;
                }
                
                if (state.unit === 'in') {
                    state[stateProperty] = stateVal * MM_PER_INCH;
                } else {
                    state[stateProperty] = stateVal;
                }
                
                if (stateProperty === 'thickness') {
                    document.querySelectorAll('.preset-btn').forEach(b => b.classList.remove('active'));
                }
                
                updateAll();
            }
            
            slider.addEventListener('input', () => handleUpdate(slider.value));
            num.addEventListener('change', () => handleUpdate(num.value));
        }

        function changeUnit(newUnit) {
            const oldUnit = state.unit;
            state.unit = newUnit;
            
            const factor = (newUnit === 'mm') ? MM_PER_INCH : (1 / MM_PER_INCH);
            
            const limits = {
                mm: {
                    width: {
                        slider: { min: 20, max: 300, step: 1 },
                        num: { min: 20, max: MAX_DIMENSION_MM, step: 1 }
                    },
                    height: {
                        slider: { min: 20, max: 300, step: 1 },
                        num: { min: 20, max: MAX_DIMENSION_MM, step: 1 }
                    },
                    depth: {
                        slider: { min: 20, max: 300, step: 1 },
                        num: { min: 20, max: MAX_DIMENSION_MM, step: 1 }
                    },
                    thickness: {
                        min: 1.0, max: MAX_THICKNESS_MM, step: 0.1
                    },
                    fingerSize: {
                        slider: { min: 3, max: 150, step: 1 },
                        num: { min: 3, max: 150, step: 1 }
                    }
                },
                in: {
                    width: {
                        slider: { min: 0.8, max: 11.81, step: 0.1 },
                        num: { min: 0.8, max: MAX_DIMENSION_MM / MM_PER_INCH, step: 0.1 }
                    },
                    height: {
                        slider: { min: 0.8, max: 11.81, step: 0.1 },
                        num: { min: 0.8, max: MAX_DIMENSION_MM / MM_PER_INCH, step: 0.1 }
                    },
                    depth: {
                        slider: { min: 0.8, max: 11.81, step: 0.1 },
                        num: { min: 0.8, max: MAX_DIMENSION_MM / MM_PER_INCH, step: 0.1 }
                    },
                    thickness: {
                        min: 0.04, max: MAX_THICKNESS_MM / MM_PER_INCH, step: 0.001
                    },
                    fingerSize: {
                        slider: { min: 0.1, max: 6.0, step: 0.05 },
                        num: { min: 0.1, max: 6.0, step: 0.05 }
                    }
                }
            };
            
            document.querySelectorAll('.unit-label').forEach(el => {
                el.textContent = newUnit;
            });
            
            const list = [
                { prop: 'width', slider: els.widthInput, num: els.widthNum },
                { prop: 'height', slider: els.heightInput, num: els.heightNum },
                { prop: 'depth', slider: els.depthInput, num: els.depthNum },
                { prop: 'fingerSize', slider: els.fingerSizeInput, num: els.fingerSizeNum }
            ];
            
            const lim = limits[newUnit];
            
            list.forEach(item => {
                const pLim = lim[item.prop];
                
                if (pLim.slider) {
                    item.slider.min = pLim.slider.min;
                    item.slider.max = pLim.slider.max;
                    item.slider.step = pLim.slider.step;
                    
                    item.num.min = pLim.num.min;
                    item.num.max = pLim.num.max;
                    item.num.step = pLim.num.step;
                } else {
                    item.slider.min = pLim.min;
                    item.slider.max = pLim.max;
                    item.slider.step = pLim.step;
                    
                    item.num.min = pLim.min;
                    item.num.max = pLim.max;
                    item.num.step = pLim.step;
                }
                
                let currentDisplayVal = parseFloat(item.num.value) * factor;
                if (newUnit === 'mm') {
                    if (item.prop === 'width' || item.prop === 'height' || item.prop === 'depth' || item.prop === 'fingerSize') {
                        currentDisplayVal = Math.round(currentDisplayVal);
                    } else {
                        currentDisplayVal = Math.round(currentDisplayVal * 10) / 10;
                    }
                } else {
                    currentDisplayVal = Math.round(currentDisplayVal * 100) / 100;
                }
                
                item.slider.value = currentDisplayVal;
                item.num.value = currentDisplayVal;
            });
            
            // Convert thickness
            const tLim = lim.thickness;
            els.thicknessNum.min = tLim.min;
            els.thicknessNum.max = tLim.max;
            els.thicknessNum.step = tLim.step;
            els.thicknessUnit.textContent = newUnit;
            
            let displayT = state.thickness * factor;
            els.thicknessNum.value = (newUnit === 'in') ? displayT.toFixed(3) : fmtTrim(displayT, 3);
            
            updateThicknessDropdownOptions();
            
            // Convert notch diameter display units
            els.notchDiameterUnit.textContent = newUnit;
            if (newUnit === 'in') {
                els.notchDiameterNum.value = ((state.notchDiameter / 2) / MM_PER_INCH).toFixed(3);
                els.notchDiameterNum.step = '0.005';
            } else {
                els.notchDiameterNum.value = (state.notchDiameter / 2).toFixed(1);
                els.notchDiameterNum.step = '0.1';
            }
            
            // Convert kerf display units
            els.kerfUnit.textContent = newUnit;
            if (newUnit === 'in') {
                els.kerfNum.value = (state.kerf / MM_PER_INCH).toFixed(3);
                els.kerfNum.step = '0.001';
            } else {
                els.kerfNum.value = state.kerf.toFixed(2);
                els.kerfNum.step = '0.01';
            }
            
            updateAll();
        }

        function updateAll() {
            validateState();
            if (state.dividers) renderDividerControls();
            renderRemovableLidControls();
            renderSlideLidControls();
            renderDoorLidControls();
            renderTwoDoorLidControls();
            renderAdjustableLidHandleControls();
            renderBottomLiftControls();
            validateState();
            updateSummary();
            updateBox3D();
        }

        function syncFingerSliderRange() {
            const { t, W_int, H_int, D_int } = getResolvedBoxDimensions();

            const range = fingerRange(W_int, H_int, D_int, t);
            const slideLid = ensureSlideLidState();
            const slideConstraints = slideLid.enabled ? getSlideLidConstraints(t) : null;
            
            // Convert range to display units (halved for UI display)
            const factor = (state.unit === 'in') ? (1 / MM_PER_INCH) : 1;
            const minFinger = slideConstraints ? Math.max(range.min, slideConstraints.fingerMin) : range.min;
            const rawMinDisplay = (minFinger / 2) * factor;
            const rawMaxDisplay = (range.max / 2) * factor;

            // The slider's step is fixed (1 for mm, see HTML), but rawMinDisplay/rawMaxDisplay
            // come from a continuous binary search and rarely land on exact step boundaries.
            // A <input type="range"> computes its reachable stops as min + n*step; if max isn't
            // one of those stops, the browser silently caps the slider at the highest reachable
            // stop BELOW max (not at max itself). E.g. min=1.5, max=15.42, step=1 -> stops are
            // 1.5, 2.5, ..., 14.5 - so the slider can never actually reach past 14.5, which then
            // displays as 14 once rounded. Rounding min UP and max DOWN to the display step here
            // guarantees max itself is a reachable, exact stop, so "drag to the end" and
            // "programmatically set to max" agree and both show the true achievable maximum.
            const stepDisplay = (state.unit === 'in') ? 0.01 : 1;
            const minDisplay = Math.ceil(rawMinDisplay / stepDisplay) * stepDisplay;
            const maxDisplay = Math.max(minDisplay, Math.floor((rawMaxDisplay + 1e-7) / stepDisplay) * stepDisplay);
            
            els.fingerSizeInput.min = minDisplay;
            els.fingerSizeInput.max = maxDisplay;
            els.fingerSizeInput.step = stepDisplay;
            els.fingerSizeNum.min = minDisplay;
            els.fingerSizeNum.max = maxDisplay;
            els.fingerSizeNum.step = stepDisplay;
            
            // Clamp current fingerSize using the same rounded bounds the UI now exposes, so the
            // internal state can never exceed what the slider is actually able to display/reach.
            const minInternal = minDisplay * 2 / factor;
            const maxInternal = maxDisplay * 2 / factor;
            let f = state.fingerSize;
            if (f < minInternal) f = minInternal;
            if (f > maxInternal) f = maxInternal;
            state.fingerSize = f;
            
            let displayF = (f / 2) * factor;
            els.fingerSizeInput.value = displayF;
            els.fingerSizeNum.value = (state.unit === 'in') ? displayF.toFixed(2) : Math.round(displayF);
        }

        function validateState() {
            if (!Number.isFinite(state.thickness)) state.thickness = 3.0;
            state.thickness = Math.max(1.0, Math.min(MAX_THICKNESS_MM, state.thickness));
            const t = state.thickness;
            const lid = ensureRemovableLidState();
            const slideLid = ensureSlideLidState();
            const doorLid = ensureDoorLidState();
            const twoDoorLid = ensureTwoDoorLidState();
            if (twoDoorLid.enabled) {
                lid.enabled = false;
                lid.open = false;
                lid.openProgress = 0;
                slideLid.enabled = false;
                slideLid.open = false;
                slideLid.openProgress = 0;
                doorLid.enabled = false;
                doorLid.open = false;
                doorLid.openProgress = 0;
            }
            if (lid.enabled && slideLid.enabled) {
                slideLid.enabled = false;
                slideLid.open = false;
                slideLid.openProgress = 0;
            }
            if (lid.enabled && doorLid.enabled) {
                doorLid.enabled = false;
                doorLid.open = false;
                doorLid.openProgress = 0;
            }
            if (slideLid.enabled && doorLid.enabled) {
                doorLid.enabled = false;
                doorLid.open = false;
                doorLid.openProgress = 0;
            }
            if ((state.boxType === 'closed' || lid.enabled || slideLid.enabled || doorLid.enabled || twoDoorLid.enabled) && state.dividers) state.dividers.addSideSlots = false;
            if (state.boxType === 'closed') {
                lid.enabled = false;
                lid.open = false;
                lid.openProgress = 0;
                slideLid.enabled = false;
                slideLid.open = false;
                slideLid.openProgress = 0;
                doorLid.enabled = false;
                doorLid.open = false;
                doorLid.openProgress = 0;
                twoDoorLid.enabled = false;
                twoDoorLid.open = false;
                twoDoorLid.openProgress = 0;
            }
            const lidSizingDimensions = getResolvedBoxDimensions();
            if (doorLid.enabled && !Number.isFinite(doorLid.handleSize)) {
                doorLid.handleSize = Math.max(4 * t, lidSizingDimensions.D_ext / 3);
            }
            if (twoDoorLid.enabled && !Number.isFinite(twoDoorLid.handleSize)) {
                twoDoorLid.handleSize = Math.max(4 * t, lidSizingDimensions.D_ext / 3);
            }
            if (!Number.isFinite(state.bottomLift)) state.bottomLift = 0;
            state.bottomLift = Math.max(0, state.bottomLift);
            state.bottomLift = Math.min(state.bottomLift, getMaxBottomLift(getResolvedBoxDimensions()));
            ensureRemovableLidHandleFits();
            
            // 1. Calculate minimum allowed dimensions based on thickness to guarantee n >= 3 with absolute min finger size (3mm)
            const minIntDim = getAbsoluteMinDimension(t);
            const isOpen = state.boxType === 'open';
            const hWall = isOpen ? t : 2 * t;
            const lidHeightInset = getLidInternalHeightInset(t, isOpen);
            const dimensionStepMm = state.unit === 'in' ? MM_PER_INCH * 0.1 : 1;
            const snapMinimum = value => Math.ceil((value - 1e-9) / dimensionStepMm) * dimensionStepMm;
            const slideConstraints = slideLid.enabled ? getSlideLidConstraints(t) : null;
            const doorConstraints = doorLid.enabled ? getDoorLidConstraints(t) : null;
            const twoDoorConstraints = twoDoorLid.enabled ? getTwoDoorLidConstraints(t) : null;
            const removableConstraints = lid.enabled && lid.addHandle ? getRemovableLidConstraints(t) : null;
            const minInternalWidth = Math.max(
                minIntDim,
                removableConstraints ? removableConstraints.minInternalWidth : 0,
                slideConstraints ? slideConstraints.minInternalWidth : 0,
                doorConstraints ? doorConstraints.minInternalWidth : 0,
                twoDoorConstraints ? twoDoorConstraints.minInternalWidth : 0
            );
            const minInternalHeight = Math.max(
                minIntDim,
                removableConstraints ? removableConstraints.minInternalHeight : 0,
                slideConstraints ? slideConstraints.minInternalHeight : 0,
                doorConstraints ? doorConstraints.minInternalHeight : 0,
                twoDoorConstraints ? twoDoorConstraints.minInternalHeight : 0
            );
            const minInternalDepth = Math.max(
                minIntDim,
                removableConstraints ? removableConstraints.minInternalDepth : 0,
                slideConstraints ? slideConstraints.minInternalDepth : 0,
                doorConstraints ? doorConstraints.minInternalDepth : 0,
                twoDoorConstraints ? twoDoorConstraints.minInternalDepth : 0
            );
            const minAllowedWidth = snapMinimum(state.dimType === 'external' ? minInternalWidth + 2 * t : minInternalWidth);
            const minAllowedHeight = snapMinimum(
                state.dimType === 'external' ? minInternalHeight + hWall + lidHeightInset : minInternalHeight
            );
            const minAllowedDepth = snapMinimum(state.dimType === 'external' ? minInternalDepth + 2 * t : minInternalDepth);

            // Clamp state dimensions
            if (state.width < minAllowedWidth) state.width = minAllowedWidth;
            if (state.height < minAllowedHeight) state.height = minAllowedHeight;
            if (state.depth < minAllowedDepth) state.depth = minAllowedDepth;

            // Update min attributes for HTML inputs
            const factor = (state.unit === 'in') ? (1 / MM_PER_INCH) : 1;
            const displayMinWidth = minAllowedWidth * factor;
            const displayMinHeight = minAllowedHeight * factor;

            els.widthInput.min = displayMinWidth;
            els.widthNum.min = displayMinWidth;
            els.heightInput.min = displayMinHeight;
            els.heightNum.min = displayMinHeight;
            els.depthInput.min = minAllowedDepth * factor;
            els.depthNum.min = minAllowedDepth * factor;
            
            // Update inputs display values if they were clamped
            // (Only override if the display value is out of sync with state to avoid cursor jumping)
            const curW = parseFloat(els.widthNum.value);
            const curH = parseFloat(els.heightNum.value);
            const curD = parseFloat(els.depthNum.value);
            
            const targetW = state.width * factor;
            const targetH = state.height * factor;
            const targetD = state.depth * factor;
            
            const tol = 1e-4;
            if (Math.abs(curW - targetW) > tol || curW < displayMinWidth) {
                els.widthInput.value = targetW;
                els.widthNum.value = (state.unit === 'in') ? targetW.toFixed(2) : Math.round(targetW);
            }
            if (Math.abs(curH - targetH) > tol || curH < displayMinHeight) {
                els.heightInput.value = targetH;
                els.heightNum.value = (state.unit === 'in') ? targetH.toFixed(2) : Math.round(targetH);
            }
            if (Math.abs(curD - targetD) > tol || curD < minAllowedDepth * factor) {
                els.depthInput.value = targetD;
                els.depthNum.value = (state.unit === 'in') ? targetD.toFixed(2) : Math.round(targetD);
            }

            // 2. Validate thickness independently from the box dimensions.
            // Width, height, depth, box type and dimension mode must NEVER modify
            // the selected material thickness. The value changes only when the user
            // edits Material Thickness or selects a thickness preset.
            // Sync thickness display input field
            const displayT = state.thickness * factor;
            const curT = parseFloat(els.thicknessNum.value);
            if (isNaN(curT) || Math.abs(curT - displayT) > 1e-4) {
                els.thicknessNum.value = (state.unit === 'in') ? displayT.toFixed(3) : fmtTrim(displayT, 3);
            }

            
            
            syncFingerSliderRange();

            // 3. Validate notch diameter (maximum half of thickness)
            let maxDiameter = state.thickness / 2;
            if (state.notchDiameter > maxDiameter) {
                state.notchDiameter = maxDiameter;
            }
            // Update input display
            const notchFactor = (state.unit === 'in') ? (1 / MM_PER_INCH) : 1;
            const displayNotch = (state.notchDiameter / 2) * notchFactor;
            els.notchDiameterNum.value = (state.unit === 'in') ? displayNotch.toFixed(3) : displayNotch.toFixed(1);

            // 4. Validate kerf (absolute value strictly less than thickness / 2)
            // The safety margin below the strict limit needs to be expressed in the same space
            // it's subtracted in (mm, since state.kerf/state.thickness are always mm internally).
            // Previously the margin was a raw display-unit constant (0.001 for inches) applied
            // directly to the mm-space limit, which in inch mode is ~0.00004in - far smaller
            // than the field's own 3-decimal display precision, so the displayed "limit" rounded
            // to the same value as the true (disallowed) maximum. Converting the intended
            // display-space margin through `factor` keeps a real, visible gap in both units.
            let maxAbsKerf = state.thickness / 2;
            const kerfMarginDisplay = (state.unit === 'in') ? 0.001 : 0.01;
            let limitKerf = maxAbsKerf - (kerfMarginDisplay / factor);
            if (Math.abs(state.kerf) >= maxAbsKerf) {
                state.kerf = Math.sign(state.kerf) * limitKerf;
            }
            // Update input display
            const displayKerf = state.kerf * factor;
            const curKerf = parseFloat(els.kerfNum.value);
            if (isNaN(curKerf) || Math.abs(curKerf - displayKerf) > 1e-4) {
                els.kerfNum.value = (state.unit === 'in') ? displayKerf.toFixed(3) : displayKerf.toFixed(2);
            }
        }

        function updateSummary() {
            const { t, W_ext, H_ext, D_ext, W_int, H_int, H_usable, D_int } = getResolvedBoxDimensions();

            const volumeLiters = (W_int * H_usable * D_int) / 1000000;
            const factor = (state.unit === 'in') ? (1 / MM_PER_INCH) : 1;
            const unitLabel = state.unit;
            const dec = (state.unit === 'in') ? 2 : 1;

            // Format each dimension independently: keep up to `dec` decimal places, but drop
            // a trailing ".0" (or ".00" for inches) when a given number happens to be a whole
            // number, rather than forcing every number in the triple to share one decimal style.
            const fmtDim = (v) => fmtTrim(v, dec);

            if (state.unit === 'in') {
                const volCubicIn = volumeLiters * 61.0237;
                els.sumVolume.textContent = `${volCubicIn.toFixed(1)} cu in`;
            } else {
                els.sumVolume.textContent = `${volumeLiters.toFixed(2)} L`;
            }

            els.sumOuter.textContent = `${fmtDim(W_ext * factor)} x ${fmtDim(H_ext * factor)} x ${fmtDim(D_ext * factor)} ${unitLabel}`;
            els.sumInner.textContent = `${fmtDim(W_int * factor)} x ${fmtDim(H_usable * factor)} x ${fmtDim(D_int * factor)} ${unitLabel}`;

            // Check if joints are invalid on any axis (should be always false now)
            const layW = fingerLayout(W_int, state.fingerSize, t);
            const layH = fingerLayout(H_int, state.fingerSize, t);
            const layD = fingerLayout(D_int, state.fingerSize, t);
            const isInvalid = !layW || layW.n < 3 || !layH || layH.n < 3 || !layD || layD.n < 3;

            if (isInvalid) {
                els.sumWarning.style.display = 'flex';
            } else {
                els.sumWarning.style.display = 'none';
            }
            panelGroup.visible = true;
        }

(function () {
  const app = document.getElementById('box-designer-app');
  if (!app) return;

  function fitBoxDesignerToViewport() {
    const viewportHeight = window.visualViewport
      ? Math.round(window.visualViewport.height)
      : window.innerHeight;

    const compactLayout = window.matchMedia('(max-width: 749px), (max-height: 560px) and (orientation: landscape)').matches;

    app.style.width = '100%';
    app.style.margin = '0';
    app.style.setProperty(
      '--vp-generator-height',
      (compactLayout ? Math.max(320, viewportHeight) : Math.max(620, viewportHeight)) + 'px'
    );

    if (typeof window.onWindowResize === 'function') {
      window.requestAnimationFrame(window.onWindowResize);
    }
  }

  window.addEventListener('load', fitBoxDesignerToViewport, { once: true });
  window.addEventListener('resize', fitBoxDesignerToViewport);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fitBoxDesignerToViewport);
  }
  window.requestAnimationFrame(fitBoxDesignerToViewport);
})();
